{
  "level": "dm01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:dm01",
    "objects": "AREAS.E3:dm01.e3",
    "mesh": "TREES.E3:dm01.e3"
  },
  "spawn_point": {
    "position": [
      2066.6321711472847,
      -68.54527167788811,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      2066.6321711472847,
      31.45472832211189,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -6158.31884765625,
      -3619.1005859375,
      -300.0
    ],
    "bbox_max": [
      5927.2158203125,
      7450.0,
      1754.5804443359375
    ],
    "vertex_count": 2477,
    "vertices": [
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -5545.388671875,
        4741.15380859375,
        334.12225341796875
      ],
      [
        -6158.31884765625,
        3750.8916015625,
        976.300048828125
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.8644714355469
      ],
      [
        -5504.7001953125,
        4729.1015625,
        -22.699951171875
      ],
      [
        -3697.7392578125,
        -2384.4521484375,
        1181.5667724609375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.9832763671875
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755867958068848
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -4205.00048828125,
        -2619.4462890625,
        1400.274658203125
      ],
      [
        -4142.94921875,
        -2642.46435546875,
        1224.0418701171875
      ],
      [
        -4141.17578125,
        -2643.59130859375,
        1220.0
      ],
      [
        -4142.94921875,
        -2642.46435546875,
        1224.0418701171875
      ],
      [
        -3790.39453125,
        -2416.412353515625,
        1220.0
      ],
      [
        -3902.9365234375,
        -2462.454833984375,
        1267.6805419921875
      ],
      [
        -4205.05908203125,
        -2619.064208984375,
        1400.243408203125
      ],
      [
        -3902.9365234375,
        -2462.454833984375,
        1267.6805419921875
      ],
      [
        -3502.183349609375,
        -3576.798583984375,
        1274.598876953125
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755615234375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.983154296875
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -5704.54443359375,
        4430.01318359375,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.0498046875,
        901.1133422851562
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.839163780212402
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.864501953125
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.83917236328125
      ],
      [
        -5158.470703125,
        5234.39599609375,
        -22.699951171875
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.77490234375
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.7749633789062
      ],
      [
        -4901.68505859375,
        5405.974609375,
        546.6459350585938
      ],
      [
        -4485.7236328125,
        5683.9111328125,
        -0.000568389892578125
      ],
      [
        -4478.6357421875,
        5688.64697265625,
        -22.699951171875
      ],
      [
        -3344.00830078125,
        -2413.83203125,
        -300.0
      ],
      [
        -3861.63232421875,
        2261.417236328125,
        -300.0
      ],
      [
        -4468.451171875,
        5695.4521484375,
        -22.699951171875
      ],
      [
        -2916.739501953125,
        3191.2431640625,
        124.09432983398438
      ],
      [
        -2650.5576171875,
        3351.36181640625,
        4.240765571594238
      ],
      [
        -2916.739501953125,
        3191.2431640625,
        124.09432983398438
      ],
      [
        -3662.5791015625,
        6233.91845703125,
        -22.699951171875
      ],
      [
        -2638.939453125,
        3351.18505859375,
        0.0
      ],
      [
        -2650.5576171875,
        3351.36181640625,
        4.2407684326171875
      ],
      [
        -2638.939453125,
        3351.18505859375,
        0.0
      ],
      [
        -2609.847900390625,
        3350.7421875,
        -10.6187744140625
      ],
      [
        -2501.9697265625,
        3265.2880859375,
        -300.0
      ],
      [
        -1106.3011474609375,
        -1988.5577392578125,
        175.4827117919922
      ],
      [
        -232.08837890625,
        -3040.7861328125,
        0.0
      ],
      [
        -3058.93505859375,
        -3479.345703125,
        1098.404052734375
      ],
      [
        -3009.681640625,
        -3300.58642578125,
        1055.6116943359375
      ],
      [
        -3058.93505859375,
        -3479.345703125,
        1098.404052734375
      ],
      [
        -3123.772216796875,
        -3589.257568359375,
        1137.4005126953125
      ],
      [
        -3714.02197265625,
        -2323.558349609375,
        1179.126708984375
      ],
      [
        -3605.181640625,
        -2269.120849609375,
        0.0
      ],
      [
        -3605.1806640625,
        -2269.11083984375,
        -0.022125244140625
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -2981.017578125,
        -3196.55322265625,
        1030.7076416015625
      ],
      [
        -2981.017578125,
        -3196.55322265625,
        1030.70751953125
      ],
      [
        -3070.88916015625,
        -3126.308349609375,
        1053.9906005859375
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -3070.88916015625,
        -3126.308349609375,
        1053.9906005859375
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -2291.78076171875,
        -858.0988159179688,
        0.0
      ],
      [
        -2293.0390625,
        -976.3355712890625,
        -300.0
      ],
      [
        -2285.501953125,
        -795.498779296875,
        100.0
      ],
      [
        -2291.78076171875,
        -858.0986938476562,
        0.0
      ],
      [
        -2134.996337890625,
        -761.4859619140625,
        0.0
      ],
      [
        -2075.04833984375,
        -842.006591796875,
        -300.0
      ],
      [
        -2165.771240234375,
        -721.718994140625,
        100.0
      ],
      [
        -2134.99658203125,
        -761.4859619140625,
        0.0
      ],
      [
        -1877.876708984375,
        1330.0,
        0.0
      ],
      [
        -1846.306884765625,
        1326.306884765625,
        -11.079254150390625
      ],
      [
        -1817.047119140625,
        3338.672607421875,
        -300.0
      ],
      [
        -1807.8961181640625,
        2057.896240234375,
        -126.31155395507812
      ],
      [
        -1846.306884765625,
        1326.306884765625,
        -11.07925033569336
      ],
      [
        -1445.5028076171875,
        2015.5028076171875,
        -253.49160766601562
      ],
      [
        -1807.8961181640625,
        2057.896240234375,
        -126.31155395507812
      ],
      [
        -1430.0,
        2310.7763671875,
        -300.0
      ],
      [
        -1445.5028076171875,
        2015.5028076171875,
        -253.49160766601562
      ],
      [
        -1425.26611328125,
        127.9840087890625,
        0.0
      ],
      [
        -1508.86181640625,
        750.1992797851562,
        -55.32252502441406
      ],
      [
        -1609.5274658203125,
        -106.07270812988281,
        100.0
      ],
      [
        -1420.4962158203125,
        86.82951354980469,
        3.937878131866455
      ],
      [
        -1425.26611328125,
        127.98397827148438,
        0.0
      ],
      [
        -1420.4962158203125,
        86.82951354980469,
        3.9378738403320312
      ],
      [
        -574.30859375,
        -1453.12939453125,
        -93.83500671386719
      ],
      [
        -826.1360473632812,
        -1463.14990234375,
        0.0
      ],
      [
        -1106.3011474609375,
        -1988.557861328125,
        175.482666015625
      ],
      [
        -1122.9091796875,
        -1954.8729248046875,
        176.92333984375
      ],
      [
        -972.0233154296875,
        -1507.5772705078125,
        59.69889450073242
      ],
      [
        -826.1360473632812,
        -1463.14990234375,
        0.0
      ],
      [
        5927.2158203125,
        -2266.7119140625,
        1754.5804443359375
      ],
      [
        -3739.031005859375,
        -2337.456298828125,
        1302.89013671875
      ],
      [
        -4335.10791015625,
        -1741.9742431640625,
        1326.741943359375
      ],
      [
        -4249.04541015625,
        -1729.944580078125,
        1312.97021484375
      ],
      [
        -3739.003173828125,
        -2337.489013671875,
        1302.8876953125
      ],
      [
        -3737.88525390625,
        -2338.66650390625,
        1297.6898193359375
      ],
      [
        -3241.3125,
        -3614.116455078125,
        1365.1121826171875
      ],
      [
        -3174.448974609375,
        -3482.3193359375,
        1341.5086669921875
      ],
      [
        -2988.559814453125,
        -3223.927001953125,
        1037.260498046875
      ],
      [
        -3312.805908203125,
        -3609.272216796875,
        1374.989013671875
      ],
      [
        -3610.738525390625,
        -3619.1005859375,
        1419.3116455078125
      ],
      [
        -3737.88525390625,
        -2338.66650390625,
        1297.6898193359375
      ],
      [
        -3700.05908203125,
        -2380.29833984375,
        1181.84423828125
      ],
      [
        -3237.596435546875,
        -3606.79150390625,
        1363.8004150390625
      ],
      [
        -3896.85986328125,
        -1680.7169189453125,
        1256.61328125
      ],
      [
        -3896.85986328125,
        -1680.7169189453125,
        1256.61328125
      ],
      [
        -3913.255859375,
        -1579.0008544921875,
        1149.344970703125
      ],
      [
        -3725.157958984375,
        -2329.201904296875,
        1299.860595703125
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -3725.157958984375,
        -2329.20166015625,
        1299.860595703125
      ],
      [
        -3725.188232421875,
        -2329.143798828125,
        1299.9984130859375
      ],
      [
        -3725.188720703125,
        -2329.142822265625,
        1300.001953125
      ],
      [
        -3725.188232421875,
        -2329.143798828125,
        1299.9984130859375
      ],
      [
        1800.1434326171875,
        -2555.390869140625,
        1572.4954833984375
      ],
      [
        3250.0,
        -1320.0,
        530.88134765625
      ],
      [
        3250.0,
        -1299.96044921875,
        500.0
      ],
      [
        3250.0,
        -1299.96044921875,
        500.0
      ],
      [
        3250.0,
        -975.499755859375,
        0.0
      ],
      [
        1434.5760498046875,
        -2215.102783203125,
        766.9312744140625
      ],
      [
        1403.8707275390625,
        -2424.779052734375,
        1103.106201171875
      ],
      [
        1403.8707275390625,
        -2424.779052734375,
        1103.106201171875
      ],
      [
        1576.1258544921875,
        -2220.202880859375,
        890.980224609375
      ],
      [
        1576.1258544921875,
        -2220.202880859375,
        890.980224609375
      ],
      [
        1559.090576171875,
        -2087.84912109375,
        649.1223754882812
      ],
      [
        1455.689697265625,
        -2200.6474609375,
        759.22412109375
      ],
      [
        1532.6546630859375,
        -2066.196533203125,
        590.2977294921875
      ],
      [
        1434.5760498046875,
        -2215.102783203125,
        766.9312744140625
      ],
      [
        1455.689697265625,
        -2200.6474609375,
        759.22412109375
      ],
      [
        1532.6546630859375,
        -2066.196533203125,
        590.2977294921875
      ],
      [
        1559.090576171875,
        -2087.84912109375,
        649.1223754882812
      ],
      [
        1800.1434326171875,
        -2555.390869140625,
        1572.4954833984375
      ],
      [
        1730.608154296875,
        -2722.79443359375,
        1715.5628662109375
      ],
      [
        1840.1190185546875,
        -2424.16015625,
        1457.2762451171875
      ],
      [
        2056.82666015625,
        -2294.947998046875,
        1411.166015625
      ],
      [
        2056.82666015625,
        -2294.947998046875,
        1411.166015625
      ],
      [
        1840.1190185546875,
        -2424.16015625,
        1457.2762451171875
      ],
      [
        1566.6243896484375,
        -2746.42431640625,
        1703.235595703125
      ],
      [
        1582.067138671875,
        -2623.69189453125,
        1590.8487548828125
      ],
      [
        1390.5198974609375,
        -2771.800537109375,
        1689.9971923828125
      ],
      [
        652.3189697265625,
        -2032.2076416015625,
        372.62445068359375
      ],
      [
        523.5577392578125,
        -2027.1854248046875,
        406.21435546875
      ],
      [
        523.5578002929688,
        -2027.1854248046875,
        406.21435546875
      ],
      [
        613.3744506835938,
        -1977.294677734375,
        241.88168334960938
      ],
      [
        -230.2316131591797,
        -2250.73291015625,
        963.2825927734375
      ],
      [
        -297.9383544921875,
        -2218.353515625,
        853.432373046875
      ],
      [
        -343.742919921875,
        -2201.4208984375,
        793.9291381835938
      ],
      [
        -297.9383544921875,
        -2218.353515625,
        853.432373046875
      ],
      [
        -105.23480224609375,
        -2282.868408203125,
        1128.5198974609375
      ],
      [
        477.5794372558594,
        -1882.072509765625,
        40.0
      ],
      [
        187.95449829101562,
        -1970.4027099609375,
        378.46026611328125
      ],
      [
        144.47817993164062,
        -2032.7874755859375,
        558.9051513671875
      ],
      [
        9.466850280761719,
        -2016.822265625,
        542.2777709960938
      ],
      [
        55.927490234375,
        -2010.6688232421875,
        532.7501831054688
      ],
      [
        157.5995330810547,
        -1981.1533203125,
        417.8730163574219
      ],
      [
        193.2102508544922,
        -2044.9600830078125,
        573.2991943359375
      ],
      [
        187.95449829101562,
        -1970.4027099609375,
        378.46026611328125
      ],
      [
        159.94473266601562,
        -1979.0865478515625,
        411.5660095214844
      ],
      [
        159.94473266601562,
        -1979.0865478515625,
        411.5660095214844
      ],
      [
        157.5995330810547,
        -1981.1533203125,
        417.8730163574219
      ],
      [
        144.47817993164062,
        -2032.7874755859375,
        558.9051513671875
      ],
      [
        150.12738037109375,
        -1981.939453125,
        422.6660461425781
      ],
      [
        9.466842651367188,
        -2016.822265625,
        542.2777709960938
      ],
      [
        -130.58880615234375,
        -2051.26220703125,
        659.73876953125
      ],
      [
        195.37515258789062,
        -2048.839111328125,
        582.7481079101562
      ],
      [
        151.15245056152344,
        -1978.9119873046875,
        414.3038024902344
      ],
      [
        161.7598419189453,
        -1861.9788818359375,
        101.8683853149414
      ],
      [
        33.036468505859375,
        -2004.950927734375,
        525.9889526367188
      ],
      [
        -139.63284301757812,
        -2038.0533447265625,
        676.1594848632812
      ],
      [
        150.375732421875,
        -1979.7041015625,
        416.67681884765625
      ],
      [
        151.15245056152344,
        -1978.9119873046875,
        414.3038024902344
      ],
      [
        150.375732421875,
        -1979.7041015625,
        416.67681884765625
      ],
      [
        33.03648376464844,
        -2004.950927734375,
        525.9889526367188
      ],
      [
        522.1129760742188,
        -2053.81787109375,
        536.96875
      ],
      [
        578.0938720703125,
        -1894.3131103515625,
        149.16845703125
      ],
      [
        432.7499694824219,
        -1936.2689208984375,
        304.911376953125
      ],
      [
        432.7499694824219,
        -1936.2689208984375,
        304.911376953125
      ],
      [
        331.8439636230469,
        -1995.29541015625,
        481.4112854003906
      ],
      [
        294.6082458496094,
        -1997.4903564453125,
        484.38848876953125
      ],
      [
        668.7681884765625,
        -2029.1787109375,
        420.2882080078125
      ],
      [
        522.1129760742188,
        -2053.81787109375,
        536.96875
      ],
      [
        483.63604736328125,
        -2021.267333984375,
        478.35906982421875
      ],
      [
        615.4124755859375,
        -1939.4237060546875,
        236.97860717773438
      ],
      [
        294.6082458496094,
        -1997.4903564453125,
        484.38848876953125
      ],
      [
        178.13218688964844,
        -2017.943359375,
        507.4896240234375
      ],
      [
        457.285888671875,
        -2033.87841796875,
        518.03955078125
      ],
      [
        483.6360168457031,
        -2021.267333984375,
        478.35906982421875
      ],
      [
        149.41319274902344,
        -1988.3677978515625,
        439.8896484375
      ],
      [
        146.86245727539062,
        -2011.3267822265625,
        501.404541015625
      ],
      [
        144.81361389160156,
        -2006.3203125,
        496.3652038574219
      ],
      [
        150.10540771484375,
        -1982.13720703125,
        423.1958312988281
      ],
      [
        140.13160705566406,
        -1994.8795166015625,
        484.849365234375
      ],
      [
        150.12738037109375,
        -1981.939453125,
        422.666015625
      ],
      [
        139.7273712158203,
        -1993.8917236328125,
        483.8551330566406
      ],
      [
        322.42205810546875,
        -2000.806884765625,
        497.8916320800781
      ],
      [
        320.817626953125,
        -2031.52685546875,
        568.8048095703125
      ],
      [
        432.3751220703125,
        -2045.800537109375,
        555.552490234375
      ],
      [
        322.42205810546875,
        -2000.806884765625,
        497.8916320800781
      ],
      [
        134.14306640625,
        -2000.3094482421875,
        516.710693359375
      ],
      [
        55.927490234375,
        -2010.6688232421875,
        532.7501831054688
      ],
      [
        134.14306640625,
        -2000.3094482421875,
        516.710693359375
      ],
      [
        139.89356994628906,
        -1921.7484130859375,
        392.18572998046875
      ],
      [
        144.45294189453125,
        -1819.39990234375,
        156.24981689453125
      ],
      [
        98.37858581542969,
        -1956.846435546875,
        489.53021240234375
      ],
      [
        -147.2863311767578,
        -2026.8753662109375,
        690.055419921875
      ],
      [
        -54.7576904296875,
        -1987.2689208984375,
        622.1032104492188
      ],
      [
        139.89356994628906,
        -1921.7484130859375,
        392.18572998046875
      ],
      [
        120.0771713256836,
        -1946.175537109375,
        456.20025634765625
      ],
      [
        120.0771713256836,
        -1946.175537109375,
        456.20025634765625
      ],
      [
        98.37860107421875,
        -1956.846435546875,
        489.53021240234375
      ],
      [
        149.80160522460938,
        -1982.3138427734375,
        424.58270263671875
      ],
      [
        -160.07855224609375,
        -2008.1922607421875,
        713.281494140625
      ],
      [
        -411.6618347167969,
        -1906.3961181640625,
        856.7205810546875
      ],
      [
        -646.1893920898438,
        -1744.5482177734375,
        476.2290344238281
      ],
      [
        -806.4102172851562,
        -1679.137939453125,
        327.972900390625
      ],
      [
        -646.1893920898438,
        -1744.5482177734375,
        476.2290344238281
      ],
      [
        488.231689453125,
        -1986.0767822265625,
        468.9074401855469
      ],
      [
        331.8439636230469,
        -1995.29541015625,
        481.41131591796875
      ],
      [
        470.0345458984375,
        -2019.2509765625,
        502.93902587890625
      ],
      [
        488.231689453125,
        -1986.0767822265625,
        468.90740966796875
      ],
      [
        470.0345458984375,
        -2019.2509765625,
        502.93902587890625
      ],
      [
        457.285888671875,
        -2033.87841796875,
        518.03955078125
      ],
      [
        653.73876953125,
        -1929.87255859375,
        337.94281005859375
      ],
      [
        672.576171875,
        -1902.1815185546875,
        262.71795654296875
      ],
      [
        675.7745971679688,
        -1886.8873291015625,
        227.15101623535156
      ],
      [
        587.3562622070312,
        -1845.9871826171875,
        212.5220184326172
      ],
      [
        675.7745971679688,
        -1886.8873291015625,
        227.1510009765625
      ],
      [
        672.576171875,
        -1902.1815185546875,
        262.71795654296875
      ],
      [
        697.9500732421875,
        -2023.6024169921875,
        502.95013427734375
      ],
      [
        697.4531860351562,
        -2023.484130859375,
        503.1079406738281
      ],
      [
        697.9500732421875,
        -2023.6024169921875,
        502.95013427734375
      ],
      [
        100.568115234375,
        -1701.48583984375,
        305.5911865234375
      ],
      [
        99.1569595336914,
        -1701.12841796875,
        305.9931335449219
      ],
      [
        -821.9474487304688,
        -1660.6412353515625,
        299.7167053222656
      ],
      [
        -642.1290893554688,
        -1737.6475830078125,
        470.2127685546875
      ],
      [
        -642.1290893554688,
        -1737.6475830078125,
        470.2127685546875
      ],
      [
        96.1108627319336,
        -1700.3289794921875,
        306.8011474609375
      ],
      [
        -313.9794921875,
        -1569.0054931640625,
        364.56988525390625
      ],
      [
        -635.583740234375,
        -1726.5235595703125,
        460.51434326171875
      ],
      [
        -647.9402465820312,
        -1735.158935546875,
        464.702880859375
      ],
      [
        -964.95458984375,
        -1505.424560546875,
        56.806270599365234
      ],
      [
        -428.72601318359375,
        -1708.9281005859375,
        404.3449401855469
      ],
      [
        -484.49310302734375,
        -1727.7908935546875,
        430.0713195800781
      ],
      [
        96.76602172851562,
        -1700.522705078125,
        306.6741943359375
      ],
      [
        96.76602172851562,
        -1700.522705078125,
        306.6742248535156
      ],
      [
        96.11085510253906,
        -1700.3289794921875,
        306.8011474609375
      ],
      [
        -635.583740234375,
        -1726.5235595703125,
        460.51434326171875
      ],
      [
        1623.89599609375,
        -2591.348876953125,
        1569.1973876953125
      ],
      [
        1113.77197265625,
        -2188.97314453125,
        695.4226684570312
      ],
      [
        1042.72265625,
        -2406.2001953125,
        1040.1240234375
      ],
      [
        1305.8316650390625,
        -2095.705810546875,
        654.6503295898438
      ],
      [
        1509.7012939453125,
        -1835.5224609375,
        320.61444091796875
      ],
      [
        1113.77197265625,
        -2188.97314453125,
        695.4226684570312
      ],
      [
        1305.8316650390625,
        -2095.705810546875,
        654.6503295898438
      ],
      [
        1774.060791015625,
        -972.6520385742188,
        125.2774658203125
      ],
      [
        870.5986938476562,
        -898.3851318359375,
        90.2027587890625
      ],
      [
        828.953369140625,
        -828.3515625,
        -14.0616455078125
      ],
      [
        1306.3896484375,
        -864.695068359375,
        0.0
      ],
      [
        1428.725830078125,
        -1549.0518798828125,
        185.03347778320312
      ],
      [
        828.953369140625,
        -828.3515625,
        -81.63313293457031
      ],
      [
        294.52099609375,
        -895.45068359375,
        -130.42694091796875
      ],
      [
        1391.9840087890625,
        -871.2106323242188,
        0.0
      ],
      [
        1523.38525390625,
        -895.1607666015625,
        22.764751434326172
      ],
      [
        1868.885986328125,
        -1248.1983642578125,
        159.84056091308594
      ],
      [
        1887.05859375,
        -1232.1240234375,
        157.82789611816406
      ],
      [
        1868.885986328125,
        -1248.1983642578125,
        159.840576171875
      ],
      [
        1922.0,
        -1006.04296875,
        102.0
      ],
      [
        1926.1201171875,
        -1020.5,
        106.36253356933594
      ],
      [
        1881.3929443359375,
        -1301.60009765625,
        168.17079162597656
      ],
      [
        1885.8992919921875,
        -1294.244873046875,
        167.4111328125
      ],
      [
        1889.3818359375,
        -1291.39501953125,
        167.16696166992188
      ],
      [
        1885.8992919921875,
        -1294.244873046875,
        167.4111328125
      ],
      [
        1768.17724609375,
        -905.3825073242188,
        22.130645751953125
      ],
      [
        1569.125244140625,
        -898.7719116210938,
        29.430980682373047
      ],
      [
        1523.38525390625,
        -895.1607666015625,
        22.764751434326172
      ],
      [
        1768.17724609375,
        -905.3825073242188,
        22.130647659301758
      ],
      [
        1789.19970703125,
        -901.4475708007812,
        14.21998405456543
      ],
      [
        807.4706420898438,
        -893.1958618164062,
        87.75196838378906
      ],
      [
        834.4644165039062,
        -894.8776245117188,
        87.97212219238281
      ],
      [
        427.6703186035156,
        -1062.943115234375,
        97.31878662109375
      ],
      [
        828.953369140625,
        -828.3515625,
        -14.061649322509766
      ],
      [
        778.9708862304688,
        -834.626953125,
        0.0
      ],
      [
        317.859619140625,
        -947.3338012695312,
        80.16206359863281
      ],
      [
        778.9708862304688,
        -834.626953125,
        0.0
      ],
      [
        780.6004638671875,
        -840.2579956054688,
        8.534324645996094
      ],
      [
        370.3416442871094,
        -941.2801513671875,
        80.94532775878906
      ],
      [
        317.859619140625,
        -947.3338012695312,
        80.16206359863281
      ],
      [
        170.58438110351562,
        -1001.1404418945312,
        82.41815185546875
      ],
      [
        1375.6494140625,
        -892.3465576171875,
        36.52680206298828
      ],
      [
        1306.3896484375,
        -864.6950073242188,
        0.0
      ],
      [
        1375.6494140625,
        -892.3465576171875,
        36.52680206298828
      ],
      [
        370.3416442871094,
        -941.2801513671875,
        80.94532775878906
      ],
      [
        780.6004638671875,
        -840.2579956054688,
        8.534322738647461
      ],
      [
        769.5424194335938,
        -890.0780639648438,
        86.27950286865234
      ],
      [
        408.6855773925781,
        -1285.966552734375,
        123.75029754638672
      ],
      [
        427.6703186035156,
        -1062.943115234375,
        97.31878662109375
      ],
      [
        1040.003662109375,
        -1761.8648681640625,
        199.55242919921875
      ],
      [
        1428.725830078125,
        -1549.0518798828125,
        185.03347778320312
      ],
      [
        951.3177490234375,
        -1790.8289794921875,
        200.4951934814453
      ],
      [
        548.0481567382812,
        -1765.029052734375,
        185.72837829589844
      ],
      [
        951.3177490234375,
        -1790.8289794921875,
        200.4951934814453
      ],
      [
        951.6287841796875,
        -1790.7315673828125,
        200.4923858642578
      ],
      [
        408.6855773925781,
        -1285.966552734375,
        123.75029754638672
      ],
      [
        489.83856201171875,
        -1707.9281005859375,
        177.1397247314453
      ],
      [
        1783.4498291015625,
        -973.279296875,
        125.41925811767578
      ],
      [
        1774.060791015625,
        -972.6520385742188,
        125.2774658203125
      ],
      [
        1906.1356201171875,
        -980.891845703125,
        126.37199401855469
      ],
      [
        1783.4498291015625,
        -973.279296875,
        125.41925811767578
      ],
      [
        1040.003662109375,
        -1761.8648681640625,
        199.55242919921875
      ],
      [
        999.75537109375,
        -1780.4920654296875,
        200.64349365234375
      ],
      [
        1956.0,
        -975.7061157226562,
        114.0
      ],
      [
        1930.5,
        -972.3056640625,
        111.0
      ],
      [
        980.9357299804688,
        -1781.5484619140625,
        200.22781372070312
      ],
      [
        980.9357299804688,
        -1781.5484619140625,
        200.2278289794922
      ],
      [
        999.7553100585938,
        -1780.4920654296875,
        200.64349365234375
      ],
      [
        1930.5,
        -972.3056640625,
        111.0
      ],
      [
        1922.0,
        -965.9807739257812,
        102.0
      ],
      [
        2243.87158203125,
        -858.3515625,
        -92.13609313964844
      ],
      [
        1828.958251953125,
        -894.486572265625,
        0.0
      ],
      [
        1824.153564453125,
        -894.9049682617188,
        1.0669479370117188
      ],
      [
        2243.87158203125,
        -858.3515625,
        -92.13609313964844
      ],
      [
        2709.246826171875,
        -750.2473754882812,
        -299.61138916015625
      ],
      [
        1990.0,
        -861.5022583007812,
        -64.97742462158203
      ],
      [
        1922.0,
        -862.20849609375,
        -57.9151611328125
      ],
      [
        1826.989013671875,
        -894.374267578125,
        0.0
      ],
      [
        2663.48828125,
        -1163.9058837890625,
        341.8642578125
      ],
      [
        2663.48828125,
        -1163.9058837890625,
        341.8642578125
      ],
      [
        2563.944091796875,
        -1063.200927734375,
        195.4212188720703
      ],
      [
        2477.266845703125,
        -1058.209228515625,
        195.34378051757812
      ],
      [
        2563.944091796875,
        -1063.200927734375,
        195.42123413085938
      ],
      [
        2342.315185546875,
        -1050.4373779296875,
        195.2231903076172
      ],
      [
        343.0009460449219,
        -944.433837890625,
        80.53728485107422
      ],
      [
        419.1201171875,
        -1163.386474609375,
        109.22278594970703
      ],
      [
        348.0556335449219,
        -943.8507690429688,
        80.61272430419922
      ],
      [
        585.7515258789062,
        -1842.68212890625,
        211.4281768798828
      ],
      [
        615.2658081054688,
        -1769.3294677734375,
        188.18972778320312
      ],
      [
        1846.7427978515625,
        -1537.049072265625,
        237.7119140625
      ],
      [
        1756.5892333984375,
        -1701.352783203125,
        289.6912841796875
      ],
      [
        1828.2545166015625,
        -1709.309326171875,
        304.3668518066406
      ],
      [
        1846.7427978515625,
        -1537.049072265625,
        237.7119140625
      ],
      [
        1880.7034912109375,
        -1307.5068359375,
        169.92564392089844
      ],
      [
        1881.73291015625,
        -1301.045166015625,
        168.1134796142578
      ],
      [
        691.6325073242188,
        -1953.2142333984375,
        446.78070068359375
      ],
      [
        600.4839477539062,
        -1806.0672607421875,
        199.8284149169922
      ],
      [
        887.89501953125,
        -1786.7713623046875,
        198.17279052734375
      ],
      [
        692.1905517578125,
        -1953.5579833984375,
        448.3835754394531
      ],
      [
        2340.683349609375,
        -1050.3433837890625,
        195.2217254638672
      ],
      [
        1850.8109130859375,
        -1485.468017578125,
        222.55604553222656
      ],
      [
        1803.877685546875,
        -1405.0067138671875,
        193.47705078125
      ],
      [
        1668.71533203125,
        -1531.2149658203125,
        210.2174835205078
      ],
      [
        1803.877685546875,
        -1405.0067138671875,
        193.47705078125
      ],
      [
        1826.7852783203125,
        -1387.89599609375,
        192.6317596435547
      ],
      [
        769.377197265625,
        -890.8225708007812,
        87.44129180908203
      ],
      [
        769.377197265625,
        -890.8225708007812,
        87.44129180908203
      ],
      [
        2322.1318359375,
        -1049.2750244140625,
        195.2051544189453
      ],
      [
        2022.963623046875,
        -1011.7991333007812,
        163.73696899414062
      ],
      [
        2322.1318359375,
        -1049.2750244140625,
        195.2051544189453
      ],
      [
        390.8761901855469,
        -1025.3253173828125,
        94.70560455322266
      ],
      [
        358.2977294921875,
        -1033.767578125,
        97.17586517333984
      ],
      [
        -3980.4384765625,
        -1365.029296875,
        1235.4888916015625
      ],
      [
        -4388.517578125,
        -1381.35546875,
        1296.49951171875
      ],
      [
        -3980.4384765625,
        -1365.02880859375,
        1235.4888916015625
      ],
      [
        -3987.50146484375,
        -1301.5224609375,
        1138.2445068359375
      ],
      [
        3070.986328125,
        -926.39599609375,
        278.6922607421875
      ],
      [
        5411.3759765625,
        -978.5357055664062,
        220.1478271484375
      ],
      [
        5411.3759765625,
        -978.5357055664062,
        220.1478271484375
      ],
      [
        3250.0,
        -1093.97802734375,
        182.5771942138672
      ],
      [
        3250.0,
        -962.6722412109375,
        0.0
      ],
      [
        3250.0,
        -1005.7769165039062,
        171.90725708007812
      ],
      [
        1909.5361328125,
        -936.10888671875,
        120.76487731933594
      ],
      [
        1753.0,
        -926.7715454101562,
        110.0
      ],
      [
        1829.130615234375,
        -930.0,
        110.0
      ],
      [
        1930.5,
        -934.5493774414062,
        111.0
      ],
      [
        1956.0,
        -936.383056640625,
        114.0
      ],
      [
        1929.5555419921875,
        -944.0,
        110.0
      ],
      [
        1930.5,
        -934.5493774414062,
        111.0
      ],
      [
        1929.5555419921875,
        -934.2586059570312,
        110.0
      ],
      [
        1929.5555419921875,
        -944.0,
        110.0
      ],
      [
        1929.5555419921875,
        -971.6029052734375,
        110.0
      ],
      [
        769.5424194335938,
        -890.0780639648438,
        86.27950286865234
      ],
      [
        773.4777221679688,
        -872.34814453125,
        58.61164093017578
      ],
      [
        1890.0,
        -919.1663818359375,
        56.5
      ],
      [
        1925.0,
        -920.650634765625,
        56.5
      ],
      [
        807.4706420898438,
        -893.1958618164062,
        87.75196838378906
      ],
      [
        1922.0,
        -931.9322509765625,
        102.0
      ],
      [
        1953.5687255859375,
        -939.3988037109375,
        126.4385986328125
      ],
      [
        1924.9368896484375,
        -940.8160400390625,
        125.78321075439453
      ],
      [
        1920.15478515625,
        -937.3532104492188,
        123.93168640136719
      ],
      [
        2665.15625,
        -975.6287841796875,
        150.58282470703125
      ],
      [
        2663.01025390625,
        -977.4854736328125,
        151.5334930419922
      ],
      [
        2645.9716796875,
        -974.8502807617188,
        150.72265625
      ],
      [
        2666.48095703125,
        -975.900390625,
        151.4419708251953
      ],
      [
        2663.01025390625,
        -977.4854736328125,
        151.5334930419922
      ],
      [
        2665.15625,
        -975.6287841796875,
        150.58282470703125
      ],
      [
        2304.45068359375,
        -922.0302734375,
        134.47035217285156
      ],
      [
        3250.0,
        -695.1821899414062,
        0.0
      ],
      [
        3250.0,
        -999.3610229492188,
        146.31979370117188
      ],
      [
        2304.45068359375,
        -922.0302734375,
        134.47035217285156
      ],
      [
        2147.562255859375,
        -929.7962036132812,
        130.879150390625
      ],
      [
        3038.564208984375,
        -805.9703979492188,
        141.63018798828125
      ],
      [
        3250.0,
        -692.3076171875,
        0.0
      ],
      [
        3250.0,
        -822.287841796875,
        149.71006774902344
      ],
      [
        2092.662109375,
        -871.5204467773438,
        -58.55836868286133
      ],
      [
        781.9329833984375,
        -834.2550659179688,
        -0.8333282470703125
      ],
      [
        1866.5491943359375,
        -891.2127685546875,
        0.0
      ],
      [
        1834.8018798828125,
        -893.9776611328125,
        -1.2976493835449219
      ],
      [
        1874.631103515625,
        -930.0,
        110.0
      ],
      [
        1927.0,
        -924.6683959960938,
        110.0
      ],
      [
        1875.4571533203125,
        -934.6168823242188,
        120.57818603515625
      ],
      [
        1927.0,
        -930.0,
        110.5882339477539
      ],
      [
        1927.0,
        -928.1876220703125,
        119.77301788330078
      ],
      [
        1927.0,
        -924.8801879882812,
        110.5882339477539
      ],
      [
        1929.5555419921875,
        -924.408203125,
        110.0
      ],
      [
        1929.5555419921875,
        -934.2586059570312,
        110.0
      ],
      [
        1927.0,
        -924.6683959960938,
        110.0
      ],
      [
        1927.0,
        -928.3321533203125,
        120.0
      ],
      [
        1927.0,
        -928.2565307617188,
        119.96438598632812
      ],
      [
        1890.0,
        -909.17041015625,
        56.5
      ],
      [
        1925.0,
        -905.6071166992188,
        56.5
      ],
      [
        1990.0,
        -915.049560546875,
        101.09986114501953
      ],
      [
        1974.0262451171875,
        -917.0,
        102.00006103515625
      ],
      [
        1990.0,
        -915.049560546875,
        101.09986114501953
      ],
      [
        1915.990478515625,
        -906.9073486328125,
        57.563480377197266
      ],
      [
        1915.846435546875,
        -906.7283935546875,
        57.02573013305664
      ],
      [
        1915.846435546875,
        -906.7283935546875,
        57.02573013305664
      ],
      [
        1915.70556640625,
        -906.5534057617188,
        56.5
      ],
      [
        1869.247314453125,
        -934.3450317382812,
        120.5441665649414
      ],
      [
        1927.0,
        -928.2693481445312,
        120.0
      ],
      [
        1990.0,
        -862.2008056640625,
        -57.99177932739258
      ],
      [
        1976.492919921875,
        -861.6425170898438,
        -63.57461929321289
      ],
      [
        1832.1395263671875,
        -930.0,
        120.00025177001953
      ],
      [
        1779.683837890625,
        -903.228759765625,
        17.800779342651367
      ],
      [
        1832.1395263671875,
        -930.0,
        120.00025177001953
      ],
      [
        1811.548828125,
        -931.8190307617188,
        120.22807312011719
      ],
      [
        1807.1473388671875,
        -929.0677490234375,
        110.0
      ],
      [
        1910.3541259765625,
        -926.3630981445312,
        110.0
      ],
      [
        1838.9818115234375,
        -926.363037109375,
        110.0
      ],
      [
        1890.0,
        -906.9060668945312,
        56.5
      ],
      [
        1912.241455078125,
        -906.9060668945312,
        56.5
      ],
      [
        1927.0,
        -918.8848876953125,
        110.0
      ],
      [
        1927.0,
        -921.9404296875,
        120.0
      ],
      [
        1927.0,
        -918.8848876953125,
        110.0
      ],
      [
        1850.0,
        -930.0,
        122.31071472167969
      ],
      [
        1850.0,
        -929.157470703125,
        122.20878601074219
      ],
      [
        1850.0,
        -928.4824829101562,
        120.0
      ],
      [
        1922.0,
        -916.8431396484375,
        101.92767333984375
      ],
      [
        1990.0,
        -910.1171875,
        98.82339477539062
      ],
      [
        1890.0,
        -905.6810302734375,
        56.5
      ],
      [
        1925.0,
        -902.7073364257812,
        56.5
      ],
      [
        1985.1414794921875,
        -909.143310546875,
        94.28524780273438
      ],
      [
        1983.61083984375,
        -901.8239135742188,
        69.90547180175781
      ],
      [
        1916.7310791015625,
        -904.5792846679688,
        60.32709503173828
      ],
      [
        1916.201416015625,
        -904.020263671875,
        58.3503303527832
      ],
      [
        1916.201416015625,
        -904.020263671875,
        58.3503303527832
      ],
      [
        1915.70556640625,
        -903.4970092773438,
        56.5
      ],
      [
        1990.0,
        -910.1171875,
        98.82339477539062
      ],
      [
        1985.1414794921875,
        -909.143310546875,
        94.28524780273438
      ],
      [
        1749.6490478515625,
        -861.7596435546875,
        111.15753173828125
      ],
      [
        1751.345947265625,
        -809.0045166015625,
        104.8245849609375
      ],
      [
        1751.345947265625,
        -809.0045166015625,
        104.82459259033203
      ],
      [
        1754.6307373046875,
        -706.8832397460938,
        92.56556701660156
      ],
      [
        1764.29443359375,
        -675.995849609375,
        56.5
      ],
      [
        1770.0,
        -779.5858764648438,
        35.20705032348633
      ],
      [
        1764.696533203125,
        -740.0,
        55.0
      ],
      [
        1768.5234375,
        -910.0577392578125,
        40.71758270263672
      ],
      [
        1774.10107421875,
        -904.2737426757812,
        19.901561737060547
      ],
      [
        1770.0,
        -779.5858764648438,
        35.20705032348633
      ],
      [
        1770.0,
        -780.0,
        35.207035064697266
      ],
      [
        1770.0555419921875,
        -780.0,
        35.00000762939453
      ],
      [
        1770.0,
        -780.0,
        35.207035064697266
      ],
      [
        1770.0640869140625,
        -780.0,
        34.96797180175781
      ],
      [
        1931.62890625,
        -857.7420043945312,
        115.92677307128906
      ],
      [
        1929.7608642578125,
        -800.5593872070312,
        108.95528411865234
      ],
      [
        1929.7608642578125,
        -800.5593872070312,
        108.95528411865234
      ],
      [
        1927.1356201171875,
        -720.1962280273438,
        99.15771484375
      ],
      [
        1915.70556640625,
        -682.6573486328125,
        56.5
      ],
      [
        1901.034423828125,
        -888.0130615234375,
        1.7463856935501099
      ],
      [
        1903.05810546875,
        -889.73974609375,
        9.298835754394531
      ],
      [
        1904.4132080078125,
        -891.5791015625,
        14.356414794921875
      ],
      [
        1903.05810546875,
        -889.73974609375,
        9.29883861541748
      ],
      [
        1769.8133544921875,
        -927.4845581054688,
        110.0
      ],
      [
        1838.9818115234375,
        -926.363037109375,
        110.0
      ],
      [
        1782.0196533203125,
        -926.363037109375,
        110.0
      ],
      [
        1927.0,
        -913.0418701171875,
        110.0
      ],
      [
        1927.0,
        -915.5742797851562,
        120.0
      ],
      [
        1927.0,
        -913.0418701171875,
        110.0
      ],
      [
        1850.0,
        -923.0206909179688,
        121.46640014648438
      ],
      [
        1850.0,
        -922.6492309570312,
        120.0
      ],
      [
        1890.0,
        -902.8929443359375,
        56.5
      ],
      [
        1915.70556640625,
        -900.531005859375,
        56.5
      ],
      [
        1915.70556640625,
        -903.4970092773438,
        56.5
      ],
      [
        1922.0,
        -910.7440795898438,
        99.11270904541016
      ],
      [
        1927.058349609375,
        -910.2177734375,
        98.86981201171875
      ],
      [
        1927.8067626953125,
        -916.268798828125,
        101.66259002685547
      ],
      [
        1800.71826171875,
        -840.0,
        110.0
      ],
      [
        1753.0,
        -851.3911743164062,
        110.0
      ],
      [
        1927.0,
        -892.5176391601562,
        120.0
      ],
      [
        1927.0,
        -840.0,
        113.64679718017578
      ],
      [
        1918.5555419921875,
        -840.0,
        110.0
      ],
      [
        1921.5009765625,
        -840.0,
        113.48799133300781
      ],
      [
        1918.5555419921875,
        -811.8702392578125,
        110.0
      ],
      [
        1850.0,
        -910.8988647460938,
        120.0
      ],
      [
        1908.8084716796875,
        -718.7819213867188,
        98.45736694335938
      ],
      [
        1889.0,
        -697.54443359375,
        75.0
      ],
      [
        1867.888916015625,
        -800.0,
        50.0
      ],
      [
        1867.888916015625,
        -800.0,
        50.0
      ],
      [
        1825.666748046875,
        -800.0,
        0.0
      ],
      [
        1825.666748046875,
        -740.0,
        0.0
      ],
      [
        1842.5555419921875,
        -780.0,
        20.0
      ],
      [
        1842.5555419921875,
        -780.0,
        20.0
      ],
      [
        1842.5555419921875,
        -800.0,
        20.0
      ],
      [
        1800.0,
        -780.0,
        20.000001907348633
      ],
      [
        1790.0,
        -800.0,
        30.0
      ],
      [
        1889.0,
        -800.0,
        75.0
      ],
      [
        1915.70556640625,
        -880.5,
        56.5
      ],
      [
        1922.0,
        -897.9967651367188,
        79.99149322509766
      ],
      [
        1926.2894287109375,
        -904.0,
        96.00006103515625
      ],
      [
        1926.2894287109375,
        -904.0,
        96.00006103515625
      ],
      [
        1880.0,
        -780.0,
        20.000001907348633
      ],
      [
        1900.0,
        -800.0,
        30.000003814697266
      ],
      [
        1880.0,
        -780.0,
        20.000001907348633
      ],
      [
        1922.0023193359375,
        -788.0,
        80.0
      ],
      [
        1923.342041015625,
        -788.0,
        85.0
      ],
      [
        1915.303466796875,
        -740.0,
        55.0
      ],
      [
        1910.0,
        -779.5858764648438,
        35.20705032348633
      ],
      [
        1895.0,
        -795.0,
        27.500003814697266
      ],
      [
        1909.9359130859375,
        -800.0,
        34.96796798706055
      ],
      [
        1909.9359130859375,
        -780.0640869140625,
        34.96797180175781
      ],
      [
        1911.284423828125,
        -780.0,
        40.0
      ],
      [
        1911.284423828125,
        -800.0,
        40.0
      ],
      [
        1910.0,
        -780.0,
        35.207035064697266
      ],
      [
        1900.0,
        -780.0,
        35.0
      ],
      [
        1909.9444580078125,
        -780.0,
        35.000003814697266
      ],
      [
        1916.6431884765625,
        -740.0,
        60.0
      ],
      [
        1910.0,
        -730.0000610351562,
        60.0
      ],
      [
        1916.6431884765625,
        -730.0000610351562,
        60.0
      ],
      [
        1909.9359130859375,
        -780.0,
        34.96796798706055
      ],
      [
        1909.9359130859375,
        -780.0,
        34.96797180175781
      ],
      [
        1916.6431884765625,
        -720.0,
        60.0
      ],
      [
        1916.6431884765625,
        -720.0,
        60.0
      ],
      [
        1915.303466796875,
        -720.0,
        55.0
      ],
      [
        1975.347900390625,
        -861.6544189453125,
        -63.4556999206543
      ],
      [
        1985.4393310546875,
        -910.5682983398438,
        99.0315933227539
      ],
      [
        1925.0,
        -889.1875,
        56.5
      ],
      [
        1915.70556640625,
        -889.1875,
        56.5
      ],
      [
        1952.0,
        -899.0,
        82.66670227050781
      ],
      [
        1952.0,
        -898.0,
        80.0
      ],
      [
        1950.0,
        -730.4000244140625,
        55.0
      ],
      [
        1909.9359130859375,
        -780.0640869140625,
        34.96797180175781
      ],
      [
        1909.9444580078125,
        -780.0,
        35.000003814697266
      ],
      [
        1930.0,
        -788.0,
        80.0
      ],
      [
        1930.0,
        -788.0,
        85.0
      ],
      [
        1950.0,
        -788.0,
        80.0
      ],
      [
        1950.0,
        -788.0,
        85.0
      ],
      [
        2970.258544921875,
        -680.0,
        0.0
      ],
      [
        2950.303466796875,
        -680.0,
        1.011322021484375
      ],
      [
        3004.293212890625,
        -1072.02197265625,
        397.90423583984375
      ],
      [
        3070.986328125,
        -926.39599609375,
        278.6922607421875
      ],
      [
        3004.293212890625,
        -1072.02197265625,
        397.90423583984375
      ],
      [
        3250.0,
        -1320.0,
        585.5209350585938
      ],
      [
        3250.0,
        -1212.96630859375,
        500.0
      ],
      [
        3250.0,
        -1212.9661865234375,
        500.0
      ],
      [
        3250.0,
        -930.3838500976562,
        274.21405029296875
      ],
      [
        2543.70263671875,
        -959.033203125,
        145.8558807373047
      ],
      [
        2477.266845703125,
        -1058.209228515625,
        195.34378051757812
      ],
      [
        1850.0,
        -743.5802612304688,
        130.0
      ],
      [
        1850.0,
        -734.8981323242188,
        120.0
      ],
      [
        1735.0213623046875,
        -769.5591430664062,
        165.74871826171875
      ],
      [
        1742.883056640625,
        -744.4315185546875,
        136.40863037109375
      ],
      [
        1742.883056640625,
        -744.4315185546875,
        136.40863037109375
      ],
      [
        1835.0,
        -755.9435424804688,
        145.0
      ],
      [
        1845.0,
        -756.3834838867188,
        145.0
      ],
      [
        1845.0,
        -760.0,
        149.1654815673828
      ],
      [
        1845.0,
        -756.3834838867188,
        145.0
      ],
      [
        1927.0,
        -738.285888671875,
        120.0
      ],
      [
        1935.37890625,
        -844.2138671875,
        129.92214965820312
      ],
      [
        1944.1435546875,
        -776.0537719726562,
        162.6319580078125
      ],
      [
        1936.333984375,
        -750.4057006835938,
        133.48654174804688
      ],
      [
        1935.3790283203125,
        -757.6924438476562,
        129.92245483398438
      ],
      [
        1935.3790283203125,
        -757.6924438476562,
        129.92245483398438
      ],
      [
        1936.333984375,
        -750.4057006835938,
        133.48654174804688
      ],
      [
        1935.3790283203125,
        -747.2693481445312,
        129.9224853515625
      ],
      [
        1934.3851318359375,
        -847.1320190429688,
        128.74533081054688
      ],
      [
        1929.4755859375,
        -778.7706298828125,
        166.5045166015625
      ],
      [
        1944.1435546875,
        -776.0537719726562,
        162.6319580078125
      ],
      [
        1935.37890625,
        -844.2138671875,
        129.92214965820312
      ],
      [
        3250.0,
        -692.3076171875,
        83.98895263671875
      ],
      [
        1731.751708984375,
        -728.5499267578125,
        177.95120239257812
      ],
      [
        1737.3897705078125,
        -702.5175170898438,
        156.90969848632812
      ],
      [
        1737.3897705078125,
        -702.5175170898438,
        156.90969848632812
      ],
      [
        1753.8572998046875,
        -626.482666015625,
        95.45210266113281
      ],
      [
        1764.29443359375,
        -626.94189453125,
        56.5
      ],
      [
        1947.9056396484375,
        -738.5323486328125,
        176.67254638671875
      ],
      [
        1941.7200927734375,
        -709.30908203125,
        153.58778381347656
      ],
      [
        1941.7200927734375,
        -709.30908203125,
        153.58778381347656
      ],
      [
        1925.789794921875,
        -634.0470581054688,
        94.13478088378906
      ],
      [
        1915.70556640625,
        -633.6033935546875,
        56.5
      ],
      [
        1927.0,
        -666.4835815429688,
        120.0
      ],
      [
        1905.2908935546875,
        -633.145263671875,
        94.2918930053711
      ],
      [
        1889.0,
        -632.428466796875,
        75.0
      ],
      [
        1850.0,
        -674.8729858398438,
        130.0
      ],
      [
        1850.0,
        -662.3574829101562,
        120.0
      ],
      [
        1835.0,
        -692.8424072265625,
        145.0
      ],
      [
        1845.0,
        -693.3782958984375,
        145.0
      ],
      [
        1845.0,
        -712.1515502929688,
        160.0
      ],
      [
        1845.0,
        -693.3782958984375,
        145.0
      ],
      [
        1933.41845703125,
        -743.4467163085938,
        181.21945190429688
      ],
      [
        1947.9056396484375,
        -738.5323486328125,
        176.67254638671875
      ],
      [
        2970.2587890625,
        -680.0,
        67.52960205078125
      ],
      [
        3250.0,
        -1320.0,
        592.6467895507812
      ],
      [
        3250.0,
        -1182.61083984375,
        500.0
      ],
      [
        3250.0,
        -1182.61083984375,
        500.0
      ],
      [
        3250.0,
        -930.3838500976562,
        274.2140808105469
      ],
      [
        3250.0,
        -1041.144287109375,
        401.7869873046875
      ],
      [
        3250.0,
        -1052.43505859375,
        412.2174377441406
      ],
      [
        3250.0,
        -728.0355834960938,
        112.5359115600586
      ],
      [
        1731.03173828125,
        -707.57373046875,
        180.63803100585938
      ],
      [
        1735.6466064453125,
        -689.2167358398438,
        163.41539001464844
      ],
      [
        1735.6466064453125,
        -689.2167358398438,
        163.4154052734375
      ],
      [
        1751.444091796875,
        -626.37646484375,
        104.45846557617188
      ],
      [
        1948.5616455078125,
        -719.4189453125,
        179.1207733154297
      ],
      [
        1943.2503662109375,
        -697.6328125,
        159.2989044189453
      ],
      [
        1943.2503662109375,
        -697.6328125,
        159.29891967773438
      ],
      [
        1927.77001953125,
        -634.1341552734375,
        101.52531433105469
      ],
      [
        1927.0,
        -654.0849609375,
        120.0
      ],
      [
        1911.6259765625,
        -633.4240112304688,
        101.79396057128906
      ],
      [
        1845.0,
        -692.2998657226562,
        160.0
      ],
      [
        1845.0,
        -676.0626831054688,
        145.0
      ],
      [
        1835.0,
        -675.4426879882812,
        145.0
      ],
      [
        1845.0,
        -676.0626831054688,
        145.0
      ],
      [
        1934.101318359375,
        -723.5525512695312,
        183.76768493652344
      ],
      [
        1948.5616455078125,
        -719.4189453125,
        179.1207733154297
      ],
      [
        1850.0,
        -660.135498046875,
        130.0
      ],
      [
        1850.0,
        -649.3106689453125,
        120.0
      ],
      [
        3250.0,
        -692.3076171875,
        169.36959838867188
      ],
      [
        1951.44482421875,
        -635.4100341796875,
        189.88143920898438
      ],
      [
        1951.422119140625,
        -635.2819213867188,
        189.79605102539062
      ],
      [
        1951.422119140625,
        -635.281982421875,
        189.7960662841797
      ],
      [
        1951.40283203125,
        -635.1739501953125,
        189.72410583496094
      ],
      [
        1728.87109375,
        -625.3833618164062,
        188.70217895507812
      ],
      [
        1729.7960205078125,
        -625.424072265625,
        185.25018310546875
      ],
      [
        1729.7960205078125,
        -625.424072265625,
        185.25018310546875
      ],
      [
        1936.9332275390625,
        -641.0409545898438,
        194.33656311035156
      ],
      [
        1951.44482421875,
        -635.4100341796875,
        189.88143920898438
      ],
      [
        1845.0,
        -630.4926147460938,
        160.0
      ],
      [
        1845.0,
        -630.4926147460938,
        145.0
      ],
      [
        1835.0,
        -630.0526733398438,
        145.0
      ],
      [
        1845.0,
        -630.4926147460938,
        145.0
      ],
      [
        1927.0,
        -634.1004638671875,
        120.0
      ],
      [
        1850.0,
        -630.712646484375,
        130.0
      ],
      [
        1850.0,
        -630.712646484375,
        120.0
      ],
      [
        3250.0,
        -1142.69775390625,
        600.0
      ],
      [
        3250.0,
        -1048.05224609375,
        500.0
      ],
      [
        3250.0,
        -1048.05224609375,
        500.0
      ],
      [
        3250.0,
        -810.6640014648438,
        249.181884765625
      ],
      [
        -4245.8544921875,
        -362.51678466796875,
        1168.4053955078125
      ],
      [
        -4541.33935546875,
        -349.516357421875,
        1209.9666748046875
      ],
      [
        -4245.8544921875,
        -362.516845703125,
        1168.405517578125
      ],
      [
        -4238.6689453125,
        -362.83282470703125,
        1100.6925048828125
      ],
      [
        1947.4486083984375,
        -635.0,
        191.38381958007812
      ],
      [
        1951.452880859375,
        -635.1761474609375,
        189.91140747070312
      ],
      [
        1947.4486083984375,
        -635.0,
        191.38381958007812
      ],
      [
        1937.125,
        -634.5458374023438,
        195.0521697998047
      ],
      [
        1951.452880859375,
        -635.1761474609375,
        189.91140747070312
      ],
      [
        1951.43603515625,
        -635.1754150390625,
        189.84815979003906
      ],
      [
        1951.43603515625,
        -635.1754150390625,
        189.84817504882812
      ],
      [
        3250.0,
        -692.3075561523438,
        600.0
      ],
      [
        3250.0,
        -692.3076171875,
        500.0
      ],
      [
        3250.0,
        -692.3076171875,
        500.0
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.1160278320312
      ],
      [
        -2708.39404296875,
        6871.484375,
        470.39349365234375
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        -2282.5439453125,
        6956.19140625,
        297.51165771484375
      ],
      [
        -2525.290771484375,
        6907.90625,
        150.0
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        -195.0383758544922,
        5178.23486328125,
        0.0
      ],
      [
        -234.04736328125,
        5684.36474609375,
        150.0
      ],
      [
        -195.0383758544922,
        5178.23486328125,
        0.0
      ],
      [
        -99.99644470214844,
        4949.07666015625,
        -300.0
      ],
      [
        -184.0259246826172,
        5035.35205078125,
        -42.34581756591797
      ],
      [
        -1857.3211669921875,
        6954.4736328125,
        506.298583984375
      ],
      [
        -1146.6842041015625,
        5724.8427734375,
        150.0
      ],
      [
        -234.04736328125,
        5684.36474609375,
        150.0
      ],
      [
        -450.0968933105469,
        7064.0869140625,
        557.4569091796875
      ],
      [
        -2708.39404296875,
        6871.484375,
        38.73222732543945
      ],
      [
        -2778.40673828125,
        6824.703125,
        -22.699951171875
      ],
      [
        -2708.39404296875,
        6871.484375,
        470.39349365234375
      ],
      [
        -4095.87744140625,
        5944.39794921875,
        176.39254760742188
      ],
      [
        3966.75,
        4947.60009765625,
        -13.693603515625
      ],
      [
        -177.262939453125,
        4947.6044921875,
        -68.35127258300781
      ],
      [
        -246.44662475585938,
        4171.71630859375,
        -300.0
      ],
      [
        -177.262939453125,
        4947.6044921875,
        -68.35127258300781
      ],
      [
        3108.39404296875,
        6871.484375,
        589.1246948242188
      ],
      [
        3052.046875,
        6882.6923828125,
        549.7059326171875
      ],
      [
        3956.67333984375,
        4948.55029296875,
        -13.543876647949219
      ],
      [
        3108.39404296875,
        6871.484375,
        620.907470703125
      ],
      [
        816.3771362304688,
        7327.39501953125,
        652.46484375
      ],
      [
        3018.31005859375,
        6889.4033203125,
        624.2334594726562
      ],
      [
        3108.39404296875,
        6871.484375,
        623.0784912109375
      ],
      [
        -4915.41455078125,
        5396.80078125,
        976.300048828125
      ],
      [
        -5086.2646484375,
        5282.642578125,
        631.4568481445312
      ],
      [
        -292.60101318359375,
        5125.58740234375,
        226.8505096435547
      ],
      [
        -419.21197509765625,
        5100.55615234375,
        150.0
      ],
      [
        -246.75621032714844,
        5099.7578125,
        150.0
      ],
      [
        -292.6009826660156,
        5125.58740234375,
        226.8504638671875
      ],
      [
        -197.83628845214844,
        5049.53076171875,
        0.0
      ],
      [
        -246.75621032714844,
        5099.7578125,
        150.0
      ],
      [
        -197.83628845214844,
        5049.53076171875,
        0.0
      ],
      [
        -184.0259246826172,
        5035.35205078125,
        -42.34581756591797
      ],
      [
        -5579.1611328125,
        4617.6630859375,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.0498046875,
        901.1133422851562
      ],
      [
        -2613.806396484375,
        3353.8779296875,
        0.0
      ],
      [
        -2613.80615234375,
        3353.8779296875,
        0.0
      ],
      [
        -2609.847900390625,
        3350.7421875,
        -10.618778228759766
      ],
      [
        3250.0,
        820.0,
        60.0
      ],
      [
        3250.0,
        -692.3076171875,
        60.0
      ],
      [
        -2636.173583984375,
        3371.595947265625,
        60.00000762939453
      ],
      [
        -1255.4737548828125,
        3519.528076171875,
        60.0
      ],
      [
        -417.7394104003906,
        3913.755859375,
        60.00000762939453
      ],
      [
        -219.95901489257812,
        4952.10302734375,
        60.0
      ],
      [
        -800.0,
        3733.86865234375,
        60.0
      ],
      [
        -700.0,
        3780.927490234375,
        60.000003814697266
      ],
      [
        -1255.4737548828125,
        3519.528076171875,
        60.00000762939453
      ],
      [
        -417.7394104003906,
        3913.755859375,
        60.0
      ],
      [
        -219.95901489257812,
        4952.10302734375,
        60.00000762939453
      ],
      [
        -217.4042510986328,
        5069.62158203125,
        60.0
      ],
      [
        2590.0,
        600.0,
        -173.99990844726562
      ],
      [
        2590.0,
        560.0,
        -293.9998779296875
      ],
      [
        2589.999755859375,
        670.0,
        36.000091552734375
      ],
      [
        2589.999755859375,
        620.0,
        -114.00003051757812
      ],
      [
        2060.60009765625,
        670.0,
        36.0
      ],
      [
        2150.0,
        670.0,
        36.0
      ],
      [
        2150.0,
        670.0,
        36.0
      ],
      [
        2150.0,
        637.9999389648438,
        -60.0
      ],
      [
        -1512.393798828125,
        658.0,
        0.0
      ],
      [
        -1514.366455078125,
        670.0,
        0.0
      ],
      [
        -1498.0869140625,
        670.0,
        -48.19183349609375
      ],
      [
        -1494.425048828125,
        642.743896484375,
        -45.7684326171875
      ],
      [
        -1514.366455078125,
        670.0,
        0.0
      ],
      [
        -1512.393798828125,
        658.0,
        0.0
      ],
      [
        -1532.6080322265625,
        670.0,
        36.0
      ],
      [
        -1548.7220458984375,
        694.0467529296875,
        60.000003814697266
      ],
      [
        -1546.084228515625,
        678.0,
        60.000003814697266
      ],
      [
        2589.999755859375,
        620.0,
        -114.00001525878906
      ],
      [
        2664.999755859375,
        620.0,
        -114.00003051757812
      ],
      [
        2664.999755859375,
        620.0,
        -114.00001525878906
      ],
      [
        2665.0,
        600.0,
        -173.9999237060547
      ],
      [
        2665.0,
        560.0,
        -293.9999084472656
      ],
      [
        2665.0,
        557.9999389648438,
        -300.0
      ],
      [
        2590.0,
        560.0,
        -293.9999084472656
      ],
      [
        2665.0,
        560.0,
        -293.9998779296875
      ],
      [
        2589.999755859375,
        669.0,
        55.0
      ],
      [
        2540.0,
        669.0,
        55.0
      ],
      [
        2200.0,
        669.0,
        55.0
      ],
      [
        2540.0,
        669.0,
        55.0
      ],
      [
        2060.60009765625,
        670.0,
        55.0
      ],
      [
        2150.0,
        670.0,
        55.0
      ],
      [
        -1542.0711669921875,
        669.0,
        55.0
      ],
      [
        -1542.235595703125,
        670.0,
        55.0
      ],
      [
        -1532.608154296875,
        670.0,
        36.00004196166992
      ],
      [
        2589.999755859375,
        658.0,
        -7.62939453125e-06
      ],
      [
        2589.999755859375,
        669.0,
        55.0
      ],
      [
        2150.0,
        670.0,
        55.0
      ],
      [
        2150.0,
        658.0,
        5.7220458984375e-05
      ],
      [
        2150.0,
        669.0,
        55.0
      ],
      [
        -1543.2767333984375,
        676.3333129882812,
        55.0
      ],
      [
        2060.60009765625,
        670.0,
        60.0
      ],
      [
        2150.0,
        670.0,
        60.0
      ],
      [
        -1544.7691650390625,
        670.0,
        60.000003814697266
      ],
      [
        -1542.235595703125,
        670.0,
        55.0
      ],
      [
        2150.0,
        670.0,
        60.0
      ],
      [
        -1449.9705810546875,
        93.32071685791016,
        60.0
      ],
      [
        -1449.9705810546875,
        93.32071685791016,
        59.999996185302734
      ],
      [
        -1429.9962158203125,
        77.13494110107422,
        8.765613555908203
      ],
      [
        -1450.64208984375,
        92.33169555664062,
        59.999996185302734
      ],
      [
        896.2005615234375,
        314.89910888671875,
        60.0
      ],
      [
        2425.0,
        566.3333129882812,
        55.0
      ],
      [
        2400.0,
        566.3333129882812,
        55.0
      ],
      [
        2520.0,
        566.3333129882812,
        55.0
      ],
      [
        2495.0,
        566.3333129882812,
        55.0
      ],
      [
        2590.0,
        566.3333129882812,
        55.0
      ],
      [
        2540.0,
        566.3333740234375,
        55.0
      ],
      [
        2589.999755859375,
        560.0,
        35.999908447265625
      ],
      [
        2664.999755859375,
        560.0,
        35.99989318847656
      ],
      [
        2664.999755859375,
        560.0,
        35.999908447265625
      ],
      [
        2664.999755859375,
        540.0,
        -24.0
      ],
      [
        2589.999755859375,
        540.0,
        -24.0
      ],
      [
        2590.0,
        500.0,
        -143.99998474121094
      ],
      [
        2420.0,
        500.0,
        -144.0
      ],
      [
        2419.999755859375,
        520.0,
        -84.00006103515625
      ],
      [
        2150.0,
        560.0,
        -60.0
      ],
      [
        2150.0,
        528.0,
        -60.0
      ],
      [
        2150.0,
        560.0,
        35.99989700317383
      ],
      [
        1970.7955322265625,
        560.0,
        0.0
      ],
      [
        1960.7735595703125,
        560.0,
        35.99991989135742
      ],
      [
        2590.0,
        500.0,
        -143.99996948242188
      ],
      [
        2665.0,
        500.0,
        -143.99998474121094
      ],
      [
        2589.999755859375,
        566.3333740234375,
        55.0
      ],
      [
        2589.999755859375,
        560.0,
        35.99989318847656
      ],
      [
        2061.023681640625,
        669.0,
        55.0
      ],
      [
        1961.616455078125,
        566.3333740234375,
        55.0
      ],
      [
        2150.0,
        669.0,
        55.0
      ],
      [
        2150.0,
        566.3333740234375,
        55.0
      ],
      [
        2380.0,
        650.0,
        55.0
      ],
      [
        2391.66650390625,
        650.0,
        55.0
      ],
      [
        2200.0,
        650.0,
        55.0
      ],
      [
        2211.66650390625,
        650.0,
        55.0
      ],
      [
        2540.0,
        650.0,
        55.0
      ],
      [
        2528.33349609375,
        650.0,
        55.0
      ],
      [
        2360.0,
        650.0,
        55.0
      ],
      [
        2348.33349609375,
        650.0,
        55.0
      ],
      [
        2528.33349609375,
        650.0,
        55.0
      ],
      [
        2391.66650390625,
        650.0,
        55.0
      ],
      [
        2348.33349609375,
        650.0,
        55.0
      ],
      [
        2211.66650390625,
        650.0,
        55.0
      ],
      [
        2530.0,
        564.666748046875,
        50.0
      ],
      [
        2530.0,
        566.3333740234375,
        55.0
      ],
      [
        2530.0,
        620.0,
        55.0
      ],
      [
        2425.0,
        566.3333129882812,
        55.0
      ],
      [
        2425.0,
        564.6666870117188,
        50.0
      ],
      [
        2540.0,
        650.0,
        55.0
      ],
      [
        2540.0,
        620.0,
        55.0
      ],
      [
        2950.0,
        669.0,
        55.0
      ],
      [
        2969.166748046875,
        664.0,
        55.0
      ],
      [
        3180.0,
        600.75,
        55.0
      ],
      [
        2969.166748046875,
        664.0,
        55.0
      ],
      [
        3180.0,
        601.0,
        60.0
      ],
      [
        1961.8382568359375,
        568.0000610351562,
        60.0
      ],
      [
        2380.0,
        650.0,
        60.0
      ],
      [
        2403.333251953125,
        650.0,
        60.0
      ],
      [
        2200.0,
        650.0,
        60.0
      ],
      [
        2223.333251953125,
        650.0,
        60.0
      ],
      [
        2540.0,
        650.0,
        60.0
      ],
      [
        2516.666748046875,
        650.0,
        60.0
      ],
      [
        2360.0,
        650.0,
        60.0
      ],
      [
        2336.666748046875,
        650.0,
        60.0
      ],
      [
        2516.666748046875,
        650.0,
        60.0
      ],
      [
        2403.333251953125,
        650.0,
        60.0
      ],
      [
        2336.666748046875,
        650.0,
        60.0
      ],
      [
        2223.333251953125,
        650.0,
        60.0
      ],
      [
        2150.0,
        568.0000610351562,
        60.0
      ],
      [
        2150.0,
        650.0,
        60.0
      ],
      [
        2150.0,
        650.0,
        55.0
      ],
      [
        2530.0,
        568.0000610351562,
        60.0
      ],
      [
        2530.0,
        620.0,
        60.0
      ],
      [
        2540.0,
        650.0,
        60.0
      ],
      [
        2540.0,
        620.0,
        60.0
      ],
      [
        2608.0,
        608.5,
        60.0
      ],
      [
        2608.0,
        611.5,
        60.0
      ],
      [
        2608.0,
        611.5,
        60.0
      ],
      [
        2605.0,
        611.5,
        60.0
      ],
      [
        2648.0,
        608.5,
        60.0
      ],
      [
        2648.0,
        611.5,
        60.0
      ],
      [
        2648.0,
        611.5,
        60.0
      ],
      [
        2645.0,
        611.5,
        60.0
      ],
      [
        2520.0,
        559.0,
        55.0
      ],
      [
        2530.0,
        559.0,
        55.0
      ],
      [
        2530.0,
        559.0,
        55.0
      ],
      [
        2530.0,
        560.0,
        55.0
      ],
      [
        2540.0,
        560.0,
        55.0
      ],
      [
        2540.0,
        559.0,
        55.0
      ],
      [
        2590.0,
        559.0,
        55.0
      ],
      [
        2665.0,
        559.0,
        55.0
      ],
      [
        2425.0,
        560.0,
        55.0
      ],
      [
        2425.0,
        559.0,
        55.0
      ],
      [
        2400.0,
        559.0,
        55.0
      ],
      [
        2400.0,
        560.0,
        55.0
      ],
      [
        2520.0,
        560.0,
        55.0
      ],
      [
        2520.0,
        559.0,
        55.0
      ],
      [
        2495.0,
        559.0,
        55.0
      ],
      [
        2495.0,
        560.0,
        55.0
      ],
      [
        2590.0,
        560.0,
        55.0
      ],
      [
        2590.0,
        559.0,
        55.0
      ],
      [
        2540.0,
        559.0,
        55.0
      ],
      [
        2540.0,
        560.0,
        55.0
      ],
      [
        1954.515869140625,
        559.0,
        55.0
      ],
      [
        1955.484130859375,
        560.0,
        55.0
      ],
      [
        1960.7735595703125,
        560.0,
        35.9998893737793
      ],
      [
        2150.0,
        560.0,
        55.0
      ],
      [
        2150.0,
        560.0,
        35.99987030029297
      ],
      [
        2150.0,
        547.9999389648438,
        -0.000232696533203125
      ],
      [
        2150.0,
        559.0,
        55.0
      ],
      [
        2664.999755859375,
        559.0,
        55.0
      ],
      [
        2664.999755859375,
        548.0000610351562,
        5.7220458984375e-05
      ],
      [
        2425.0,
        559.0,
        55.0
      ],
      [
        2425.0,
        560.0,
        55.0
      ],
      [
        2425.0,
        560.0,
        50.0
      ],
      [
        2425.0,
        558.0,
        50.0
      ],
      [
        2150.0,
        560.0,
        60.0
      ],
      [
        1961.616455078125,
        566.3333740234375,
        55.0
      ],
      [
        1955.484130859375,
        560.0,
        55.0
      ],
      [
        2150.0,
        566.3333740234375,
        55.0
      ],
      [
        2150.0,
        560.0,
        55.0
      ],
      [
        2530.0,
        566.3333740234375,
        55.0
      ],
      [
        2530.0,
        560.0,
        60.0
      ],
      [
        2532.0,
        560.0,
        60.0
      ],
      [
        2532.0,
        565.0,
        60.0
      ],
      [
        2532.0,
        565.0,
        60.0
      ],
      [
        2530.0,
        565.0,
        60.0
      ],
      [
        2150.0,
        450.0,
        60.0
      ],
      [
        2150.0,
        500.0,
        60.0
      ],
      [
        2150.0,
        500.0,
        -60.0
      ],
      [
        1763.3565673828125,
        397.1375732421875,
        60.0
      ],
      [
        1763.3565673828125,
        500.0,
        60.0
      ],
      [
        1764.29443359375,
        500.0,
        56.5
      ],
      [
        1764.29443359375,
        396.0545654296875,
        56.5
      ],
      [
        1916.6434326171875,
        411.6748352050781,
        60.0
      ],
      [
        1916.6434326171875,
        500.0,
        60.0
      ],
      [
        1915.70556640625,
        500.0,
        56.5
      ],
      [
        1915.70556640625,
        410.4139404296875,
        56.5
      ],
      [
        2665.0,
        480.9725341796875,
        55.0
      ],
      [
        2654.7451171875,
        480.0,
        55.0
      ],
      [
        2425.0,
        500.0,
        55.0
      ],
      [
        2425.0,
        458.2117004394531,
        55.0
      ],
      [
        2400.0,
        455.84075927734375,
        55.0
      ],
      [
        2400.0,
        500.0,
        55.0
      ],
      [
        2520.0,
        500.0,
        55.0
      ],
      [
        2520.0,
        467.22119140625,
        55.0
      ],
      [
        2495.0,
        464.85028076171875,
        55.0
      ],
      [
        2495.0,
        500.0,
        55.0
      ],
      [
        2590.0,
        500.0,
        55.0
      ],
      [
        2590.0,
        473.8597717285156,
        55.0
      ],
      [
        2540.0,
        469.117919921875,
        55.0
      ],
      [
        2540.0,
        500.0,
        55.0
      ],
      [
        2425.0,
        458.211669921875,
        55.0
      ],
      [
        2425.0,
        500.0,
        55.0
      ],
      [
        2425.0,
        500.0,
        50.0
      ],
      [
        2425.0,
        456.5375671386719,
        50.0
      ],
      [
        2530.0,
        500.0,
        55.0
      ],
      [
        2530.0,
        500.0,
        50.0
      ],
      [
        2530.0,
        466.49542236328125,
        50.0
      ],
      [
        2530.0,
        468.1695556640625,
        55.0
      ],
      [
        2400.0,
        457.514892578125,
        60.0
      ],
      [
        2400.0,
        500.0,
        60.0
      ],
      [
        2400.0,
        500.0,
        55.0
      ],
      [
        2400.0,
        455.84075927734375,
        55.0
      ],
      [
        2530.0,
        469.84368896484375,
        60.0
      ],
      [
        2530.0,
        500.0,
        60.0
      ],
      [
        1763.3565673828125,
        534.8547973632812,
        60.0
      ],
      [
        1763.3565673828125,
        530.6475219726562,
        60.0
      ],
      [
        1763.3565673828125,
        530.6475219726562,
        60.0
      ],
      [
        1916.6434326171875,
        534.8547973632812,
        60.0
      ],
      [
        1916.6434326171875,
        530.6475219726562,
        60.0
      ],
      [
        1916.6434326171875,
        530.6475219726562,
        60.0
      ],
      [
        2419.999755859375,
        500.0,
        55.0
      ],
      [
        2419.999755859375,
        559.0,
        55.0
      ],
      [
        2400.0,
        540.0,
        60.0
      ],
      [
        2530.0,
        500.0,
        55.0
      ],
      [
        2530.0,
        540.0,
        60.0
      ],
      [
        2520.0,
        540.0,
        60.0
      ],
      [
        2530.0,
        540.0,
        60.0
      ],
      [
        2532.0,
        535.0,
        60.0
      ],
      [
        2532.0,
        540.0,
        60.0
      ],
      [
        2532.0,
        540.0,
        60.0
      ],
      [
        2530.0,
        540.0,
        60.0
      ],
      [
        2608.0,
        548.5,
        60.0
      ],
      [
        2608.0,
        551.5,
        60.0
      ],
      [
        2608.0,
        551.5,
        60.0
      ],
      [
        2605.0,
        551.5,
        60.0
      ],
      [
        2648.0,
        548.5,
        60.0
      ],
      [
        2648.0,
        551.5,
        60.0
      ],
      [
        2648.0,
        551.5,
        60.0
      ],
      [
        2645.0,
        551.5,
        60.0
      ],
      [
        -1431.1385498046875,
        75.96923065185547,
        9.346118927001953
      ],
      [
        -1456.4737548828125,
        83.74275207519531,
        59.999996185302734
      ],
      [
        2425.0,
        450.845458984375,
        55.0
      ],
      [
        2416.085205078125,
        450.0,
        55.0
      ],
      [
        2520.0,
        459.8549499511719,
        55.0
      ],
      [
        2495.0,
        457.4840393066406,
        55.0
      ],
      [
        2590.0,
        466.4935302734375,
        55.0
      ],
      [
        2540.0,
        461.7516784667969,
        55.0
      ],
      [
        2530.0,
        468.1695556640625,
        55.0
      ],
      [
        2530.0,
        459.7988586425781,
        50.0
      ],
      [
        2530.0,
        460.8033447265625,
        55.0
      ],
      [
        2425.0,
        450.0,
        50.791526794433594
      ],
      [
        2425.0,
        450.845458984375,
        55.0
      ],
      [
        2530.0,
        461.8078308105469,
        60.0
      ],
      [
        1916.6434326171875,
        403.6389465332031,
        60.0
      ],
      [
        1915.70556640625,
        402.8468933105469,
        56.5
      ],
      [
        1763.3565673828125,
        389.1016845703125,
        60.0
      ],
      [
        1764.29443359375,
        388.48748779296875,
        56.5
      ],
      [
        2400.0,
        450.0,
        60.0
      ],
      [
        1763.3565673828125,
        -4.854816436767578,
        60.0
      ],
      [
        1763.3565673828125,
        -0.6475386619567871,
        60.0
      ],
      [
        1763.3565673828125,
        -454.8548278808594,
        60.0
      ],
      [
        1763.3565673828125,
        -450.6475524902344,
        60.0
      ],
      [
        1763.3565673828125,
        84.85485076904297,
        60.0
      ],
      [
        1763.3565673828125,
        80.64755249023438,
        60.0
      ],
      [
        1763.3565673828125,
        -365.1451416015625,
        60.0
      ],
      [
        1763.3565673828125,
        -369.3524169921875,
        60.0
      ],
      [
        1763.3565673828125,
        -0.64752197265625,
        60.0
      ],
      [
        1763.3565673828125,
        -450.64752197265625,
        60.0
      ],
      [
        1763.3565673828125,
        80.64756774902344,
        60.0
      ],
      [
        1763.3565673828125,
        -369.3524169921875,
        60.0
      ],
      [
        1763.3565673828125,
        -626.900634765625,
        60.0
      ],
      [
        -1530.8154296875,
        -25.748764038085938,
        60.000003814697266
      ],
      [
        1916.6434326171875,
        -4.854816436767578,
        60.0
      ],
      [
        1916.6434326171875,
        -0.6475386619567871,
        60.0
      ],
      [
        1916.6434326171875,
        -454.8548278808594,
        60.0
      ],
      [
        1916.6434326171875,
        -450.6475524902344,
        60.0
      ],
      [
        1916.6434326171875,
        84.85485076904297,
        60.0
      ],
      [
        1916.6434326171875,
        80.64755249023438,
        60.0
      ],
      [
        1916.6434326171875,
        -365.1451416015625,
        60.0
      ],
      [
        1916.6434326171875,
        -369.3524475097656,
        60.0
      ],
      [
        1916.6434326171875,
        -0.64752197265625,
        60.0
      ],
      [
        1916.6434326171875,
        -450.64752197265625,
        60.0
      ],
      [
        1916.6434326171875,
        80.64756774902344,
        60.0
      ],
      [
        1916.6434326171875,
        -369.3524169921875,
        60.0
      ],
      [
        1916.6434326171875,
        -633.6446533203125,
        60.0
      ],
      [
        1915.70556640625,
        -471.0,
        56.5
      ],
      [
        1915.70556640625,
        -430.5,
        56.5
      ],
      [
        1915.70556640625,
        -21.0,
        56.5
      ],
      [
        1915.70556640625,
        19.5,
        56.5
      ],
      [
        1915.70556640625,
        -389.5,
        56.5
      ],
      [
        1915.70556640625,
        -349.0,
        56.5
      ],
      [
        1915.70556640625,
        60.5,
        56.5
      ],
      [
        1915.70556640625,
        101.0,
        56.5
      ],
      [
        1900.9378662109375,
        -9.215412139892578,
        60.0
      ],
      [
        1916.6434326171875,
        -4.8548173904418945,
        60.0
      ],
      [
        1916.6434326171875,
        84.85485076904297,
        60.0
      ],
      [
        1900.9378662109375,
        89.21544647216797,
        60.0
      ],
      [
        1916.6434326171875,
        -365.1451416015625,
        60.0
      ],
      [
        1900.9378662109375,
        -360.7845458984375,
        60.0
      ],
      [
        1900.9378662109375,
        -459.2154235839844,
        60.0
      ],
      [
        1916.6434326171875,
        -454.8548278808594,
        60.0
      ],
      [
        2857.43701171875,
        268.1971435546875,
        60.000003814697266
      ],
      [
        2857.43701171875,
        231.8031005859375,
        59.999996185302734
      ],
      [
        2868.0,
        287.0949401855469,
        60.0
      ],
      [
        2868.0,
        250.0,
        60.0
      ],
      [
        2868.0,
        250.0,
        60.0
      ],
      [
        2868.0,
        212.90505981445312,
        60.000003814697266
      ],
      [
        2868.0,
        322.5,
        60.00000762939453
      ],
      [
        2868.0,
        287.0949401855469,
        60.000003814697266
      ],
      [
        2868.0,
        212.90505981445312,
        60.0
      ],
      [
        2868.0,
        177.5,
        60.000003814697266
      ],
      [
        2868.0,
        177.5,
        60.0
      ],
      [
        2918.0,
        177.5,
        60.0
      ],
      [
        2857.5595703125,
        240.93533325195312,
        60.0
      ],
      [
        2868.0,
        237.91893005371094,
        60.0
      ],
      [
        2857.559814453125,
        250.00013732910156,
        60.000003814697266
      ],
      [
        2857.559814453125,
        259.0649719238281,
        60.0
      ],
      [
        2857.5595703125,
        240.93533325195312,
        60.0
      ],
      [
        2857.559814453125,
        250.00013732910156,
        60.000003814697266
      ],
      [
        2530.0,
        450.0,
        55.0
      ],
      [
        2530.0,
        460.8033447265625,
        55.0
      ],
      [
        2530.0,
        450.0,
        60.0
      ],
      [
        2970.2587890625,
        -680.0,
        60.000003814697266
      ],
      [
        3250.0,
        -680.0,
        60.0
      ],
      [
        2918.0,
        -277.5,
        60.0
      ],
      [
        2918.0,
        -122.5,
        60.0
      ],
      [
        2857.43701171875,
        -331.8028564453125,
        60.000003814697266
      ],
      [
        2857.43701171875,
        -368.1968994140625,
        59.999996185302734
      ],
      [
        2857.43701171875,
        -31.8028621673584,
        60.000003814697266
      ],
      [
        2857.43701171875,
        -68.1968994140625,
        59.999996185302734
      ],
      [
        2868.0,
        -312.9050598144531,
        60.0
      ],
      [
        2868.0,
        -350.0,
        60.0
      ],
      [
        2868.0,
        -350.0,
        60.0
      ],
      [
        2868.0,
        -387.0949401855469,
        60.000003814697266
      ],
      [
        2868.0,
        -87.0949478149414,
        60.0
      ],
      [
        2868.0,
        -122.5,
        60.000003814697266
      ],
      [
        2868.0,
        22.5,
        60.00000762939453
      ],
      [
        2868.0,
        -12.90505599975586,
        60.000003814697266
      ],
      [
        2868.0,
        -277.5,
        60.00000762939453
      ],
      [
        2868.0,
        -312.9050598144531,
        60.000003814697266
      ],
      [
        2868.0,
        -387.0949401855469,
        60.0
      ],
      [
        2868.0,
        -422.5,
        60.000003814697266
      ],
      [
        2868.0,
        -122.5,
        60.0
      ],
      [
        2918.0,
        -122.5,
        60.0
      ],
      [
        2918.0,
        22.5,
        60.0
      ],
      [
        2868.0,
        22.5,
        60.000003814697266
      ],
      [
        2918.0,
        -277.5,
        60.0
      ],
      [
        2868.0,
        -277.5,
        60.000003814697266
      ],
      [
        2857.5595703125,
        -59.064659118652344,
        60.0
      ],
      [
        2868.0,
        -62.08106994628906,
        60.0
      ],
      [
        2857.559814453125,
        -40.9350471496582,
        60.0
      ],
      [
        2868.000244140625,
        -37.91912078857422,
        60.0
      ],
      [
        2857.559814453125,
        -49.9998664855957,
        60.000003814697266
      ],
      [
        2857.559814453125,
        -40.9350471496582,
        60.0
      ],
      [
        2857.5595703125,
        -59.064659118652344,
        60.0
      ],
      [
        2857.559814453125,
        -49.9998664855957,
        60.000003814697266
      ],
      [
        2857.559814453125,
        -340.93505859375,
        60.0
      ],
      [
        2868.000244140625,
        -337.91912841796875,
        60.0
      ],
      [
        2857.559814453125,
        -349.9998779296875,
        60.000003814697266
      ],
      [
        2857.559814453125,
        -340.93505859375,
        60.0
      ],
      [
        2857.5595703125,
        -359.0646667480469,
        60.0
      ],
      [
        2857.559814453125,
        -349.9998779296875,
        60.000003814697266
      ],
      [
        1740.5809326171875,
        442.7949523925781,
        145.0
      ],
      [
        1740.5809326171875,
        356.86663818359375,
        145.0
      ],
      [
        1740.5809326171875,
        87.20508575439453,
        145.0
      ],
      [
        1740.5809326171875,
        173.1333465576172,
        145.0
      ],
      [
        1740.5809326171875,
        -362.794921875,
        145.0
      ],
      [
        1740.5809326171875,
        -276.8666687011719,
        145.0
      ],
      [
        1740.5809326171875,
        -7.205051422119141,
        145.0
      ],
      [
        1740.5809326171875,
        -93.13333892822266,
        145.0
      ],
      [
        1740.5809326171875,
        -457.2050476074219,
        145.0
      ],
      [
        1740.5809326171875,
        -543.13330078125,
        145.0
      ],
      [
        1740.5809326171875,
        173.13336181640625,
        145.0
      ],
      [
        1740.5809326171875,
        356.86663818359375,
        145.0
      ],
      [
        1740.5809326171875,
        -276.86663818359375,
        145.0
      ],
      [
        1740.5809326171875,
        -93.13333129882812,
        145.0
      ],
      [
        1740.5809326171875,
        -543.13330078125,
        145.0
      ],
      [
        1740.5809326171875,
        -625.8985595703125,
        145.0
      ],
      [
        1845.0,
        -408.0,
        185.0
      ],
      [
        1749.4000244140625,
        -408.0,
        145.0
      ],
      [
        1845.0,
        -408.0,
        145.0
      ],
      [
        1749.4000244140625,
        -408.0,
        112.0872573852539
      ],
      [
        1749.42333984375,
        -408.0,
        112.0
      ],
      [
        1845.0,
        560.0,
        110.0
      ],
      [
        1845.0,
        470.0,
        110.0
      ],
      [
        1845.0,
        -408.0,
        112.0
      ],
      [
        1850.0,
        560.0,
        110.0
      ],
      [
        1850.0,
        470.0,
        110.0
      ],
      [
        1850.0,
        -408.0,
        185.0
      ],
      [
        1850.0,
        -408.0,
        112.0
      ],
      [
        1935.37890625,
        474.21392822265625,
        129.92213439941406
      ],
      [
        1935.3790283203125,
        387.69244384765625,
        129.92242431640625
      ],
      [
        1935.37890625,
        55.7861328125,
        129.92214965820312
      ],
      [
        1935.3790283203125,
        142.3075408935547,
        129.92242431640625
      ],
      [
        1935.37890625,
        -394.2138671875,
        129.92214965820312
      ],
      [
        1935.3790283203125,
        -307.6924743652344,
        129.92242431640625
      ],
      [
        1935.37890625,
        24.213926315307617,
        129.92213439941406
      ],
      [
        1935.3790283203125,
        -62.307533264160156,
        129.92242431640625
      ],
      [
        1935.37890625,
        -425.78607177734375,
        129.92213439941406
      ],
      [
        1935.3790283203125,
        -512.3075561523438,
        129.92242431640625
      ],
      [
        1935.3790283203125,
        142.3075408935547,
        129.92242431640625
      ],
      [
        1935.3790283203125,
        387.69244384765625,
        129.92242431640625
      ],
      [
        1935.3790283203125,
        -307.69244384765625,
        129.92242431640625
      ],
      [
        1935.3790283203125,
        -62.307525634765625,
        129.92242431640625
      ],
      [
        1935.3790283203125,
        -512.3074951171875,
        129.92242431640625
      ],
      [
        1935.3790283203125,
        -634.4689331054688,
        129.9224853515625
      ],
      [
        1910.0,
        670.0,
        99.86825561523438
      ],
      [
        1910.0,
        720.0,
        99.86825561523438
      ],
      [
        1910.0,
        560.0,
        110.0
      ],
      [
        1910.0,
        470.0,
        110.0
      ],
      [
        1910.0,
        -408.0,
        185.0
      ],
      [
        1910.0,
        -408.0,
        112.0
      ],
      [
        1934.3851318359375,
        27.132080078125,
        128.74533081054688
      ],
      [
        1935.37890625,
        24.21392822265625,
        129.92214965820312
      ],
      [
        1934.3851318359375,
        -397.13201904296875,
        128.74533081054688
      ],
      [
        1935.37890625,
        -394.2138671875,
        129.92213439941406
      ],
      [
        1934.3851318359375,
        27.132080078125,
        128.74533081054688
      ],
      [
        1912.3736572265625,
        53.262367248535156,
        102.67929077148438
      ],
      [
        1912.3736572265625,
        -423.2623291015625,
        102.67928314208984
      ],
      [
        1934.3851318359375,
        -397.13201904296875,
        128.74533081054688
      ],
      [
        1912.3736572265625,
        26.737680435180664,
        102.67928314208984
      ],
      [
        1916.5921630859375,
        40.000022888183594,
        118.42277526855469
      ],
      [
        1923.5455322265625,
        40.000030517578125,
        115.90901947021484
      ],
      [
        1916.592041015625,
        -409.9999694824219,
        118.42277526855469
      ],
      [
        1912.3736572265625,
        -396.7376403808594,
        102.67929077148438
      ],
      [
        1923.5455322265625,
        -409.99993896484375,
        115.90899658203125
      ],
      [
        1910.0,
        -408.0,
        118.20184326171875
      ],
      [
        1920.2445068359375,
        -408.0,
        112.0
      ],
      [
        1921.8607177734375,
        -408.0,
        113.91397857666016
      ],
      [
        1910.0,
        -408.0,
        123.40996551513672
      ],
      [
        1925.230224609375,
        -408.0,
        117.90406036376953
      ],
      [
        1910.0,
        -408.0,
        131.8402557373047
      ],
      [
        1930.5999755859375,
        -408.0,
        124.26303100585938
      ],
      [
        1930.5999755859375,
        -408.0,
        124.39309692382812
      ],
      [
        1918.3284912109375,
        -415.458984375,
        124.90309143066406
      ],
      [
        1928.14404296875,
        -415.4589538574219,
        121.3545913696289
      ],
      [
        1930.5999755859375,
        -408.0,
        124.39309692382812
      ],
      [
        1930.5999755859375,
        -408.0,
        124.26303100585938
      ],
      [
        1930.5999755859375,
        -408.2470703125,
        124.26303100585938
      ],
      [
        1918.3284912109375,
        45.45903396606445,
        124.903076171875
      ],
      [
        1928.14404296875,
        45.459007263183594,
        121.35456848144531
      ],
      [
        1927.2296142578125,
        -473.76348876953125,
        158.12271118164062
      ],
      [
        1934.3851318359375,
        -422.867919921875,
        128.74533081054688
      ],
      [
        1935.37890625,
        -425.78607177734375,
        129.92214965820312
      ],
      [
        1941.5482177734375,
        -473.763427734375,
        152.94630432128906
      ],
      [
        1934.3851318359375,
        -422.867919921875,
        128.74533081054688
      ],
      [
        1930.5999755859375,
        -412.0,
        124.26303100585938
      ],
      [
        1930.5999755859375,
        -412.0,
        124.39302062988281
      ],
      [
        1930.5999755859375,
        -411.7530517578125,
        124.26303100585938
      ],
      [
        1910.0,
        -408.0,
        173.591064453125
      ],
      [
        1930.5999755859375,
        -408.0,
        166.14385986328125
      ],
      [
        1930.5999755859375,
        -412.0,
        165.5819091796875
      ],
      [
        1930.5999755859375,
        -408.0,
        166.14385986328125
      ],
      [
        1934.3851318359375,
        52.86798095703125,
        128.74533081054688
      ],
      [
        1927.2296142578125,
        103.76337432861328,
        158.12265014648438
      ],
      [
        1941.5482177734375,
        103.76325988769531,
        152.9462127685547
      ],
      [
        1935.37890625,
        55.7861328125,
        129.92213439941406
      ],
      [
        1910.0,
        490.6123046875,
        110.0
      ],
      [
        1918.0106201171875,
        470.0,
        110.0
      ],
      [
        1934.3851318359375,
        52.86798095703125,
        128.74533081054688
      ],
      [
        1930.5999755859375,
        -412.0,
        166.14385986328125
      ],
      [
        1930.5999755859375,
        -410.0,
        165.86288452148438
      ],
      [
        1934.3851318359375,
        477.132080078125,
        128.74533081054688
      ],
      [
        1935.37890625,
        474.21392822265625,
        129.92214965820312
      ],
      [
        1910.0,
        529.4911499023438,
        110.0
      ],
      [
        1918.5555419921875,
        470.0,
        110.0
      ],
      [
        1918.5555419921875,
        523.615234375,
        110.0
      ],
      [
        1918.5555419921875,
        560.0,
        110.0
      ],
      [
        1935.0,
        720.0,
        129.4736328125
      ],
      [
        1935.0,
        720.0,
        131.95767211914062
      ],
      [
        1935.814697265625,
        720.814697265625,
        131.54867553710938
      ],
      [
        1935.37890625,
        720.37890625,
        129.92236328125
      ],
      [
        1951.1846923828125,
        785.0,
        188.91029357910156
      ],
      [
        1951.1846923828125,
        795.0,
        188.91029357910156
      ],
      [
        1938.0792236328125,
        723.0792846679688,
        140.0
      ],
      [
        1943.888916015625,
        728.888916015625,
        140.0
      ],
      [
        2974.532958984375,
        1830.0,
        140.0
      ],
      [
        3228.21484375,
        1830.0,
        451.8016357421875
      ],
      [
        3250.0,
        -680.0,
        365.8627624511719
      ],
      [
        3001.150390625,
        -680.0,
        60.000003814697266
      ],
      [
        2955.164306640625,
        668.6527709960938,
        64.04167175292969
      ],
      [
        2955.164306640625,
        668.6527709960938,
        64.04167175292969
      ],
      [
        2951.84716796875,
        669.4458618164062,
        60.0
      ],
      [
        2950.0,
        720.0008544921875,
        60.0
      ],
      [
        2950.0,
        725.0,
        60.22446060180664
      ],
      [
        2950.0,
        725.0,
        60.22446060180664
      ],
      [
        2949.8173828125,
        725.0,
        60.0
      ],
      [
        2975.79443359375,
        250.0,
        70.59814453125
      ],
      [
        2997.292236328125,
        271.21319580078125,
        97.97368621826172
      ],
      [
        2999.4189453125,
        228.78680419921875,
        98.68264770507812
      ],
      [
        2975.79443359375,
        250.0,
        70.59814453125
      ],
      [
        2990.833984375,
        -50.0,
        75.61128997802734
      ],
      [
        3012.33154296875,
        -28.78680419921875,
        102.98681640625
      ],
      [
        3014.458740234375,
        -71.21319580078125,
        103.69584655761719
      ],
      [
        2990.833984375,
        -50.0,
        75.61129760742188
      ],
      [
        3005.873291015625,
        -350.0,
        80.62444305419922
      ],
      [
        3027.37109375,
        -328.78680419921875,
        108.00003051757812
      ],
      [
        3005.873291015625,
        -350.0,
        80.62443542480469
      ],
      [
        3029.498046875,
        -371.21319580078125,
        108.708984375
      ],
      [
        3081.39794921875,
        -320.0,
        174.79934692382812
      ],
      [
        3027.37109375,
        -328.78680419921875,
        108.00003051757812
      ],
      [
        3029.498046875,
        -371.21319580078125,
        108.70899200439453
      ],
      [
        3084.40576171875,
        -380.0,
        175.8019561767578
      ],
      [
        3024.7119140625,
        -331.41094970703125,
        104.61357116699219
      ],
      [
        3026.57568359375,
        -368.58905029296875,
        105.23483276367188
      ],
      [
        3100.0,
        -368.58905029296875,
        129.70962524414062
      ],
      [
        3100.0,
        -331.41094970703125,
        129.70962524414062
      ],
      [
        3029.498046875,
        -371.21319580078125,
        108.70899200439453
      ],
      [
        3027.37109375,
        -328.78680419921875,
        108.00003051757812
      ],
      [
        3027.37109375,
        -328.78680419921875,
        108.00003051757812
      ],
      [
        3029.498046875,
        -371.21319580078125,
        108.708984375
      ],
      [
        3100.0,
        -322.9768371582031,
        197.5293731689453
      ],
      [
        3100.0,
        -377.46380615234375,
        195.08262634277344
      ],
      [
        3100.0,
        -322.9768371582031,
        197.5293731689453
      ],
      [
        3081.39794921875,
        -320.0,
        174.79934692382812
      ],
      [
        3084.40576171875,
        -380.0,
        175.8019561767578
      ],
      [
        3100.0,
        -377.46380615234375,
        195.08262634277344
      ],
      [
        3009.672119140625,
        -31.41094970703125,
        99.60034942626953
      ],
      [
        3011.535888671875,
        -68.58905029296875,
        100.22161102294922
      ],
      [
        3100.0,
        -68.58905029296875,
        129.70962524414062
      ],
      [
        3100.0,
        -31.410951614379883,
        129.70962524414062
      ],
      [
        3014.458740234375,
        -71.21319580078125,
        103.69584655761719
      ],
      [
        3012.33154296875,
        -28.78680419921875,
        102.98681640625
      ],
      [
        3012.33154296875,
        -28.78680419921875,
        102.98681640625
      ],
      [
        3014.458740234375,
        -71.21319580078125,
        103.69584655761719
      ],
      [
        3066.358642578125,
        -20.0,
        169.78619384765625
      ],
      [
        3012.33154296875,
        -28.78680419921875,
        102.98681640625
      ],
      [
        3014.458740234375,
        -71.21319580078125,
        103.69584655761719
      ],
      [
        3069.366455078125,
        -80.0,
        170.78878784179688
      ],
      [
        3100.0,
        -25.383586883544922,
        210.89337158203125
      ],
      [
        3100.0,
        -75.01785278320312,
        208.66429138183594
      ],
      [
        3100.0,
        -25.383586883544922,
        210.89337158203125
      ],
      [
        3066.358642578125,
        -20.0,
        169.78619384765625
      ],
      [
        3069.366455078125,
        -80.0,
        170.78878784179688
      ],
      [
        3100.0,
        -75.01785278320312,
        208.66429138183594
      ],
      [
        2994.6328125,
        268.58905029296875,
        94.58720397949219
      ],
      [
        2996.49658203125,
        231.41094970703125,
        95.20846557617188
      ],
      [
        3100.0,
        231.41094970703125,
        129.70962524414062
      ],
      [
        3100.0,
        268.58905029296875,
        129.70962524414062
      ],
      [
        2999.4189453125,
        228.78680419921875,
        98.68264770507812
      ],
      [
        2997.292236328125,
        271.21319580078125,
        97.97368621826172
      ],
      [
        2997.292236328125,
        271.21319580078125,
        97.97368621826172
      ],
      [
        2999.4189453125,
        228.78680419921875,
        98.68264770507812
      ],
      [
        3051.319091796875,
        280.0,
        164.77304077148438
      ],
      [
        2997.292236328125,
        271.21319580078125,
        97.97368621826172
      ],
      [
        2999.4189453125,
        228.78680419921875,
        98.68264770507812
      ],
      [
        3054.326904296875,
        220.0,
        165.77565002441406
      ],
      [
        3100.0,
        272.2096862792969,
        224.2572479248047
      ],
      [
        3100.0,
        227.42816162109375,
        222.2462921142578
      ],
      [
        3100.0,
        272.2096862792969,
        224.2572479248047
      ],
      [
        3051.319091796875,
        280.0,
        164.77304077148438
      ],
      [
        3054.326904296875,
        220.0,
        165.77565002441406
      ],
      [
        3100.0,
        227.42816162109375,
        222.2462921142578
      ],
      [
        2939.536376953125,
        1830.0,
        140.0
      ],
      [
        3211.685546875,
        1830.0,
        440.3029479980469
      ],
      [
        2950.0,
        725.0,
        60.412349700927734
      ],
      [
        2950.0,
        725.0,
        60.412349700927734
      ],
      [
        2949.626220703125,
        725.0,
        60.0
      ],
      [
        3141.666748046875,
        670.0,
        293.3333435058594
      ],
      [
        3100.0,
        670.0,
        500.0
      ],
      [
        3072.071044921875,
        670.0,
        500.0
      ],
      [
        3100.0,
        670.0,
        500.0
      ],
      [
        3138.431396484375,
        670.0,
        500.0
      ],
      [
        3072.071044921875,
        670.0,
        500.0
      ],
      [
        3072.071044921875,
        670.0,
        540.0
      ],
      [
        3136.3603515625,
        675.0,
        540.0
      ],
      [
        3138.431396484375,
        670.0,
        540.0
      ],
      [
        3138.431396484375,
        670.0,
        500.0
      ],
      [
        3136.3603515625,
        675.0,
        500.0
      ],
      [
        2905.0,
        760.5,
        60.0
      ],
      [
        2905.0,
        800.5,
        64.0
      ],
      [
        2950.0,
        725.0,
        60.5
      ],
      [
        2944.4443359375,
        725.0,
        60.0
      ],
      [
        3170.0,
        -388.6426086425781,
        540.0
      ],
      [
        3170.0,
        -388.642578125,
        525.0
      ],
      [
        3170.0,
        -388.642578125,
        515.0
      ],
      [
        3170.0,
        -388.6426086425781,
        500.0
      ],
      [
        3170.0,
        -388.642578125,
        515.0
      ],
      [
        3170.0,
        -388.642578125,
        525.0
      ],
      [
        3170.0,
        -388.6426696777344,
        650.0
      ],
      [
        3170.0,
        -388.6426086425781,
        540.0
      ],
      [
        3192.0,
        -379.41607666015625,
        500.0
      ],
      [
        3192.0,
        -430.0,
        500.0
      ],
      [
        3172.0,
        -430.0,
        500.0
      ],
      [
        3172.0,
        -387.80389404296875,
        500.0
      ],
      [
        3170.0,
        -388.6426696777344,
        500.0
      ],
      [
        3172.0,
        -387.80389404296875,
        500.0
      ],
      [
        3172.0,
        -429.9999694824219,
        500.0
      ],
      [
        3170.0,
        -429.9999694824219,
        500.0
      ],
      [
        3250.0,
        -355.0914001464844,
        500.0
      ],
      [
        3250.0,
        -430.0,
        500.0
      ],
      [
        3192.0,
        -430.0,
        500.0
      ],
      [
        3192.0,
        -379.41607666015625,
        500.0
      ],
      [
        3105.0,
        -415.9030456542969,
        500.0
      ],
      [
        3128.61279296875,
        -430.0,
        500.0
      ],
      [
        3128.61279296875,
        -430.0,
        500.0
      ],
      [
        3104.768798828125,
        -420.0000305175781,
        550.0
      ],
      [
        3105.0,
        -415.9030456542969,
        500.0
      ],
      [
        3105.0,
        -420.0969543457031,
        549.51513671875
      ],
      [
        3105.0,
        -419.9999694824219,
        550.0
      ],
      [
        3105.0,
        -415.9030456542969,
        550.0
      ],
      [
        3168.34326171875,
        -389.33734130859375,
        525.0
      ],
      [
        3168.34326171875,
        -389.33734130859375,
        528.0
      ],
      [
        3168.34326171875,
        -389.33734130859375,
        525.0
      ],
      [
        3168.34326171875,
        -389.33734130859375,
        520.0
      ],
      [
        3170.0,
        -388.64251708984375,
        520.0
      ],
      [
        3168.34326171875,
        -389.33734130859375,
        520.0
      ],
      [
        3170.0,
        -388.6425476074219,
        528.0
      ],
      [
        3168.34326171875,
        -389.33734130859375,
        528.0
      ],
      [
        3105.0,
        -582.096923828125,
        500.0
      ],
      [
        3250.0,
        -642.9086303710938,
        500.0
      ],
      [
        3105.0,
        -582.096923828125,
        500.0
      ],
      [
        3105.0,
        -582.096923828125,
        540.0
      ],
      [
        3074.5,
        -365.7805480957031,
        415.0
      ],
      [
        3070.0,
        -376.78057861328125,
        400.0
      ],
      [
        3100.0,
        -303.4482421875,
        500.0
      ],
      [
        3074.5,
        -365.7805480957031,
        415.0
      ],
      [
        3068.412353515625,
        -380.6615295410156,
        394.7076721191406
      ],
      [
        3172.0,
        -270.0,
        500.0
      ],
      [
        3192.0,
        -270.0,
        500.0
      ],
      [
        3170.0,
        -270.0,
        500.0
      ],
      [
        3172.0,
        -270.0,
        500.0
      ],
      [
        3170.0,
        -388.6426696777344,
        500.0
      ],
      [
        3250.0,
        -270.0,
        500.0
      ],
      [
        3192.0,
        -270.0,
        500.0
      ],
      [
        3105.0,
        -291.2268371582031,
        500.0
      ],
      [
        3111.57958984375,
        -275.14361572265625,
        500.0
      ],
      [
        3123.843994140625,
        -270.0,
        500.0
      ],
      [
        3076.86474609375,
        -360.0,
        415.0
      ],
      [
        3076.86474609375,
        -360.0,
        400.0
      ],
      [
        3068.682861328125,
        -380.0,
        170.56097412109375
      ],
      [
        3072.27734375,
        -371.21319580078125,
        220.5495147705078
      ],
      [
        3100.0,
        -360.0,
        240.47308349609375
      ],
      [
        3100.0,
        -360.0,
        195.86683654785156
      ],
      [
        3100.0,
        -360.0,
        240.47308349609375
      ],
      [
        3076.86474609375,
        -360.0,
        232.7613525390625
      ],
      [
        3072.27734375,
        -371.21319580078125,
        220.54953002929688
      ],
      [
        3069.64892578125,
        -377.63848876953125,
        157.77024841308594
      ],
      [
        3068.682861328125,
        -380.0,
        170.56097412109375
      ],
      [
        3076.86474609375,
        -360.0,
        400.0
      ],
      [
        3085.046875,
        -340.0,
        400.0
      ],
      [
        3089.63427734375,
        -328.78680419921875,
        226.33511352539062
      ],
      [
        3092.501708984375,
        -321.77691650390625,
        188.36724853515625
      ],
      [
        3089.63427734375,
        -328.78680419921875,
        226.33511352539062
      ],
      [
        3080.955810546875,
        -350.0,
        243.65194702148438
      ],
      [
        3080.955810546875,
        -350.0,
        243.65194702148438
      ],
      [
        3085.046630859375,
        -340.0,
        415.0
      ],
      [
        3076.86474609375,
        -360.0,
        415.0
      ],
      [
        3085.046875,
        -340.0,
        400.0
      ],
      [
        3085.046630859375,
        -340.0,
        415.0
      ],
      [
        3105.0,
        -291.2268371582031,
        500.0
      ],
      [
        3105.0,
        -415.9030456542969,
        516.667236328125
      ],
      [
        3105.0,
        -291.2268371582031,
        516.667236328125
      ],
      [
        3111.579345703125,
        -275.14373779296875,
        520.0
      ],
      [
        3111.579345703125,
        -275.14373779296875,
        525.0
      ],
      [
        3111.922119140625,
        -275.0,
        525.0
      ],
      [
        3114.306396484375,
        -274.0,
        520.0
      ],
      [
        3130.0,
        -356.2159729003906,
        528.0
      ],
      [
        3130.0,
        -356.2159729003906,
        525.0
      ],
      [
        3130.0,
        -343.7840270996094,
        528.0
      ],
      [
        3130.0,
        -343.7840270996094,
        525.0
      ],
      [
        3111.579345703125,
        -275.14373779296875,
        525.7186889648438
      ],
      [
        3123.843994140625,
        -270.0,
        500.0
      ],
      [
        3111.579345703125,
        -275.14373779296875,
        500.0
      ],
      [
        3170.95751953125,
        -130.0,
        500.0
      ],
      [
        3183.23046875,
        -100.0,
        650.0
      ],
      [
        3224.140380859375,
        0.0,
        650.0
      ],
      [
        3236.413330078125,
        30.0,
        500.0
      ],
      [
        3192.0,
        -78.56396484375,
        500.0
      ],
      [
        3192.0,
        -130.00001525878906,
        500.0
      ],
      [
        3172.0,
        -130.0,
        500.0
      ],
      [
        3172.0,
        -127.45208740234375,
        500.0
      ],
      [
        3172.0,
        -127.45208740234375,
        500.0
      ],
      [
        3172.0,
        -130.0,
        500.0
      ],
      [
        3170.95751953125,
        -130.0,
        500.0
      ],
      [
        3250.0,
        30.0,
        500.0
      ],
      [
        3250.0,
        -130.0,
        500.0
      ],
      [
        3192.0,
        -130.0,
        500.0
      ],
      [
        3192.0,
        -78.56396484375,
        500.0
      ],
      [
        3236.413330078125,
        29.999996185302734,
        500.0
      ],
      [
        3250.0,
        63.21173095703125,
        500.0
      ],
      [
        3242.02783203125,
        43.72439193725586,
        500.0
      ],
      [
        3242.02783203125,
        43.72439193725586,
        500.0
      ],
      [
        3166.160888671875,
        -141.724365234375,
        500.0
      ],
      [
        3161.36474609375,
        -153.44818115234375,
        500.0
      ],
      [
        3166.1611328125,
        -141.724365234375,
        500.0
      ],
      [
        3161.36474609375,
        -153.44818115234375,
        500.0
      ],
      [
        3161.36474609375,
        -153.44818115234375,
        550.0
      ],
      [
        3111.579345703125,
        -275.14373779296875,
        538.5979614257812
      ],
      [
        3115.0,
        -273.70916748046875,
        550.0
      ],
      [
        3105.0,
        -291.2268371582031,
        550.0
      ],
      [
        3100.0,
        -303.4482421875,
        500.0
      ],
      [
        3100.0,
        -303.4482421875,
        550.0
      ],
      [
        3070.72802734375,
        -375.0,
        430.0
      ],
      [
        3070.728271484375,
        -375.0,
        402.4276123046875
      ],
      [
        3111.579345703125,
        -275.14373779296875,
        550.0
      ],
      [
        3170.0,
        290.6427307128906,
        525.0
      ],
      [
        3170.0,
        290.64276123046875,
        540.0
      ],
      [
        3170.0,
        290.6427307128906,
        515.0
      ],
      [
        3170.0,
        290.64276123046875,
        500.0
      ],
      [
        3170.0,
        290.6427307128906,
        515.0
      ],
      [
        3170.0,
        290.6427307128906,
        525.0
      ],
      [
        3170.0,
        290.6427001953125,
        650.0
      ],
      [
        3170.0,
        290.64276123046875,
        540.0
      ],
      [
        3172.0,
        289.8038635253906,
        500.0
      ],
      [
        3172.0,
        330.0,
        500.0
      ],
      [
        3192.0,
        330.0,
        500.0
      ],
      [
        3192.0,
        281.416015625,
        500.0
      ],
      [
        3170.0,
        330.0,
        500.0
      ],
      [
        3172.0,
        330.0,
        500.0
      ],
      [
        3172.0,
        289.8038635253906,
        500.0
      ],
      [
        3170.0,
        290.64263916015625,
        500.0
      ],
      [
        3192.0,
        281.416015625,
        500.0
      ],
      [
        3192.0,
        330.0,
        500.0
      ],
      [
        3250.0,
        330.0,
        500.0
      ],
      [
        3250.0,
        257.0914306640625,
        500.0
      ],
      [
        3105.0,
        317.9030456542969,
        500.0
      ],
      [
        3123.843994140625,
        330.0,
        500.0
      ],
      [
        3123.843994140625,
        330.0,
        500.0
      ],
      [
        3105.0,
        317.9030456542969,
        500.0
      ],
      [
        3105.0,
        317.9030456542969,
        550.0
      ],
      [
        3105.0,
        320.0,
        550.0
      ],
      [
        3105.0,
        322.0969543457031,
        539.5151977539062
      ],
      [
        3250.0,
        544.9085693359375,
        500.0
      ],
      [
        3105.0,
        484.0968933105469,
        500.0
      ],
      [
        3105.0,
        484.0968933105469,
        500.0
      ],
      [
        3105.0,
        484.0968933105469,
        540.0
      ],
      [
        3074.5,
        267.7804870605469,
        415.0
      ],
      [
        3070.0,
        278.78009033203125,
        400.0
      ],
      [
        3100.0,
        205.44822692871094,
        500.0
      ],
      [
        3074.5,
        267.7804870605469,
        415.0
      ],
      [
        3069.3984375,
        280.25067138671875,
        397.99456787109375
      ],
      [
        3192.0,
        170.0,
        500.0
      ],
      [
        3172.0,
        170.0,
        500.0
      ],
      [
        3170.0,
        290.64263916015625,
        500.0
      ],
      [
        3172.0,
        170.0,
        500.0
      ],
      [
        3170.0,
        170.0,
        500.0
      ],
      [
        3192.0,
        170.0,
        500.0
      ],
      [
        3250.0,
        170.0,
        500.0
      ],
      [
        3105.0,
        193.2262420654297,
        500.0
      ],
      [
        3128.613037109375,
        170.0,
        500.0
      ],
      [
        3111.579345703125,
        177.1437530517578,
        500.0
      ],
      [
        3077.27392578125,
        261.0,
        400.0
      ],
      [
        3077.27392578125,
        261.0,
        415.0
      ],
      [
        3073.095703125,
        271.21319580078125,
        220.822265625
      ],
      [
        3070.7744140625,
        276.8865966796875,
        188.54595947265625
      ],
      [
        3100.0,
        261.0,
        239.52040100097656
      ],
      [
        3073.095703125,
        271.21319580078125,
        220.82228088378906
      ],
      [
        3077.27392578125,
        261.0,
        231.94505310058594
      ],
      [
        3100.0,
        261.0,
        239.52040100097656
      ],
      [
        3100.0,
        261.0,
        223.7538604736328
      ],
      [
        3085.455810546875,
        241.0,
        400.0
      ],
      [
        3077.27392578125,
        261.0,
        400.0
      ],
      [
        3081.774169921875,
        250.0,
        243.92469787597656
      ],
      [
        3090.4521484375,
        228.78680419921875,
        226.60777282714844
      ],
      [
        3081.774169921875,
        250.0,
        243.92469787597656
      ],
      [
        3091.56884765625,
        226.0569610595703,
        211.82208251953125
      ],
      [
        3090.4521484375,
        228.78680419921875,
        226.60777282714844
      ],
      [
        3077.27392578125,
        261.0,
        415.0
      ],
      [
        3085.455810546875,
        241.0,
        415.0
      ],
      [
        3085.455810546875,
        241.0,
        415.0
      ],
      [
        3085.455810546875,
        241.0,
        400.0
      ],
      [
        3105.0,
        193.22625732421875,
        500.0
      ],
      [
        3105.0,
        193.22625732421875,
        516.667236328125
      ],
      [
        3105.0,
        317.9030456542969,
        516.667236328125
      ],
      [
        3119.075439453125,
        174.0,
        520.0
      ],
      [
        3116.69091796875,
        175.0,
        525.0
      ],
      [
        3111.579345703125,
        177.1437530517578,
        525.0
      ],
      [
        3111.579345703125,
        177.1437530517578,
        520.0
      ],
      [
        3130.0,
        243.7840118408203,
        528.0
      ],
      [
        3130.0,
        243.7840118408203,
        525.0
      ],
      [
        3130.0,
        256.2159729003906,
        528.0
      ],
      [
        3130.0,
        256.2159729003906,
        525.0
      ],
      [
        3111.579345703125,
        177.1437530517578,
        535.7188110351562
      ],
      [
        3111.579345703125,
        177.1437530517578,
        500.0
      ],
      [
        3128.613037109375,
        170.0,
        500.0
      ],
      [
        3184.048583984375,
        0.0,
        650.0
      ],
      [
        3171.77587890625,
        30.0,
        500.0
      ],
      [
        3172.0,
        29.451997756958008,
        500.0
      ],
      [
        3172.0,
        30.0,
        500.0
      ],
      [
        3192.0,
        29.999998092651367,
        500.0
      ],
      [
        3192.0,
        -19.436433792114258,
        500.0
      ],
      [
        3172.0,
        30.0,
        500.0
      ],
      [
        3172.0,
        29.451995849609375,
        500.0
      ],
      [
        3171.77587890625,
        30.0,
        500.0
      ],
      [
        3236.413330078125,
        29.99999237060547,
        500.0
      ],
      [
        3204.094482421875,
        -49.000160217285156,
        500.0
      ],
      [
        3192.0,
        -19.436439514160156,
        500.0
      ],
      [
        3192.0,
        29.999996185302734,
        500.0
      ],
      [
        3161.36474609375,
        55.44817352294922,
        500.0
      ],
      [
        3166.160888671875,
        43.724369049072266,
        500.0
      ],
      [
        3166.1611328125,
        43.724369049072266,
        500.0
      ],
      [
        3161.36474609375,
        55.44817352294922,
        500.0
      ],
      [
        3161.36474609375,
        55.44817352294922,
        550.0
      ],
      [
        3115.0,
        175.7091827392578,
        550.0
      ],
      [
        3111.579345703125,
        177.1437530517578,
        538.5979614257812
      ],
      [
        3105.0,
        193.2262420654297,
        550.0
      ],
      [
        3100.0,
        205.4482421875,
        500.0
      ],
      [
        3100.0,
        205.44822692871094,
        550.0
      ],
      [
        3071.54638671875,
        275.0,
        430.0
      ],
      [
        3071.546630859375,
        275.0,
        405.155029296875
      ],
      [
        3111.579345703125,
        177.1437530517578,
        550.0
      ],
      [
        3170.0,
        -9.357295989990234,
        525.0
      ],
      [
        3170.0,
        -9.357271194458008,
        540.0
      ],
      [
        3170.0,
        -9.357295989990234,
        515.0
      ],
      [
        3170.0,
        -9.357322692871094,
        500.0
      ],
      [
        3170.0,
        -9.357292175292969,
        515.0
      ],
      [
        3170.0,
        -9.357297897338867,
        525.0
      ],
      [
        3170.0,
        -9.357307434082031,
        650.0
      ],
      [
        3170.0,
        -9.357269287109375,
        540.0
      ],
      [
        3172.0,
        -10.196149826049805,
        500.0
      ],
      [
        3191.5791015625,
        -18.40741539001465,
        500.0
      ],
      [
        3170.0,
        30.0,
        500.0
      ],
      [
        3171.77587890625,
        30.0,
        500.0
      ],
      [
        3172.0,
        -10.196149826049805,
        500.0
      ],
      [
        3170.0,
        -9.357368469238281,
        500.0
      ],
      [
        3105.0,
        17.903039932250977,
        500.0
      ],
      [
        3123.843994140625,
        30.0,
        500.0
      ],
      [
        3123.843994140625,
        30.0,
        500.0
      ],
      [
        3105.0,
        17.903030395507812,
        500.0
      ],
      [
        3105.0,
        17.903039932250977,
        550.0
      ],
      [
        3105.0,
        19.999996185302734,
        550.0
      ],
      [
        3105.0,
        22.096954345703125,
        539.5151977539062
      ],
      [
        3105.0,
        184.09695434570312,
        500.0
      ],
      [
        3105.0,
        184.09695434570312,
        550.0
      ],
      [
        3105.0,
        184.09695434570312,
        500.0
      ],
      [
        3108.187744140625,
        185.43392944335938,
        500.0
      ],
      [
        3164.756103515625,
        47.158138275146484,
        500.0
      ],
      [
        3074.5,
        -32.21992492675781,
        415.0
      ],
      [
        3070.0,
        -21.21993637084961,
        400.0
      ],
      [
        3100.0,
        -94.55177307128906,
        500.0
      ],
      [
        3074.5,
        -32.21992492675781,
        415.0
      ],
      [
        3069.3984375,
        -19.74932098388672,
        397.99456787109375
      ],
      [
        3170.0,
        -9.357368469238281,
        500.0
      ],
      [
        3170.95751953125,
        -130.0,
        500.0
      ],
      [
        3170.0,
        -130.0,
        500.0
      ],
      [
        3105.0,
        -106.77375793457031,
        500.0
      ],
      [
        3128.613037109375,
        -130.0,
        500.0
      ],
      [
        3111.579345703125,
        -122.85624694824219,
        500.0
      ],
      [
        3077.682861328125,
        -40.0,
        400.0
      ],
      [
        3077.682861328125,
        -40.0,
        415.0
      ],
      [
        3073.095703125,
        -28.78680419921875,
        220.82225036621094
      ],
      [
        3069.720947265625,
        -20.53806495666504,
        173.89466857910156
      ],
      [
        3100.0,
        -40.0,
        240.47308349609375
      ],
      [
        3073.095703125,
        -28.78680419921875,
        220.82228088378906
      ],
      [
        3077.682861328125,
        -40.0,
        233.0340576171875
      ],
      [
        3100.0,
        -40.0,
        240.47308349609375
      ],
      [
        3100.0,
        -40.0,
        210.23695373535156
      ],
      [
        3085.86474609375,
        -60.0,
        400.0
      ],
      [
        3077.682861328125,
        -40.0,
        400.0
      ],
      [
        3081.77392578125,
        -50.0,
        243.9246063232422
      ],
      [
        3090.4521484375,
        -71.21319580078125,
        226.60777282714844
      ],
      [
        3092.507080078125,
        -76.23645782470703,
        199.400146484375
      ],
      [
        3090.4521484375,
        -71.21319580078125,
        226.60777282714844
      ],
      [
        3081.77392578125,
        -50.0,
        243.9246063232422
      ],
      [
        3077.682861328125,
        -40.0,
        415.0
      ],
      [
        3085.86474609375,
        -60.0,
        415.0
      ],
      [
        3085.86474609375,
        -60.0,
        415.0
      ],
      [
        3085.86474609375,
        -60.0,
        400.0
      ],
      [
        3105.0,
        -106.77375030517578,
        500.0
      ],
      [
        3105.0,
        -106.77375030517578,
        516.667236328125
      ],
      [
        3105.0,
        17.903034210205078,
        516.667236328125
      ],
      [
        3119.075439453125,
        -126.00000762939453,
        520.0
      ],
      [
        3116.69091796875,
        -125.00000762939453,
        525.0
      ],
      [
        3111.579345703125,
        -122.85624694824219,
        525.0
      ],
      [
        3111.579345703125,
        -122.85624694824219,
        520.0
      ],
      [
        3130.0,
        -56.21590805053711,
        528.0
      ],
      [
        3130.0,
        -56.21590805053711,
        525.0
      ],
      [
        3130.0,
        -43.78409194946289,
        528.0
      ],
      [
        3130.0,
        -43.78409194946289,
        525.0
      ],
      [
        3111.579345703125,
        -122.85624694824219,
        535.7188110351562
      ],
      [
        3111.579345703125,
        -122.85624694824219,
        500.0
      ],
      [
        3128.613037109375,
        -130.0,
        500.0
      ],
      [
        3115.0,
        -124.29082489013672,
        550.0
      ],
      [
        3111.579345703125,
        -122.85624694824219,
        538.5979614257812
      ],
      [
        3164.756103515625,
        -145.15821838378906,
        500.0
      ],
      [
        3105.0,
        -106.77375793457031,
        550.0
      ],
      [
        3100.0,
        -94.55176544189453,
        500.0
      ],
      [
        3100.0,
        -94.55177307128906,
        550.0
      ],
      [
        3069.500732421875,
        -20.0,
        430.0
      ],
      [
        3069.5009765625,
        -20.0,
        400.0
      ],
      [
        3071.54638671875,
        -25.0,
        430.0
      ],
      [
        3071.546630859375,
        -25.0,
        405.155029296875
      ],
      [
        3111.579345703125,
        -122.85624694824219,
        550.0
      ],
      [
        3074.5,
        234.22006225585938,
        415.0
      ],
      [
        3070.0,
        223.22006225585938,
        400.0
      ],
      [
        3074.5,
        234.22006225585938,
        415.0
      ],
      [
        3081.36474609375,
        251.00021362304688,
        437.882568359375
      ],
      [
        3068.411865234375,
        219.3383331298828,
        394.70660400390625
      ],
      [
        3069.705810546875,
        222.50120544433594,
        184.79034423828125
      ],
      [
        3072.27734375,
        228.78680419921875,
        220.5495147705078
      ],
      [
        3105.0,
        184.09695434570312,
        516.667236328125
      ],
      [
        3105.0,
        193.22625732421875,
        516.667236328125
      ],
      [
        3077.273681640625,
        241.0,
        415.0
      ],
      [
        3077.273681640625,
        241.0,
        400.0
      ],
      [
        3077.273681640625,
        241.0,
        415.0
      ],
      [
        3081.36474609375,
        251.0003204345703,
        415.0
      ],
      [
        3077.273681640625,
        241.0,
        400.0
      ],
      [
        3081.36474609375,
        251.0003204345703,
        400.0
      ],
      [
        3080.955322265625,
        250.0,
        243.6517791748047
      ],
      [
        3072.27734375,
        228.78680419921875,
        220.54953002929688
      ],
      [
        3080.955322265625,
        250.0,
        243.6517791748047
      ],
      [
        3081.36474609375,
        251.0006866455078,
        242.83489990234375
      ],
      [
        3068.6826171875,
        220.0,
        400.0
      ],
      [
        3068.6826171875,
        220.0,
        430.0
      ],
      [
        3070.72802734375,
        225.0,
        430.0
      ],
      [
        3070.728271484375,
        225.0,
        402.4276123046875
      ],
      [
        3105.0,
        -115.90306854248047,
        500.0
      ],
      [
        3105.0,
        -115.90306854248047,
        550.0
      ],
      [
        3105.0,
        -115.90306854248047,
        500.0
      ],
      [
        3108.187744140625,
        -114.56609344482422,
        500.0
      ],
      [
        3105.0,
        -282.0969543457031,
        500.0
      ],
      [
        3105.0,
        -282.0969543457031,
        550.0
      ],
      [
        3105.0,
        -282.0969543457031,
        500.0
      ],
      [
        3108.18798828125,
        -283.4339904785156,
        500.0
      ],
      [
        3074.5,
        -332.219482421875,
        415.0
      ],
      [
        3070.0,
        -321.21929931640625,
        400.0
      ],
      [
        3081.364990234375,
        -348.99993896484375,
        437.8830261230469
      ],
      [
        3074.5,
        -332.219482421875,
        415.0
      ],
      [
        3069.398681640625,
        -319.74945068359375,
        397.9956359863281
      ],
      [
        3073.095458984375,
        -328.78680419921875,
        220.8221893310547
      ],
      [
        3069.501220703125,
        -320.0,
        170.83375549316406
      ],
      [
        3105.0,
        -291.2268371582031,
        516.667236328125
      ],
      [
        3105.0,
        -282.0969543457031,
        516.667236328125
      ],
      [
        3077.68310546875,
        -340.0,
        400.0
      ],
      [
        3077.68310546875,
        -340.0,
        415.0
      ],
      [
        3077.68310546875,
        -340.0,
        400.0
      ],
      [
        3081.364990234375,
        -349.0001220703125,
        400.0
      ],
      [
        3077.68310546875,
        -340.0,
        415.0
      ],
      [
        3081.36474609375,
        -348.99993896484375,
        415.0
      ],
      [
        3073.095458984375,
        -328.78680419921875,
        220.82220458984375
      ],
      [
        3081.364990234375,
        -348.9999694824219,
        242.83560180664062
      ],
      [
        3069.501220703125,
        -320.0,
        170.83375549316406
      ],
      [
        3070.243408203125,
        -321.8141784667969,
        161.00762939453125
      ],
      [
        3069.5009765625,
        -320.0,
        430.0
      ],
      [
        3069.501220703125,
        -320.0,
        400.0
      ],
      [
        3071.54638671875,
        -325.0,
        430.0
      ],
      [
        3071.546630859375,
        -325.0,
        405.155029296875
      ],
      [
        3069.398681640625,
        -319.74945068359375,
        397.9956359863281
      ],
      [
        3069.501220703125,
        -320.0,
        400.0
      ],
      [
        3074.5,
        -65.78038787841797,
        415.0
      ],
      [
        3070.0,
        -76.78057861328125,
        400.0
      ],
      [
        3074.5,
        -65.78038787841797,
        415.0
      ],
      [
        3081.36474609375,
        -49.00008773803711,
        437.882568359375
      ],
      [
        3068.412353515625,
        -80.66154479980469,
        394.7076721191406
      ],
      [
        3068.6826171875,
        -80.0,
        170.56088256835938
      ],
      [
        3072.27734375,
        -71.21319580078125,
        220.54953002929688
      ],
      [
        3105.0,
        -115.90306854248047,
        516.667236328125
      ],
      [
        3105.0,
        -106.77375030517578,
        516.667236328125
      ],
      [
        3076.86474609375,
        -60.0,
        415.0
      ],
      [
        3076.86474609375,
        -60.0,
        400.0
      ],
      [
        3076.86474609375,
        -60.0,
        415.0
      ],
      [
        3081.36474609375,
        -49.00025939941406,
        415.0
      ],
      [
        3076.86474609375,
        -60.0,
        400.0
      ],
      [
        3081.36474609375,
        -49.00025939941406,
        400.0
      ],
      [
        3080.95556640625,
        -50.0,
        243.65185546875
      ],
      [
        3072.27734375,
        -71.21319580078125,
        220.54953002929688
      ],
      [
        3080.95556640625,
        -50.0,
        243.65185546875
      ],
      [
        3081.36474609375,
        -48.99993133544922,
        242.83547973632812
      ],
      [
        3068.724853515625,
        -79.89730834960938,
        170.00466918945312
      ],
      [
        3068.6826171875,
        -80.0,
        170.56088256835938
      ],
      [
        3068.682861328125,
        -80.0,
        400.0
      ],
      [
        3068.682861328125,
        -80.0,
        430.0
      ],
      [
        3070.72802734375,
        -75.0,
        430.0
      ],
      [
        3070.728271484375,
        -75.0,
        402.4276123046875
      ],
      [
        2971.3173828125,
        -80.0,
        400.0
      ],
      [
        2978.4072265625,
        -97.33032989501953,
        261.35736083984375
      ],
      [
        2971.317138671875,
        -80.0,
        138.105712890625
      ],
      [
        2967.72265625,
        -71.21319580078125,
        185.6979217529297
      ],
      [
        2970.0,
        -75.0,
        430.0
      ],
      [
        2970.0,
        -76.25,
        430.0
      ],
      [
        2970.0,
        -76.77993774414062,
        425.7604675292969
      ],
      [
        2970.0,
        -76.77993774414062,
        400.0
      ],
      [
        2970.0,
        -75.0,
        400.0
      ],
      [
        3070.728515625,
        -75.0,
        402.4280090332031
      ],
      [
        3070.0,
        -75.0,
        400.0
      ],
      [
        2970.0,
        -75.0,
        400.0
      ],
      [
        2970.0,
        -76.77993774414062,
        400.0
      ],
      [
        2969.271728515625,
        -75.0,
        397.57275390625
      ],
      [
        2975.0,
        -60.0,
        400.0
      ],
      [
        3070.0,
        -60.0,
        400.0
      ],
      [
        2970.0,
        -60.0,
        400.0
      ],
      [
        2963.135498046875,
        -60.0,
        377.1178283691406
      ],
      [
        2975.0,
        -60.0,
        430.0
      ],
      [
        2975.0,
        -60.0,
        400.0
      ],
      [
        2970.0,
        -60.0,
        430.0
      ],
      [
        2970.0,
        -60.0,
        400.0
      ],
      [
        3076.86474609375,
        -60.0,
        422.8824768066406
      ],
      [
        2967.72265625,
        -71.21319580078125,
        88.11715698242188
      ],
      [
        2971.317138671875,
        -80.0,
        138.105712890625
      ],
      [
        2967.72265625,
        -71.21319580078125,
        185.69790649414062
      ],
      [
        2963.13525390625,
        -60.0,
        194.85150146484375
      ],
      [
        3076.864501953125,
        -60.0,
        232.7613067626953
      ],
      [
        2967.72265625,
        -71.21319580078125,
        88.11715698242188
      ],
      [
        3013.896484375,
        -60.0,
        103.50845336914062
      ],
      [
        2963.135498046875,
        -60.0,
        86.58806610107422
      ],
      [
        3013.896484375,
        -60.0,
        103.50845336914062
      ],
      [
        2967.72265625,
        -71.21319580078125,
        88.11715698242188
      ],
      [
        2963.135498046875,
        -60.0,
        86.58806610107422
      ],
      [
        2967.72265625,
        -71.21319580078125,
        88.11715698242188
      ],
      [
        2963.13525390625,
        -60.0,
        75.90532684326172
      ],
      [
        3001.970703125,
        -60.0,
        88.8504867553711
      ],
      [
        3011.105224609375,
        -60.0,
        100.07808685302734
      ],
      [
        2966.649169921875,
        -68.58905029296875,
        85.25932312011719
      ],
      [
        2963.135498046875,
        -60.0,
        84.08805847167969
      ],
      [
        2971.3173828125,
        -80.0,
        400.0
      ],
      [
        2971.3173828125,
        -80.0,
        430.0
      ],
      [
        2970.0,
        -76.77993774414062,
        430.0
      ],
      [
        2977.7080078125,
        -2.378307342529297,
        259.0264587402344
      ],
      [
        2970.4990234375,
        -20.0,
        400.0
      ],
      [
        2966.904296875,
        -28.78680419921875,
        185.42507934570312
      ],
      [
        2970.4990234375,
        -20.0,
        137.83297729492188
      ],
      [
        2970.0,
        -23.749996185302734,
        430.0
      ],
      [
        2970.0,
        -25.0,
        430.0
      ],
      [
        2970.0,
        -25.0,
        400.0
      ],
      [
        2970.0,
        -21.21993637084961,
        400.0
      ],
      [
        2970.0,
        -21.21993637084961,
        409.7594909667969
      ],
      [
        3070.0,
        -25.0,
        400.0
      ],
      [
        3071.54638671875,
        -25.0,
        405.1546325683594
      ],
      [
        2970.0,
        -21.21993637084961,
        400.0
      ],
      [
        2970.0,
        -25.0,
        400.0
      ],
      [
        2968.45361328125,
        -25.0,
        394.84515380859375
      ],
      [
        2975.0,
        -40.0,
        400.0
      ],
      [
        3070.0,
        -40.0,
        400.0
      ],
      [
        2970.0,
        -40.0,
        400.0
      ],
      [
        2962.317138671875,
        -40.0,
        374.3897399902344
      ],
      [
        2975.0,
        -40.0,
        430.0
      ],
      [
        2975.0,
        -40.0,
        400.0
      ],
      [
        2970.0,
        -40.0,
        430.0
      ],
      [
        2970.0,
        -40.0,
        400.0
      ],
      [
        3077.682861328125,
        -40.0,
        425.60943603515625
      ],
      [
        2970.4990234375,
        -20.0,
        137.83297729492188
      ],
      [
        2966.904052734375,
        -28.78680419921875,
        87.84432220458984
      ],
      [
        2966.904052734375,
        -28.78680419921875,
        185.42507934570312
      ],
      [
        2962.31689453125,
        -40.0,
        194.57872009277344
      ],
      [
        3077.682861328125,
        -40.0,
        233.0340576171875
      ],
      [
        3012.893798828125,
        -40.0,
        103.17420959472656
      ],
      [
        2966.904052734375,
        -28.78680419921875,
        87.84432220458984
      ],
      [
        2962.31689453125,
        -40.0,
        86.31523132324219
      ],
      [
        2966.904052734375,
        -28.78680419921875,
        87.84432220458984
      ],
      [
        3012.893798828125,
        -40.0,
        103.17420959472656
      ],
      [
        2962.31689453125,
        -40.0,
        86.31523132324219
      ],
      [
        2965.830810546875,
        -31.41094970703125,
        84.9865493774414
      ],
      [
        3010.102783203125,
        -40.0,
        99.7438735961914
      ],
      [
        2962.317138671875,
        -40.0,
        83.81529235839844
      ],
      [
        2962.31689453125,
        -40.0,
        75.63253784179688
      ],
      [
        2965.83056640625,
        -31.41095733642578,
        84.9864730834961
      ],
      [
        3009.672119140625,
        -31.410993576049805,
        99.60031127929688
      ],
      [
        3000.968017578125,
        -40.0,
        88.51624298095703
      ],
      [
        2966.904052734375,
        -28.78680419921875,
        87.84432220458984
      ],
      [
        2970.4990234375,
        -20.0,
        430.0
      ],
      [
        2970.4990234375,
        -20.0,
        400.0
      ],
      [
        2970.0,
        -21.21993637084961,
        430.0
      ],
      [
        2959.04443359375,
        -50.0,
        363.481201171875
      ],
      [
        2958.63525390625,
        -48.99961853027344,
        362.1170349121094
      ],
      [
        2959.04443359375,
        -50.0,
        363.481201171875
      ],
      [
        2980.0,
        -40.0,
        92.20960235595703
      ],
      [
        2958.63525390625,
        -48.999610900878906,
        85.0879898071289
      ],
      [
        2980.0,
        -60.0,
        92.20958709716797
      ],
      [
        2980.0,
        -60.0,
        92.20958709716797
      ],
      [
        2958.63525390625,
        -48.999610900878906,
        85.0879898071289
      ],
      [
        2980.0,
        -40.0,
        92.20960235595703
      ],
      [
        2980.0,
        -60.0,
        89.70960235595703
      ],
      [
        2958.63525390625,
        -48.999942779541016,
        82.58800506591797
      ],
      [
        2980.0,
        -40.0,
        89.7095947265625
      ],
      [
        2959.044189453125,
        -50.0,
        65.01473999023438
      ],
      [
        2980.0,
        -50.0,
        71.99998474121094
      ],
      [
        2980.0,
        -60.0,
        81.52691650390625
      ],
      [
        2980.0,
        -50.0,
        71.9999771118164
      ],
      [
        2959.044189453125,
        -50.0,
        65.01473999023438
      ],
      [
        2958.635009765625,
        -48.999916076660156,
        65.83113098144531
      ],
      [
        2980.0,
        -40.0,
        81.52690124511719
      ],
      [
        2959.044189453125,
        -50.0,
        203.01473999023438
      ],
      [
        2975.0,
        -40.0,
        416.66656494140625
      ],
      [
        2975.0,
        -60.0,
        416.66656494140625
      ],
      [
        2959.044189453125,
        -50.0,
        203.01473999023438
      ],
      [
        2958.635009765625,
        -48.99991989135742,
        201.92559814453125
      ],
      [
        3000.0,
        -40.0,
        98.87627410888672
      ],
      [
        3000.0,
        -60.0,
        98.87627410888672
      ],
      [
        3000.0,
        -60.0,
        98.87627410888672
      ],
      [
        3000.0,
        -40.0,
        98.87627410888672
      ],
      [
        3000.0,
        -60.0,
        96.3763198852539
      ],
      [
        3000.0,
        -40.0,
        96.37627410888672
      ],
      [
        3000.0,
        -58.230445861816406,
        86.50773620605469
      ],
      [
        3000.0,
        -60.0,
        88.19358825683594
      ],
      [
        3000.0,
        -40.0,
        88.19357299804688
      ],
      [
        3000.0,
        -40.95521545410156,
        87.2835464477539
      ],
      [
        2900.0,
        190.8333282470703,
        166.66665649414062
      ],
      [
        2900.0,
        177.5,
        60.0
      ],
      [
        2900.0,
        226.42335510253906,
        166.6668701171875
      ],
      [
        2900.0,
        217.37899780273438,
        166.6668701171875
      ],
      [
        2900.0,
        309.16668701171875,
        166.66653442382812
      ],
      [
        2900.0,
        273.57666015625,
        166.6668701171875
      ],
      [
        2900.0,
        217.3789825439453,
        166.6668701171875
      ],
      [
        2900.0,
        190.83331298828125,
        166.66651916503906
      ],
      [
        2978.999755859375,
        225.0,
        430.0
      ],
      [
        2975.0,
        225.0,
        416.66741943359375
      ],
      [
        2900.0,
        225.0,
        158.763427734375
      ],
      [
        2900.0,
        220.0,
        131.0
      ],
      [
        2950.0,
        225.0,
        158.76344299316406
      ],
      [
        3070.728271484375,
        225.0,
        402.42718505859375
      ],
      [
        3070.0,
        225.0,
        400.0
      ],
      [
        2900.0,
        220.0,
        131.0
      ],
      [
        2900.0,
        221.50076293945312,
        122.66675567626953
      ],
      [
        2975.0,
        240.0,
        400.0
      ],
      [
        3070.0,
        240.0,
        400.0
      ],
      [
        2900.0,
        226.42335510253906,
        166.6668701171875
      ],
      [
        2904.87158203125,
        232.05697631835938,
        182.9058380126953
      ],
      [
        2975.0,
        240.0,
        400.0
      ],
      [
        2975.0,
        225.0,
        416.66741943359375
      ],
      [
        2975.0,
        240.0,
        416.66729736328125
      ],
      [
        3074.5,
        240.0,
        415.0
      ],
      [
        3070.0,
        240.0,
        400.0
      ],
      [
        3074.5,
        240.0,
        415.0
      ],
      [
        3076.864501953125,
        240.0,
        422.8819274902344
      ],
      [
        2950.0,
        240.0,
        190.47308349609375
      ],
      [
        3076.864501953125,
        240.0,
        232.7612762451172
      ],
      [
        2907.141845703125,
        240.0,
        190.47308349609375
      ],
      [
        2950.0,
        240.0,
        190.47308349609375
      ],
      [
        2900.0,
        228.78680419921875,
        82.20962524414062
      ],
      [
        2998.85693359375,
        240.0,
        98.49526977539062
      ],
      [
        2950.0,
        240.0,
        82.20962524414062
      ],
      [
        2950.0,
        240.0,
        82.20962524414062
      ],
      [
        2998.85693359375,
        240.0,
        98.49526977539062
      ],
      [
        2950.0,
        240.0,
        71.52691650390625
      ],
      [
        2986.93115234375,
        240.0,
        83.83731079101562
      ],
      [
        2996.06591796875,
        240.0,
        95.06494140625
      ],
      [
        2950.0,
        240.0,
        79.70962524414062
      ],
      [
        2950.0,
        240.0,
        79.70962524414062
      ],
      [
        2942.5,
        231.41094970703125,
        79.70962524414062
      ],
      [
        2942.5,
        240.0,
        79.70962524414062
      ],
      [
        2942.5,
        231.41094970703125,
        79.70962524414062
      ],
      [
        2900.0,
        228.78680419921875,
        82.20962524414062
      ],
      [
        2900.0,
        240.0,
        82.20962524414062
      ],
      [
        2950.0,
        240.0,
        82.20962524414062
      ],
      [
        2900.0,
        231.41094970703125,
        79.70962524414062
      ],
      [
        2900.0,
        228.78680419921875,
        82.20962524414062
      ],
      [
        2900.0,
        231.41094970703125,
        79.70962524414062
      ],
      [
        2900.0,
        240.0,
        79.70962524414062
      ],
      [
        3074.5,
        260.0,
        415.0
      ],
      [
        3077.682861328125,
        260.0,
        425.60992431640625
      ],
      [
        3070.0,
        260.0,
        400.0
      ],
      [
        3077.68310546875,
        260.0,
        400.0
      ],
      [
        3074.5,
        260.0,
        415.0
      ],
      [
        3077.68310546875,
        260.0,
        415.0
      ],
      [
        2979.0,
        275.0,
        430.0
      ],
      [
        2975.0,
        275.0,
        416.6669616699219
      ],
      [
        2900.0,
        280.0,
        131.0
      ],
      [
        2900.0,
        275.0,
        158.76348876953125
      ],
      [
        2950.0,
        275.0,
        158.76344299316406
      ],
      [
        2900.0,
        278.49920654296875,
        122.66664123535156
      ],
      [
        2900.0,
        280.0,
        131.0
      ],
      [
        2975.0,
        260.0,
        400.0
      ],
      [
        3070.0,
        260.0,
        400.0
      ],
      [
        2900.0,
        273.57666015625,
        166.6668701171875
      ],
      [
        2904.87158203125,
        267.9430236816406,
        182.90585327148438
      ],
      [
        2975.0,
        275.0,
        416.6669616699219
      ],
      [
        2975.0,
        260.0,
        400.0
      ],
      [
        2975.0,
        260.0,
        416.6671142578125
      ],
      [
        2950.0,
        260.0,
        190.47308349609375
      ],
      [
        3077.68310546875,
        260.0,
        233.03411865234375
      ],
      [
        2907.141845703125,
        260.0,
        190.47308349609375
      ],
      [
        2950.0,
        260.0,
        190.47308349609375
      ],
      [
        2900.0,
        271.21319580078125,
        82.20962524414062
      ],
      [
        2997.854248046875,
        260.0,
        98.16106414794922
      ],
      [
        2950.0,
        260.0,
        82.20962524414062
      ],
      [
        2950.0,
        260.0,
        82.20962524414062
      ],
      [
        2997.854248046875,
        260.0,
        98.16106414794922
      ],
      [
        2950.0,
        260.0,
        71.52691650390625
      ],
      [
        2985.9287109375,
        260.0,
        83.50310516357422
      ],
      [
        2995.0634765625,
        260.0,
        94.73072814941406
      ],
      [
        2950.0,
        260.0,
        79.70962524414062
      ],
      [
        2942.5,
        268.58905029296875,
        79.70962524414062
      ],
      [
        2950.0,
        260.0,
        79.70962524414062
      ],
      [
        2942.5,
        260.0,
        79.70962524414062
      ],
      [
        2942.5,
        268.58905029296875,
        79.70962524414062
      ],
      [
        2900.0,
        260.0,
        82.20962524414062
      ],
      [
        2900.0,
        271.21319580078125,
        82.20962524414062
      ],
      [
        2950.0,
        260.0,
        82.20962524414062
      ],
      [
        2900.0,
        268.58905029296875,
        79.70962524414062
      ],
      [
        2900.0,
        271.21319580078125,
        82.20962524414062
      ],
      [
        2900.0,
        268.58905029296875,
        79.70962524414062
      ],
      [
        2900.0,
        260.0,
        79.70962524414062
      ],
      [
        2974.54833984375,
        260.0,
        79.70962524414062
      ],
      [
        2980.0,
        258.0924987792969,
        79.70962524414062
      ],
      [
        2980.0,
        254.14984130859375,
        75.95349884033203
      ],
      [
        2980.0,
        246.22369384765625,
        75.59765625
      ],
      [
        2980.0,
        241.9075469970703,
        79.70962524414062
      ],
      [
        2974.548095703125,
        240.0,
        79.70962524414062
      ],
      [
        2957.5,
        240.0,
        82.20962524414062
      ],
      [
        2957.5,
        260.0,
        82.20962524414062
      ],
      [
        2980.0,
        240.0,
        81.52692413330078
      ],
      [
        2980.0,
        260.0,
        81.5268783569336
      ],
      [
        2980.0,
        244.751708984375,
        205.0
      ],
      [
        2980.0,
        260.0,
        92.20964050292969
      ],
      [
        2980.0,
        240.0,
        92.20962524414062
      ],
      [
        2980.0,
        260.0,
        92.20964050292969
      ],
      [
        2980.0,
        240.0,
        92.20962524414062
      ],
      [
        2980.0,
        240.0,
        89.70963287353516
      ],
      [
        2980.0,
        260.0,
        89.70958709716797
      ],
      [
        2970.0,
        223.75,
        430.0
      ],
      [
        2900.0,
        234.34521484375,
        201.4686279296875
      ],
      [
        2900.0,
        219.47433471679688,
        186.02633666992188
      ],
      [
        2900.0,
        271.2132568359375,
        180.97146606445312
      ],
      [
        2900.0,
        251.475341796875,
        201.4680633544922
      ],
      [
        2900.0,
        251.475341796875,
        201.4680633544922
      ],
      [
        2900.0,
        265.6554870605469,
        201.4681854248047
      ],
      [
        2902.447998046875,
        242.9099884033203,
        209.6282196044922
      ],
      [
        2900.0,
        248.52493286132812,
        201.4680633544922
      ],
      [
        2900.0,
        228.786865234375,
        180.97146606445312
      ],
      [
        2900.0,
        219.47433471679688,
        186.02633666992188
      ],
      [
        2900.435791015625,
        216.53733825683594,
        168.1204376220703
      ],
      [
        2900.0,
        216.537353515625,
        168.251220703125
      ],
      [
        2900.0,
        248.52493286132812,
        201.4680633544922
      ],
      [
        2900.0,
        234.34521484375,
        201.4686279296875
      ],
      [
        2900.0,
        226.42335510253906,
        166.6668701171875
      ],
      [
        2900.0,
        228.786865234375,
        180.97146606445312
      ],
      [
        2900.0,
        216.27566528320312,
        166.66746520996094
      ],
      [
        2900.0,
        273.57666015625,
        166.6668701171875
      ],
      [
        2900.0,
        271.2132568359375,
        180.97146606445312
      ],
      [
        2931.72412109375,
        16.78158187866211,
        105.74736022949219
      ],
      [
        2941.998291015625,
        -8.332643508911133,
        306.6611328125
      ],
      [
        2947.97021484375,
        -22.930110931396484,
        326.56732177734375
      ],
      [
        2941.998291015625,
        -8.332637786865234,
        306.6611022949219
      ],
      [
        2947.97021484375,
        -22.930110931396484,
        326.56732177734375
      ],
      [
        2950.0,
        -27.891876220703125,
        87.17887878417969
      ],
      [
        2950.3662109375,
        -28.78680419921875,
        82.3316650390625
      ],
      [
        2950.0,
        -27.891876220703125,
        174.8211212158203
      ],
      [
        2950.3662109375,
        -28.78680419921875,
        179.91241455078125
      ],
      [
        2946.771240234375,
        -20.0,
        131.0
      ],
      [
        2950.0,
        -27.891876220703125,
        174.8211212158203
      ],
      [
        2946.771240234375,
        -20.0,
        131.0
      ],
      [
        2946.810302734375,
        -20.095739364624023,
        130.4683837890625
      ],
      [
        2950.0,
        -27.891876220703125,
        87.17887878417969
      ],
      [
        2950.3662109375,
        -28.78680419921875,
        82.3316650390625
      ],
      [
        2950.3662109375,
        -28.78680419921875,
        179.91241455078125
      ],
      [
        2950.3662109375,
        -28.78680419921875,
        82.3316650390625
      ],
      [
        2950.3662109375,
        -28.78680419921875,
        82.3316650390625
      ],
      [
        2951.439453125,
        -31.41094970703125,
        80.18943786621094
      ],
      [
        2970.0,
        -21.21993637084961,
        409.7594909667969
      ],
      [
        2900.0,
        -290.8333435058594,
        166.6666717529297
      ],
      [
        2900.0,
        -277.5,
        60.0
      ],
      [
        2900.0,
        -290.83331298828125,
        166.66653442382812
      ],
      [
        2900.0,
        -326.42333984375,
        166.6668701171875
      ],
      [
        2900.0,
        -382.6210021972656,
        166.6668701171875
      ],
      [
        2900.0,
        -409.16668701171875,
        166.66651916503906
      ],
      [
        3076.86474609375,
        -360.0,
        422.8826904296875
      ],
      [
        2978.999755859375,
        -375.0,
        430.0
      ],
      [
        2975.0,
        -375.0,
        416.66741943359375
      ],
      [
        2900.0,
        -375.0,
        158.76348876953125
      ],
      [
        2900.0,
        -380.0,
        131.0
      ],
      [
        2950.0,
        -375.0,
        158.76344299316406
      ],
      [
        2900.0,
        -380.0,
        131.0
      ],
      [
        2900.0,
        -378.49920654296875,
        122.66664123535156
      ],
      [
        2975.0,
        -360.0,
        400.0
      ],
      [
        3070.0,
        -360.0,
        400.0
      ],
      [
        2900.0,
        -373.57666015625,
        166.6668701171875
      ],
      [
        2904.87158203125,
        -367.9430236816406,
        182.90585327148438
      ],
      [
        2975.0,
        -360.0,
        400.0
      ],
      [
        2975.0,
        -375.0,
        416.66741943359375
      ],
      [
        2975.0,
        -360.0,
        416.66729736328125
      ],
      [
        3028.935791015625,
        -360.0,
        108.52161407470703
      ],
      [
        2950.0,
        -360.0,
        82.20962524414062
      ],
      [
        2950.0,
        -360.0,
        82.20962524414062
      ],
      [
        3028.935791015625,
        -360.0,
        108.5216064453125
      ],
      [
        2950.0,
        -360.0,
        190.47308349609375
      ],
      [
        3076.86474609375,
        -360.0,
        232.7613525390625
      ],
      [
        2907.141845703125,
        -360.0,
        190.47308349609375
      ],
      [
        2950.0,
        -360.0,
        190.47308349609375
      ],
      [
        2900.0,
        -371.21319580078125,
        82.20962524414062
      ],
      [
        2900.0,
        -371.21319580078125,
        82.20962524414062
      ],
      [
        2900.0,
        -360.0,
        82.20962524414062
      ],
      [
        2950.0,
        -360.0,
        82.20962524414062
      ],
      [
        2900.0,
        -368.58905029296875,
        79.70962524414062
      ],
      [
        2942.5,
        -368.58905029296875,
        79.70962524414062
      ],
      [
        2900.0,
        -371.21319580078125,
        82.20962524414062
      ],
      [
        2942.5,
        -368.58905029296875,
        79.70962524414062
      ],
      [
        2900.0,
        -368.58905029296875,
        79.70962524414062
      ],
      [
        2900.0,
        -360.0,
        79.70962524414062
      ],
      [
        2942.5,
        -360.0,
        79.70962524414062
      ],
      [
        3026.14501953125,
        -360.0,
        105.09130859375
      ],
      [
        2950.0,
        -360.0,
        79.70962524414062
      ],
      [
        3017.010009765625,
        -360.0,
        93.8636245727539
      ],
      [
        3026.575439453125,
        -368.5889892578125,
        105.23474884033203
      ],
      [
        2950.0,
        -360.0,
        71.52691650390625
      ],
      [
        2950.0,
        -360.0,
        79.70962524414062
      ],
      [
        2979.0,
        -325.0,
        430.0
      ],
      [
        2975.0,
        -325.0,
        416.6669616699219
      ],
      [
        2900.0,
        -320.0,
        131.0
      ],
      [
        2900.0,
        -325.0,
        158.76348876953125
      ],
      [
        2950.0,
        -325.0,
        158.76344299316406
      ],
      [
        3070.0,
        -325.0,
        400.0
      ],
      [
        3071.546630859375,
        -325.0,
        405.1554260253906
      ],
      [
        2900.0,
        -321.50079345703125,
        122.66661071777344
      ],
      [
        2900.0,
        -320.0,
        131.0
      ],
      [
        2975.0,
        -340.0,
        400.0
      ],
      [
        3070.0,
        -340.0,
        400.0
      ],
      [
        2900.0,
        -326.42333984375,
        166.6668701171875
      ],
      [
        2904.87158203125,
        -332.0569763183594,
        182.9058380126953
      ],
      [
        2975.0,
        -325.0,
        416.6669616699219
      ],
      [
        2975.0,
        -340.0,
        400.0
      ],
      [
        2975.0,
        -340.0,
        416.6671142578125
      ],
      [
        3077.68310546875,
        -340.0,
        425.6100769042969
      ],
      [
        3027.93310546875,
        -340.0,
        108.18740844726562
      ],
      [
        2950.0,
        -340.0,
        82.20962524414062
      ],
      [
        2950.0,
        -340.0,
        82.20962524414062
      ],
      [
        3027.93310546875,
        -340.0,
        108.1874008178711
      ],
      [
        3025.142578125,
        -340.0,
        104.75709533691406
      ],
      [
        2950.0,
        -340.0,
        79.70962524414062
      ],
      [
        2950.0,
        -340.0,
        71.52691650390625
      ],
      [
        3024.711669921875,
        -331.4109802246094,
        104.61351776123047
      ],
      [
        3016.007568359375,
        -340.0,
        93.52942657470703
      ],
      [
        2942.5,
        -331.41094970703125,
        79.70962524414062
      ],
      [
        2950.0,
        -340.0,
        79.70962524414062
      ],
      [
        2942.5,
        -340.0,
        79.70962524414062
      ],
      [
        2942.5,
        -331.41094970703125,
        79.70962524414062
      ],
      [
        2950.0,
        -340.0,
        190.47308349609375
      ],
      [
        3077.682861328125,
        -340.0,
        233.03407287597656
      ],
      [
        2907.141845703125,
        -340.0,
        190.47308349609375
      ],
      [
        2950.0,
        -340.0,
        190.47308349609375
      ],
      [
        2900.0,
        -328.78680419921875,
        82.20962524414062
      ],
      [
        2900.0,
        -340.0,
        82.20962524414062
      ],
      [
        2900.0,
        -328.78680419921875,
        82.20962524414062
      ],
      [
        2950.0,
        -340.0,
        82.20962524414062
      ],
      [
        2900.0,
        -331.41094970703125,
        79.70962524414062
      ],
      [
        2900.0,
        -328.78680419921875,
        82.20962524414062
      ],
      [
        2900.0,
        -331.41094970703125,
        79.70962524414062
      ],
      [
        2900.0,
        -340.0,
        79.70962524414062
      ],
      [
        2980.0,
        -350.0,
        72.0
      ],
      [
        2980.0,
        -358.09246826171875,
        79.70962524414062
      ],
      [
        2974.548095703125,
        -360.0,
        79.70962524414062
      ],
      [
        2980.0,
        -350.0,
        72.00000762939453
      ],
      [
        2974.548095703125,
        -340.0,
        79.70962524414062
      ],
      [
        2980.0,
        -341.90753173828125,
        79.70962524414062
      ],
      [
        2957.5,
        -360.0,
        82.20962524414062
      ],
      [
        2957.5,
        -340.0,
        82.20962524414062
      ],
      [
        2980.0,
        -360.0,
        81.52693176269531
      ],
      [
        2980.0,
        -340.0,
        81.52690887451172
      ],
      [
        2980.0,
        -355.248291015625,
        204.99998474121094
      ],
      [
        2980.0,
        -340.0,
        92.20965576171875
      ],
      [
        2980.0,
        -360.0,
        92.20964813232422
      ],
      [
        2980.0,
        -340.0,
        92.20965576171875
      ],
      [
        2980.0,
        -360.0,
        92.20964050292969
      ],
      [
        2980.0,
        -360.0,
        89.70962524414062
      ],
      [
        2980.0,
        -340.0,
        89.70960235595703
      ],
      [
        3000.0,
        -340.0,
        98.8763427734375
      ],
      [
        3000.0,
        -360.0,
        98.87632751464844
      ],
      [
        3000.0,
        -340.0,
        98.8763427734375
      ],
      [
        3000.0,
        -360.0,
        98.8763198852539
      ],
      [
        3000.0,
        -360.0,
        96.37629699707031
      ],
      [
        3000.0,
        -340.0,
        96.37625122070312
      ],
      [
        3000.0,
        -350.0,
        78.66667175292969
      ],
      [
        3000.0,
        -360.0,
        88.19361114501953
      ],
      [
        3000.0,
        -350.0,
        78.66667938232422
      ],
      [
        3000.0,
        -340.0,
        88.19357299804688
      ],
      [
        2970.0,
        -323.7499694824219,
        430.0
      ],
      [
        2900.0,
        -334.3445129394531,
        201.4681854248047
      ],
      [
        2900.0,
        -319.47430419921875,
        186.02635192871094
      ],
      [
        2900.0,
        -351.4750671386719,
        201.4680633544922
      ],
      [
        2900.0,
        -371.213134765625,
        180.97146606445312
      ],
      [
        2902.447998046875,
        -342.90972900390625,
        209.62820434570312
      ],
      [
        2900.0,
        -351.4750671386719,
        201.4680633544922
      ],
      [
        2900.0,
        -365.6548156738281,
        201.4686279296875
      ],
      [
        2900.0,
        -328.7867431640625,
        180.97146606445312
      ],
      [
        2900.0,
        -348.5246887207031,
        201.4680633544922
      ],
      [
        2900.436279296875,
        -316.53759765625,
        168.1205596923828
      ],
      [
        2900.0,
        -319.47430419921875,
        186.02635192871094
      ],
      [
        2900.0,
        -316.53759765625,
        168.25143432617188
      ],
      [
        2900.0,
        -348.5246887207031,
        201.4680633544922
      ],
      [
        2900.0,
        -334.3445129394531,
        201.4681854248047
      ],
      [
        2900.0,
        -326.42333984375,
        166.6668701171875
      ],
      [
        2900.0,
        -328.7867431640625,
        180.97146606445312
      ],
      [
        2900.0,
        -316.27569580078125,
        166.66629028320312
      ],
      [
        2900.0,
        -373.57666015625,
        166.6668701171875
      ],
      [
        2900.0,
        -371.213134765625,
        180.97146606445312
      ],
      [
        3029.0,
        -320.0,
        430.0
      ],
      [
        3020.0,
        -320.0,
        400.0
      ],
      [
        2939.300048828125,
        -80.0,
        131.0
      ],
      [
        2924.662841796875,
        -71.21319580078125,
        82.20962524414062
      ],
      [
        2924.662841796875,
        -28.78680419921875,
        82.20962524414062
      ],
      [
        2939.2998046875,
        -20.0,
        131.0
      ],
      [
        2950.0,
        -73.57664489746094,
        166.66688537597656
      ],
      [
        2954.37451171875,
        -71.21319580078125,
        181.24851989746094
      ],
      [
        2939.300048828125,
        -80.0,
        131.0
      ],
      [
        2950.0,
        -73.57664489746094,
        166.66688537597656
      ],
      [
        2924.662841796875,
        -71.21319580078125,
        82.20962524414062
      ],
      [
        2924.662841796875,
        -28.78680419921875,
        82.20962524414062
      ],
      [
        2923.912841796875,
        -31.41094970703125,
        79.70962524414062
      ],
      [
        2923.912841796875,
        -68.58905029296875,
        79.70962524414062
      ],
      [
        2964.564208984375,
        -63.49319839477539,
        79.70962524414062
      ],
      [
        2951.68017578125,
        -31.998796463012695,
        79.70962524414062
      ],
      [
        2957.5,
        -46.22523498535156,
        82.20962524414062
      ],
      [
        2957.5,
        -68.58905029296875,
        82.20962524414062
      ],
      [
        2965.50341796875,
        -65.78875732421875,
        82.20962524414062
      ],
      [
        2957.5,
        -68.58903503417969,
        82.20962524414062
      ],
      [
        2951.439697265625,
        -31.410945892333984,
        80.18950653076172
      ],
      [
        2923.912841796875,
        -68.58905029296875,
        79.70962524414062
      ],
      [
        2924.662841796875,
        -71.21319580078125,
        82.20962524414062
      ],
      [
        2923.912841796875,
        -31.41094970703125,
        79.70962524414062
      ],
      [
        2924.662841796875,
        -28.78680419921875,
        82.20962524414062
      ],
      [
        2950.42724609375,
        -28.936302185058594,
        82.20962524414062
      ],
      [
        2957.5,
        -68.58903503417969,
        82.20962524414062
      ],
      [
        2966.649169921875,
        -68.58903503417969,
        85.25929260253906
      ],
      [
        2939.2998046875,
        -20.0,
        131.0
      ],
      [
        2949.20361328125,
        -25.94532585144043,
        164.01254272460938
      ],
      [
        2954.37451171875,
        -71.21319580078125,
        181.24851989746094
      ],
      [
        2960.207763671875,
        -52.844276428222656,
        200.69288635253906
      ],
      [
        2900.0,
        -109.16667175292969,
        166.66665649414062
      ],
      [
        2900.0,
        -122.5,
        60.0
      ],
      [
        2900.0,
        -73.57664489746094,
        166.6668701171875
      ],
      [
        2900.0,
        -82.62100982666016,
        166.6668701171875
      ],
      [
        2900.0,
        9.166683197021484,
        166.66653442382812
      ],
      [
        2900.0,
        -26.42335319519043,
        166.6668701171875
      ],
      [
        2900.0,
        -82.62100982666016,
        166.6668701171875
      ],
      [
        2900.0,
        -109.16668701171875,
        166.66651916503906
      ],
      [
        2900.0,
        9.166666030883789,
        166.6666717529297
      ],
      [
        2900.0,
        22.5,
        60.0
      ],
      [
        2900.0,
        -80.0,
        131.0
      ],
      [
        2900.0,
        -71.21319580078125,
        82.20962524414062
      ],
      [
        2900.0,
        -28.78680419921875,
        82.20962524414062
      ],
      [
        2900.0,
        -20.0,
        131.0
      ],
      [
        2900.0,
        -73.57664489746094,
        166.6668701171875
      ],
      [
        2900.0,
        -80.0,
        131.0
      ],
      [
        2954.4775390625,
        -70.88874816894531,
        181.5919647216797
      ],
      [
        2900.0,
        -20.0,
        131.0
      ],
      [
        2900.0,
        -26.42335319519043,
        166.6668701171875
      ],
      [
        2950.37744140625,
        -28.814144134521484,
        179.9421844482422
      ],
      [
        2959.741455078125,
        -51.70418930053711,
        201.62356567382812
      ],
      [
        2900.0,
        -71.21319580078125,
        82.20962524414062
      ],
      [
        2900.0,
        -28.78680419921875,
        82.20962524414062
      ],
      [
        2900.0,
        -31.41094970703125,
        79.70962524414062
      ],
      [
        2900.0,
        -68.58905029296875,
        79.70962524414062
      ],
      [
        2900.0,
        -68.58905029296875,
        79.70962524414062
      ],
      [
        2900.0,
        -71.21319580078125,
        82.20962524414062
      ],
      [
        2900.0,
        -31.41094970703125,
        79.70962524414062
      ],
      [
        2900.0,
        -28.78680419921875,
        82.20962524414062
      ],
      [
        2900.0,
        -65.65479278564453,
        201.4686279296875
      ],
      [
        2900.0,
        -80.52567291259766,
        186.02633666992188
      ],
      [
        2900.0,
        -34.34450149536133,
        201.4681854248047
      ],
      [
        2900.0,
        -19.474275588989258,
        186.02635192871094
      ],
      [
        2900.0,
        -51.475067138671875,
        201.4680633544922
      ],
      [
        2900.0,
        -71.21314239501953,
        180.97146606445312
      ],
      [
        2902.447998046875,
        -42.90973663330078,
        209.6282196044922
      ],
      [
        2900.0,
        -51.47507095336914,
        201.4680633544922
      ],
      [
        2900.0,
        -65.65479278564453,
        201.4686279296875
      ],
      [
        2900.0,
        -80.52567291259766,
        186.02633666992188
      ],
      [
        2900.435791015625,
        -83.4626693725586,
        168.1204376220703
      ],
      [
        2900.0,
        -83.46266174316406,
        168.251220703125
      ],
      [
        2900.0,
        -28.7867488861084,
        180.97146606445312
      ],
      [
        2900.0,
        -48.524662017822266,
        201.4680633544922
      ],
      [
        2900.436279296875,
        -16.537586212158203,
        168.1205596923828
      ],
      [
        2900.0,
        -19.474275588989258,
        186.02635192871094
      ],
      [
        2900.0,
        -16.537572860717773,
        168.25143432617188
      ],
      [
        2900.0,
        -48.52466583251953,
        201.4680633544922
      ],
      [
        2900.0,
        -34.34449768066406,
        201.4681854248047
      ],
      [
        2900.0,
        -73.57664489746094,
        166.6668701171875
      ],
      [
        2900.0,
        -71.21314239501953,
        180.97146606445312
      ],
      [
        2900.0,
        -83.7243423461914,
        166.66746520996094
      ],
      [
        2900.0,
        -26.42335319519043,
        166.6668701171875
      ],
      [
        2900.0,
        -28.7867488861084,
        180.97146606445312
      ],
      [
        2900.0,
        -16.27568244934082,
        166.66629028320312
      ],
      [
        2970.0,
        -76.77993774414062,
        425.7604675292969
      ],
      [
        1918.5556640625,
        34.07644271850586,
        110.0
      ],
      [
        1927.0,
        44.100914001464844,
        119.99982452392578
      ],
      [
        1927.0,
        36.420989990234375,
        110.0
      ],
      [
        1923.5455322265625,
        40.000022888183594,
        115.90902709960938
      ],
      [
        1918.5556640625,
        45.923614501953125,
        110.0
      ],
      [
        1927.0,
        43.579063415527344,
        110.0
      ],
      [
        1927.0,
        40.00001525878906,
        114.66018676757812
      ],
      [
        1927.0,
        -414.1008605957031,
        119.99982452392578
      ],
      [
        1918.5556640625,
        -404.0763854980469,
        110.0
      ],
      [
        1927.0,
        -406.4209289550781,
        110.0
      ],
      [
        1918.5556640625,
        -415.9235534667969,
        110.0
      ],
      [
        1923.5455322265625,
        -409.9999694824219,
        115.90901947021484
      ],
      [
        1927.0,
        -409.9999694824219,
        114.6601791381836
      ],
      [
        1927.0,
        -413.5790100097656,
        110.0
      ],
      [
        1927.0,
        -408.0,
        112.0
      ],
      [
        1927.0,
        -408.0,
        112.05609893798828
      ],
      [
        1921.8607177734375,
        -408.0,
        113.91398620605469
      ],
      [
        1927.0,
        35.89914321899414,
        119.99982452392578
      ],
      [
        1927.0,
        -408.0,
        119.99990844726562
      ],
      [
        1925.230224609375,
        -408.0,
        117.90406799316406
      ],
      [
        1927.0,
        -408.0,
        117.2642822265625
      ],
      [
        1927.0,
        -405.8990783691406,
        119.99982452392578
      ],
      [
        1930.040771484375,
        37.26525115966797,
        110.0
      ],
      [
        1930.040771484375,
        42.73480224609375,
        110.0
      ],
      [
        1930.91064453125,
        40.00001525878906,
        113.24641418457031
      ],
      [
        1927.0,
        40.00001525878906,
        114.66018676757812
      ],
      [
        1935.0,
        720.0,
        128.50816345214844
      ],
      [
        1935.37890625,
        720.37890625,
        129.92236328125
      ],
      [
        1930.040771484375,
        -407.26519775390625,
        110.0
      ],
      [
        1927.1551513671875,
        -408.0,
        112.0
      ],
      [
        1927.0,
        -408.0,
        112.05609893798828
      ],
      [
        1930.91064453125,
        -409.9999694824219,
        113.24640655517578
      ],
      [
        1930.040771484375,
        -412.7347412109375,
        110.0
      ],
      [
        1927.0,
        -409.9999694824219,
        114.6601791381836
      ],
      [
        1930.5999755859375,
        -409.9999694824219,
        113.3587417602539
      ],
      [
        1930.5999755859375,
        -409.0231018066406,
        112.08678436279297
      ],
      [
        1930.5999755859375,
        -410.9768371582031,
        112.08678436279297
      ],
      [
        1930.5999755859375,
        -412.0,
        112.08678436279297
      ],
      [
        1930.5999755859375,
        -412.0,
        115.96292877197266
      ],
      [
        1930.5767822265625,
        -408.0,
        112.0
      ],
      [
        1930.5999755859375,
        -408.0,
        112.08678436279297
      ],
      [
        1930.5999755859375,
        -408.0,
        115.96282958984375
      ],
      [
        1927.0,
        -408.0,
        117.26424407958984
      ],
      [
        1930.5999755859375,
        -408.0,
        115.96282958984375
      ],
      [
        1930.5999755859375,
        -408.0,
        112.08678436279297
      ],
      [
        1930.5999755859375,
        -409.9999694824219,
        113.3587417602539
      ],
      [
        1910.0,
        418.0,
        85.0
      ],
      [
        1910.0,
        418.0,
        80.0
      ],
      [
        1922.002197265625,
        720.0,
        80.0
      ],
      [
        1916.6431884765625,
        720.0,
        60.0
      ],
      [
        1923.342041015625,
        418.0,
        85.0
      ],
      [
        1922.0023193359375,
        418.0,
        80.0
      ],
      [
        2749.382568359375,
        919.3826293945312,
        80.0
      ],
      [
        2751.2822265625,
        917.4354858398438,
        79.74354553222656
      ],
      [
        2751.2822265625,
        917.4354858398438,
        79.74354553222656
      ],
      [
        2650.0,
        1021.25,
        86.83332824707031
      ],
      [
        2700.0,
        1071.7860107421875,
        93.57147216796875
      ],
      [
        2650.0,
        1021.2499389648438,
        86.83332824707031
      ],
      [
        2650.0,
        1021.2499389648438,
        93.18965911865234
      ],
      [
        2749.382568359375,
        919.3826293945312,
        80.0
      ],
      [
        2650.0,
        1021.2499389648438,
        100.0
      ],
      [
        2150.0,
        720.0,
        80.0
      ],
      [
        2150.0,
        720.0,
        60.0
      ],
      [
        2150.0,
        720.0,
        100.0
      ],
      [
        2150.0,
        720.0,
        80.0
      ],
      [
        2150.0,
        720.0,
        111.0
      ],
      [
        2150.0,
        720.0,
        112.70936584472656
      ],
      [
        1945.0,
        730.0,
        120.0
      ],
      [
        1955.0,
        740.0,
        130.00001525878906
      ],
      [
        1935.0,
        720.0,
        109.9999771118164
      ],
      [
        1945.0,
        730.0,
        120.0
      ],
      [
        2065.0,
        730.0,
        120.0
      ],
      [
        2070.0,
        735.0,
        125.00000762939453
      ],
      [
        2055.0,
        720.0,
        109.9999771118164
      ],
      [
        2065.0,
        730.0,
        120.0
      ],
      [
        2005.0,
        730.0,
        120.0
      ],
      [
        2015.0,
        740.0,
        130.00001525878906
      ],
      [
        1995.0,
        720.0,
        109.9999771118164
      ],
      [
        2005.0,
        730.0,
        120.0
      ],
      [
        2032.5,
        757.4998779296875,
        147.49990844726562
      ],
      [
        2150.0,
        725.0,
        113.21629333496094
      ],
      [
        2150.0,
        725.0,
        100.0
      ],
      [
        2060.641845703125,
        680.0,
        60.02119064331055
      ],
      [
        2060.641845703125,
        680.0,
        60.0
      ],
      [
        2150.0,
        680.0,
        80.0
      ],
      [
        2150.0,
        700.0,
        80.0
      ],
      [
        2150.0,
        715.0,
        80.0
      ],
      [
        2150.0,
        715.0,
        83.0
      ],
      [
        2600.0,
        760.0,
        65.33333587646484
      ],
      [
        2600.0,
        869.9999389648438,
        80.0
      ],
      [
        2315.0,
        730.0,
        60.999996185302734
      ],
      [
        2395.0,
        730.0,
        60.999996185302734
      ],
      [
        2440.0,
        790.0,
        69.33333587646484
      ],
      [
        2315.0,
        730.0,
        61.333335876464844
      ],
      [
        2395.0,
        730.0,
        61.333335876464844
      ],
      [
        2680.0,
        890.0,
        72.00001525878906
      ],
      [
        2680.0,
        870.0,
        66.66667938232422
      ],
      [
        2790.0,
        750.0,
        64.00000762939453
      ],
      [
        2790.0,
        780.0,
        68.00000762939453
      ],
      [
        2720.0,
        750.0,
        64.00000762939453
      ],
      [
        2680.0,
        730.0,
        61.333335876464844
      ],
      [
        2680.0,
        890.0,
        80.0
      ],
      [
        2680.0,
        870.0,
        80.0
      ],
      [
        2700.0,
        850.0,
        77.33334350585938
      ],
      [
        2700.0,
        870.0,
        80.00000762939453
      ],
      [
        2710.0,
        830.0,
        74.66667175292969
      ],
      [
        2710.0,
        850.0,
        77.33334350585938
      ],
      [
        2730.0,
        800.0,
        70.66667175292969
      ],
      [
        2760.0,
        800.0,
        70.66667938232422
      ],
      [
        2740.0,
        820.0,
        73.33334350585938
      ],
      [
        2740.0,
        830.0,
        74.66667175292969
      ],
      [
        2750.0,
        810.0,
        72.00001525878906
      ],
      [
        2750.0,
        820.0,
        73.33334350585938
      ],
      [
        2760.0,
        810.0,
        72.00001525878906
      ],
      [
        2760.0,
        800.0,
        70.66667175292969
      ],
      [
        2760.0,
        780.0,
        68.00000762939453
      ],
      [
        2760.0,
        770.0,
        66.66667175292969
      ],
      [
        2810.0,
        750.0,
        64.00000762939453
      ],
      [
        2840.0,
        730.0,
        61.333335876464844
      ],
      [
        2480.0,
        970.0000610351562,
        93.3333511352539
      ],
      [
        2599.99951171875,
        970.0,
        93.33334350585938
      ],
      [
        2650.0,
        970.0,
        89.9999771118164
      ],
      [
        2650.0,
        970.0,
        89.9999771118164
      ],
      [
        2650.0,
        1021.2499389648438,
        93.4166488647461
      ],
      [
        2600.0,
        920.0,
        86.66667175292969
      ],
      [
        2680.0,
        890.0,
        82.66667175292969
      ],
      [
        2650.0,
        970.0,
        93.33334350585938
      ],
      [
        2650.0,
        1020.0,
        100.0
      ],
      [
        2650.0,
        970.0,
        93.33334350585938
      ],
      [
        2530.0,
        680.0,
        80.0
      ],
      [
        2530.0,
        690.7692260742188,
        80.0
      ],
      [
        2530.0,
        760.0,
        80.0
      ],
      [
        2530.0,
        690.7692260742188,
        80.0
      ],
      [
        2380.0,
        650.0,
        80.0
      ],
      [
        2200.0,
        650.0,
        80.0
      ],
      [
        2537.58349609375,
        650.0,
        60.0
      ],
      [
        2530.0,
        650.0,
        80.0
      ],
      [
        2360.0,
        650.0,
        80.0
      ],
      [
        2440.0,
        790.0,
        80.0
      ],
      [
        2269.5,
        654.3301391601562,
        80.0
      ],
      [
        2272.0,
        650.0,
        80.0
      ],
      [
        2264.5,
        654.3301391601562,
        80.0
      ],
      [
        2269.5,
        654.3301391601562,
        80.0
      ],
      [
        2297.5,
        654.3301391601562,
        80.0
      ],
      [
        2300.0,
        650.0,
        80.0
      ],
      [
        2292.5,
        654.3301391601562,
        80.0
      ],
      [
        2297.5,
        654.3301391601562,
        80.0
      ],
      [
        2447.5,
        654.3301391601562,
        80.0
      ],
      [
        2450.0,
        650.0,
        80.0
      ],
      [
        2442.5,
        654.3301391601562,
        80.0
      ],
      [
        2447.5,
        654.3301391601562,
        80.0
      ],
      [
        2475.5,
        654.3301391601562,
        80.0
      ],
      [
        2478.0,
        650.0,
        80.0
      ],
      [
        2470.5,
        654.3301391601562,
        80.0
      ],
      [
        2475.5,
        654.3301391601562,
        80.0
      ],
      [
        2440.0,
        720.0,
        111.0
      ],
      [
        2440.0,
        720.0,
        112.70936584472656
      ],
      [
        2440.0,
        722.5,
        112.10814666748047
      ],
      [
        2440.0,
        729.0240478515625,
        115.0
      ],
      [
        2440.0,
        751.0,
        116.0
      ],
      [
        2440.0,
        763.25,
        113.49038696289062
      ],
      [
        2440.0,
        729.0240478515625,
        115.0
      ],
      [
        2440.0,
        740.0,
        116.74038696289062
      ],
      [
        2440.0,
        715.0,
        83.0
      ],
      [
        2498.716552734375,
        760.0,
        120.0
      ],
      [
        2467.25634765625,
        760.0,
        140.0
      ],
      [
        2467.25634765625,
        760.0,
        140.0
      ],
      [
        2460.0,
        760.0,
        144.61302185058594
      ],
      [
        2528.4833984375,
        760.0,
        84.0
      ],
      [
        2522.416259765625,
        760.0,
        100.0
      ],
      [
        2522.416259765625,
        760.0,
        100.0
      ],
      [
        2498.716552734375,
        760.0,
        120.0
      ],
      [
        2519.95166015625,
        760.0,
        106.50029754638672
      ],
      [
        2522.416259765625,
        970.0000610351562,
        100.0
      ],
      [
        2524.9443359375,
        970.0000610351562,
        93.3333511352539
      ],
      [
        2522.416259765625,
        970.0000610351562,
        100.0
      ],
      [
        2498.716552734375,
        970.0001220703125,
        120.0
      ],
      [
        2519.95166015625,
        970.0000610351562,
        106.50029754638672
      ],
      [
        2445.0,
        760.0,
        114.15620422363281
      ],
      [
        2440.0,
        760.0,
        114.15620422363281
      ],
      [
        2460.78369140625,
        650.0,
        144.11488342285156
      ],
      [
        2490.9609375,
        650.0,
        124.93043518066406
      ],
      [
        2519.95166015625,
        650.0,
        106.50017547607422
      ],
      [
        2490.9609375,
        650.0,
        124.93043518066406
      ],
      [
        2561.63671875,
        680.0,
        80.0
      ],
      [
        2561.63671875,
        685.9020385742188,
        80.0
      ],
      [
        2561.63671875,
        760.0,
        80.0
      ],
      [
        2561.63671875,
        685.9020385742188,
        80.0
      ],
      [
        2540.0,
        650.0,
        80.0
      ],
      [
        2540.0,
        620.0,
        80.0
      ],
      [
        2540.0,
        650.0,
        80.0
      ],
      [
        2530.0,
        650.0,
        80.0
      ],
      [
        2534.087646484375,
        650.0,
        97.51359558105469
      ],
      [
        2534.087646484375,
        620.0,
        97.51359558105469
      ],
      [
        2534.087646484375,
        650.0,
        97.51359558105469
      ],
      [
        2539.0205078125,
        760.0,
        84.0
      ],
      [
        2530.176513671875,
        760.0,
        100.0
      ],
      [
        2534.08740234375,
        760.0,
        97.513671875
      ],
      [
        2530.176513671875,
        760.0,
        100.0
      ],
      [
        2530.176513671875,
        970.0000610351562,
        100.0
      ],
      [
        2534.087646484375,
        970.0000610351562,
        97.51364135742188
      ],
      [
        2535.613525390625,
        970.0000610351562,
        93.3333511352539
      ],
      [
        2530.176513671875,
        970.0000610351562,
        100.0
      ],
      [
        2555.344482421875,
        760.0,
        84.0
      ],
      [
        2540.6630859375,
        970.0000610351562,
        93.3333511352539
      ],
      [
        2560.0,
        760.0,
        84.0
      ],
      [
        2560.0,
        760.0,
        100.0
      ],
      [
        2560.0,
        760.0,
        100.0
      ],
      [
        2560.0,
        760.0,
        120.0
      ],
      [
        2560.0,
        970.0000610351562,
        100.0
      ],
      [
        2560.0,
        970.0000610351562,
        120.0
      ],
      [
        2560.0,
        970.0000610351562,
        100.0
      ],
      [
        2560.0,
        970.0000610351562,
        93.3333511352539
      ],
      [
        2600.0,
        550.0,
        72.0
      ],
      [
        2600.0,
        565.0,
        65.0
      ],
      [
        2600.0,
        550.0,
        72.0
      ],
      [
        2600.0,
        535.0,
        65.0
      ],
      [
        2600.0,
        490.0,
        72.0
      ],
      [
        2600.0,
        505.0,
        65.0
      ],
      [
        2600.0,
        610.0,
        72.0
      ],
      [
        2600.0,
        625.0,
        65.0
      ],
      [
        2600.0,
        610.0,
        72.0
      ],
      [
        2600.0,
        595.0,
        65.0
      ],
      [
        2600.0,
        970.0,
        100.0
      ],
      [
        2600.0,
        970.0000610351562,
        120.0
      ],
      [
        2600.0,
        970.0,
        100.0
      ],
      [
        2600.0,
        970.0,
        93.33334350585938
      ],
      [
        2873.912841796875,
        268.58905029296875,
        79.70962524414062
      ],
      [
        2873.912841796875,
        231.41094970703125,
        79.70962524414062
      ],
      [
        2896.62109375,
        236.70289611816406,
        190.20530700683594
      ],
      [
        2897.953369140625,
        227.18487548828125,
        194.64703369140625
      ],
      [
        2891.553955078125,
        272.89703369140625,
        173.31471252441406
      ],
      [
        2890.003173828125,
        283.9757995605469,
        168.14462280273438
      ],
      [
        2888.173583984375,
        214.92630004882812,
        162.04702758789062
      ],
      [
        2897.751953125,
        214.92611694335938,
        159.17385864257812
      ],
      [
        2860.192138671875,
        231.72377014160156,
        68.77578735351562
      ],
      [
        2869.7705078125,
        231.72366333007812,
        65.90219116210938
      ],
      [
        2897.953369140625,
        227.18487548828125,
        194.64703369140625
      ],
      [
        2900.0,
        227.59274291992188,
        194.45669555664062
      ],
      [
        2891.553955078125,
        272.89703369140625,
        173.31471252441406
      ],
      [
        2900.0,
        272.4433288574219,
        173.5264434814453
      ],
      [
        2873.912841796875,
        231.41094970703125,
        79.70962524414062
      ],
      [
        2863.472412109375,
        234.42724609375,
        79.70962524414062
      ],
      [
        2873.912841796875,
        268.58905029296875,
        79.70962524414062
      ],
      [
        2863.472412109375,
        265.572998046875,
        79.70962524414062
      ],
      [
        2864.222412109375,
        231.8031005859375,
        82.20962524414062
      ],
      [
        2864.222412109375,
        268.1971435546875,
        82.20962524414062
      ],
      [
        2896.62109375,
        236.70289611816406,
        190.20530700683594
      ],
      [
        2900.0,
        237.3763427734375,
        189.8910369873047
      ],
      [
        2790.0,
        770.0,
        90.0
      ],
      [
        2790.0,
        770.0,
        66.66667175292969
      ],
      [
        2680.0,
        720.0,
        80.0
      ],
      [
        2680.0,
        730.0,
        80.0
      ],
      [
        2790.0,
        770.0,
        80.0
      ],
      [
        2840.0,
        720.0,
        80.0
      ],
      [
        2840.0,
        730.0,
        80.0
      ],
      [
        2873.912841796875,
        -31.41094970703125,
        79.70962524414062
      ],
      [
        2873.9130859375,
        -68.58905029296875,
        79.70962524414062
      ],
      [
        2888.173828125,
        -14.92602825164795,
        162.0469207763672
      ],
      [
        2897.752197265625,
        -14.926216125488281,
        159.17312622070312
      ],
      [
        2860.1923828125,
        -31.72350311279297,
        68.77574157714844
      ],
      [
        2869.77099609375,
        -31.723615646362305,
        65.90238952636719
      ],
      [
        2888.17333984375,
        -85.0737075805664,
        162.0469970703125
      ],
      [
        2897.751953125,
        -85.07389831542969,
        159.173828125
      ],
      [
        2860.192138671875,
        -68.27622985839844,
        68.77578735351562
      ],
      [
        2869.7705078125,
        -68.27633666992188,
        65.90218353271484
      ],
      [
        2899.250732421875,
        -68.27620697021484,
        198.9712371826172
      ],
      [
        2900.0,
        -68.2762222290039,
        198.74647521972656
      ],
      [
        2899.2509765625,
        -31.723512649536133,
        198.97119140625
      ],
      [
        2900.0,
        -31.72352409362793,
        198.7464599609375
      ],
      [
        2873.912841796875,
        -68.58905029296875,
        79.70962524414062
      ],
      [
        2863.472412109375,
        -65.57274627685547,
        79.70962524414062
      ],
      [
        2873.912841796875,
        -31.41094970703125,
        79.70962524414062
      ],
      [
        2863.472412109375,
        -34.426979064941406,
        79.70962524414062
      ],
      [
        2864.222412109375,
        -68.19689178466797,
        82.20962524414062
      ],
      [
        2864.222412109375,
        -31.80283546447754,
        82.20962524414062
      ],
      [
        2873.912841796875,
        -331.41094970703125,
        79.70962524414062
      ],
      [
        2873.9130859375,
        -368.58905029296875,
        79.70962524414062
      ],
      [
        2888.173828125,
        -314.9260559082031,
        162.04690551757812
      ],
      [
        2897.752197265625,
        -314.9262390136719,
        159.1731719970703
      ],
      [
        2860.1923828125,
        -331.7235412597656,
        68.7757339477539
      ],
      [
        2869.77099609375,
        -331.7236328125,
        65.90239715576172
      ],
      [
        2899.2509765625,
        -331.7234802246094,
        198.97116088867188
      ],
      [
        2900.0,
        -331.7235107421875,
        198.7464141845703
      ],
      [
        2873.912841796875,
        -331.41094970703125,
        79.70962524414062
      ],
      [
        2863.472412109375,
        -334.427001953125,
        79.70962524414062
      ],
      [
        2873.912841796875,
        -368.58905029296875,
        79.70962524414062
      ],
      [
        2863.472412109375,
        -365.57275390625,
        79.70962524414062
      ],
      [
        2864.222412109375,
        -368.1968994140625,
        82.20962524414062
      ],
      [
        2864.222412109375,
        -331.8028564453125,
        82.20962524414062
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3614.939453125,
        -3588.4169921875,
        1220.0
      ],
      "bbox_max": [
        -3502.183349609375,
        -3559.13720703125,
        1317.599365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6158.31884765625,
        3750.8916015625,
        347.8644714355469
      ],
      "bbox_max": [
        -5532.3203125,
        4687.76513671875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -5573.556640625,
        -2413.83203125,
        -300.0
      ],
      "bbox_max": [
        -3344.00830078125,
        5695.4521484375,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        -22.699951171875
      ],
      "bbox_max": [
        -5158.470703125,
        5234.39599609375,
        -11.83917236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5573.556640625,
        4626.0498046875,
        -22.699951171875
      ],
      "bbox_max": [
        -4478.6357421875,
        5688.64697265625,
        901.1133422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        -22.699951171875
      ],
      "bbox_max": [
        -4478.6357421875,
        5688.64697265625,
        671.7749633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        -3589.257568359375,
        -300.0
      ],
      "bbox_max": [
        -232.08837890625,
        6233.91845703125,
        1181.5667724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 3250.0,
      "bbox_min": [
        3250.0,
        -1142.69775390625,
        169.36959838867188
      ],
      "bbox_max": [
        3250.0,
        -692.3075561523438,
        600.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -4095.87744140625,
        5684.36474609375,
        -22.699951171875
      ],
      "bbox_max": [
        -202.00167846679688,
        7158.4658203125,
        557.4569091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -2778.40673828125,
        6824.703125,
        -22.699951171875
      ],
      "bbox_max": [
        -2708.39404296875,
        6871.484375,
        38.73222732543945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9484592080116272,
        -0.020618677139282227,
        0.3162277638912201
      ],
      "plane_d": 291.7543029785156,
      "bbox_min": [
        -184.0259246826172,
        4939.48486328125,
        -300.0
      ],
      "bbox_max": [
        -99.99644470214844,
        5035.35205078125,
        -42.34581756591797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        816.3771362304688,
        4948.55029296875,
        -13.543876647949219
      ],
      "bbox_max": [
        3970.173828125,
        7327.39501953125,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3045.157470703125,
        4948.55029296875,
        -13.543876647949219
      ],
      "bbox_max": [
        3970.173828125,
        5034.5224609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        -5704.54443359375,
        -692.3076171875,
        -300.0
      ],
      "bbox_max": [
        3250.0,
        7450.0,
        1209.9666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14300541579723358,
        0.1037236675620079,
        0.984271764755249
      ],
      "plane_d": -505.24676513671875,
      "bbox_min": [
        -5704.54443359375,
        -362.51678466796875,
        901.1133422851562
      ],
      "bbox_max": [
        -4245.8544921875,
        4626.0498046875,
        1209.9666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1451.4854736328125,
      "bbox_min": [
        -1850.0,
        557.9999389648438,
        -300.0
      ],
      "bbox_max": [
        2665.0,
        2670.0,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9361191391944885,
        0.15388573706150055,
        0.31622791290283203
      ],
      "plane_d": 1314.5240478515625,
      "bbox_min": [
        -1548.7220458984375,
        670.0,
        -55.32252502441406
      ],
      "bbox_max": [
        -1498.0869140625,
        750.1992797851562,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        6.877201030874858e-07
      ],
      "plane_d": -2664.999755859375,
      "bbox_min": [
        2590.0,
        557.9999389648438,
        -300.0
      ],
      "bbox_max": [
        2665.0,
        620.0,
        -114.00001525878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        2590.0,
        560.0,
        -300.0
      ],
      "bbox_max": [
        2665.0,
        560.0,
        -293.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8825817704200745,
        0.14508481323719025,
        0.4472133219242096
      ],
      "plane_d": 1239.3453369140625,
      "bbox_min": [
        -1542.235595703125,
        658.0,
        -7.62939453125e-06
      ],
      "bbox_max": [
        2589.999755859375,
        670.0,
        55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        1959.176513671875,
        500.0,
        -300.0
      ],
      "bbox_max": [
        3180.0,
        669.0,
        55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        6.877201030874858e-07
      ],
      "plane_d": -2664.999755859375,
      "bbox_min": [
        1959.176513671875,
        500.0,
        -300.0
      ],
      "bbox_max": [
        2665.0,
        560.0,
        35.99991989135742
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        6.877201030874858e-07
      ],
      "plane_d": -2589.999755859375,
      "bbox_min": [
        1959.176513671875,
        500.0,
        -300.0
      ],
      "bbox_max": [
        2665.0,
        560.0,
        35.99991989135742
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        6.975446353862935e-07
      ],
      "plane_d": -2419.999755859375,
      "bbox_min": [
        1959.176513671875,
        500.0,
        -300.0
      ],
      "bbox_max": [
        2420.0,
        560.0,
        35.99991989135742
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2150.0,
      "bbox_min": [
        1959.176513671875,
        528.0,
        -60.0
      ],
      "bbox_max": [
        2150.0,
        560.0,
        35.99991989135742
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7044675350189209,
        -0.6821027994155884,
        0.19611512124538422
      ],
      "plane_d": -1006.3839111328125,
      "bbox_min": [
        1959.176513671875,
        548.0,
        0.0
      ],
      "bbox_max": [
        1970.7955322265625,
        560.0,
        35.99991989135742
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        2590.0,
        500.0,
        -300.0
      ],
      "bbox_max": [
        2665.0,
        500.0,
        -143.99996948242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24782390892505646,
        -0.9499915838241577,
        0.1899983137845993
      ],
      "plane_d": 1356.175048828125,
      "bbox_min": [
        2589.999755859375,
        598.0,
        -173.9999237060547
      ],
      "bbox_max": [
        3180.0,
        669.0,
        55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        2589.999755859375,
        620.0,
        -114.00003051757812
      ],
      "bbox_max": [
        2664.999755859375,
        620.0,
        55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2150.0,
      "bbox_min": [
        2150.0,
        650.0,
        55.0
      ],
      "bbox_max": [
        2150.0,
        670.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7044675350189209,
        -0.6821027994155884,
        0.19611512124538422
      ],
      "plane_d": -1006.3839111328125,
      "bbox_min": [
        1954.515869140625,
        547.9999389648438,
        -0.000232696533203125
      ],
      "bbox_max": [
        2664.999755859375,
        560.0,
        55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7044675350189209,
        -0.6821027994155884,
        0.19611512124538422
      ],
      "plane_d": -1006.3839111328125,
      "bbox_min": [
        1954.0921630859375,
        559.0,
        55.0
      ],
      "bbox_max": [
        2150.0,
        560.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7044675350189209,
        -0.6821027994155884,
        0.19611512124538422
      ],
      "plane_d": -1006.3839111328125,
      "bbox_min": [
        1955.484130859375,
        560.0,
        35.99987030029297
      ],
      "bbox_max": [
        2589.999755859375,
        566.3333740234375,
        55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -2530.0,
      "bbox_min": [
        2150.0,
        560.0,
        55.0
      ],
      "bbox_max": [
        2532.0,
        568.0000610351562,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -565.0,
      "bbox_min": [
        2530.0,
        565.0,
        55.0
      ],
      "bbox_max": [
        2532.0,
        565.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        1763.3565673828125,
        396.0545654296875,
        -144.0
      ],
      "bbox_max": [
        2665.0,
        560.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2400.0,
      "bbox_min": [
        2400.0,
        455.84075927734375,
        55.0
      ],
      "bbox_max": [
        2530.0,
        500.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        6.975446353862935e-07
      ],
      "plane_d": -2419.999755859375,
      "bbox_min": [
        1763.3565673828125,
        500.0,
        -144.0
      ],
      "bbox_max": [
        2590.0,
        560.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -55.0,
      "bbox_min": [
        2400.0,
        500.0,
        55.0
      ],
      "bbox_max": [
        2419.999755859375,
        559.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2400.0,
      "bbox_min": [
        2400.0,
        500.0,
        55.0
      ],
      "bbox_max": [
        2400.0,
        540.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2530.0,
      "bbox_min": [
        2520.0,
        500.0,
        55.0
      ],
      "bbox_max": [
        2532.0,
        540.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -540.0,
      "bbox_min": [
        2520.0,
        540.0,
        55.0
      ],
      "bbox_max": [
        2530.0,
        540.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -2532.0,
      "bbox_min": [
        2530.0,
        535.0,
        55.0
      ],
      "bbox_max": [
        2532.0,
        540.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -540.0,
      "bbox_min": [
        2530.0,
        540.0,
        55.0
      ],
      "bbox_max": [
        2532.0,
        540.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -55.0,
      "bbox_min": [
        2590.0,
        540.0,
        -24.0
      ],
      "bbox_max": [
        2665.0,
        559.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 771.0,
      "bbox_min": [
        1910.0,
        771.0,
        140.0
      ],
      "bbox_max": [
        1928.0,
        830.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.215046688914299,
        -0.7745373845100403,
        0.5948501825332642
      ],
      "plane_d": -451.61907958984375,
      "bbox_min": [
        1900.9378662109375,
        -9.215412139892578,
        60.0
      ],
      "bbox_max": [
        1930.040771484375,
        37.26525115966797,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2395.0,
      "bbox_min": [
        2395.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        2395.0,
        730.0,
        60.999996185302734
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2395.0,
      "bbox_min": [
        2395.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        2395.0,
        730.0,
        61.333335876464844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2400.0,
      "bbox_min": [
        2400.0,
        450.0,
        60.0
      ],
      "bbox_max": [
        2530.0,
        540.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -2532.0,
      "bbox_min": [
        2530.0,
        535.0,
        60.0
      ],
      "bbox_max": [
        2532.0,
        540.0,
        73.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -2145.58056640625,
      "bbox_min": [
        2530.0,
        535.0,
        70.0
      ],
      "bbox_max": [
        2532.0,
        540.0,
        73.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -565.0,
      "bbox_min": [
        2530.0,
        560.0,
        60.0
      ],
      "bbox_max": [
        2532.0,
        565.0,
        73.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2532.0,
      "bbox_min": [
        2530.0,
        560.0,
        60.0
      ],
      "bbox_max": [
        2532.0,
        565.0,
        73.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -2145.58056640625,
      "bbox_min": [
        2530.0,
        560.0,
        70.0
      ],
      "bbox_max": [
        2532.0,
        565.0,
        73.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        0.49999895691871643,
        -0.0
      ],
      "plane_d": -2292.610595703125,
      "bbox_min": [
        2264.5,
        650.0,
        60.0
      ],
      "bbox_max": [
        2272.0,
        654.3301391601562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -654.3301391601562,
      "bbox_min": [
        2264.5,
        654.3301391601562,
        60.0
      ],
      "bbox_max": [
        2269.5,
        654.3301391601562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2315.0,
      "bbox_min": [
        2315.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        2395.0,
        730.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -654.3301391601562,
      "bbox_min": [
        2292.5,
        654.3301391601562,
        60.0
      ],
      "bbox_max": [
        2297.5,
        654.3301391601562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -2470.0,
      "bbox_min": [
        2442.5,
        650.0,
        60.0
      ],
      "bbox_max": [
        2478.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        0.49999895691871643,
        -0.0
      ],
      "plane_d": -2446.762939453125,
      "bbox_min": [
        2442.5,
        650.0,
        60.0
      ],
      "bbox_max": [
        2450.0,
        654.3301391601562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -654.3301391601562,
      "bbox_min": [
        2442.5,
        654.3301391601562,
        60.0
      ],
      "bbox_max": [
        2447.5,
        654.3301391601562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        0.49999895691871643,
        0.0
      ],
      "plane_d": -2471.01171875,
      "bbox_min": [
        2470.5,
        650.0,
        60.0
      ],
      "bbox_max": [
        2478.0,
        654.3301391601562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -654.3301391601562,
      "bbox_min": [
        2470.5,
        654.3301391601562,
        60.0
      ],
      "bbox_max": [
        2475.5,
        654.3301391601562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5622575283050537,
        -0.0,
        0.8269622325897217
      ],
      "plane_d": -1413.048828125,
      "bbox_min": [
        2317.67626953125,
        620.0,
        81.3165283203125
      ],
      "bbox_max": [
        2360.0,
        650.0,
        132.91766357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        0.49999895691871643,
        -0.0
      ],
      "plane_d": -2292.610595703125,
      "bbox_min": [
        2264.5,
        650.0,
        80.0
      ],
      "bbox_max": [
        2300.0,
        654.3301391601562,
        107.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -654.3301391601562,
      "bbox_min": [
        2264.5,
        650.0,
        80.0
      ],
      "bbox_max": [
        2272.0,
        654.3301391601562,
        107.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7500003576278687,
        0.4330117404460907,
        0.5000002980232239
      ],
      "plane_d": -2035.45849609375,
      "bbox_min": [
        2267.0,
        650.0,
        100.0
      ],
      "bbox_max": [
        2272.0,
        654.3301391601562,
        107.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -654.3301391601562,
      "bbox_min": [
        2292.5,
        650.0,
        80.0
      ],
      "bbox_max": [
        2300.0,
        654.3301391601562,
        107.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7500004172325134,
        0.4330117106437683,
        0.5000002980232239
      ],
      "plane_d": -2056.458740234375,
      "bbox_min": [
        2295.0,
        650.0,
        100.0
      ],
      "bbox_max": [
        2300.0,
        654.3301391601562,
        107.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        0.49999895691871643,
        -0.0
      ],
      "plane_d": -2446.762939453125,
      "bbox_min": [
        2442.5,
        650.0,
        80.0
      ],
      "bbox_max": [
        2478.0,
        654.3301391601562,
        107.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -654.3301391601562,
      "bbox_min": [
        2442.5,
        650.0,
        80.0
      ],
      "bbox_max": [
        2450.0,
        654.3301391601562,
        107.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7500003576278687,
        0.4330117404460907,
        0.5000002980232239
      ],
      "plane_d": -2168.95849609375,
      "bbox_min": [
        2445.0,
        650.0,
        100.0
      ],
      "bbox_max": [
        2450.0,
        654.3301391601562,
        107.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        0.49999895691871643,
        0.0
      ],
      "plane_d": -2471.01171875,
      "bbox_min": [
        2470.5,
        650.0,
        80.0
      ],
      "bbox_max": [
        2478.0,
        654.3301391601562,
        107.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -654.3301391601562,
      "bbox_min": [
        2470.5,
        650.0,
        80.0
      ],
      "bbox_max": [
        2478.0,
        654.3301391601562,
        107.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7500004172325134,
        0.4330117106437683,
        0.5000002980232239
      ],
      "plane_d": -2189.95849609375,
      "bbox_min": [
        2473.0,
        650.0,
        100.0
      ],
      "bbox_max": [
        2478.0,
        654.3301391601562,
        107.5
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}